const langObj = {
    'format': 'Formát',
    'addRemoveProductDialog.addProductIfExists': 'Přidat produkt i do objednávek, kde již existuje',
    'addRemoveProductDialog.addProducts': 'Přidat produkty (promo) do objednávek',
    'addRemoveProductDialog.removeProducts': 'Odebrat produkty (promo) z objednávek',
    'addRemoveProductDialog.removeOrders.info': 'Po uložení dojde k odebrání zadaných produktů z označených objednávek. Pokud označená objednávka zadaný produkt neobsahuje, nebude pro objednávku provedena žádná akce.',
    'apiErrors.PRODUCT_SET_CONTAINS_PRODUCTS': 'SKU: {{sku}} nelze změnit typ produktu, protože je aktuálně definováno jako sada produktů. Vytvořte nové SKU, nebo kontaktujte customercare@skladon.cz',
    'apiErrors.PRODUCT_SET_USED_IN_ORDERS': 'Produktový set již byl použit v objednávkách a nelze změnit jeho typ ze Sada produktů! Musíte vytvořit nový produkt!',
    'apiErrors.serverErrorTitle': 'Chyba při volání API',
    'login.loginTitle': 'Přihlášení',
    'login.yourEmail': 'Váš e-mail',
    'login.password': 'Heslo',
    'login.forgetPassword': 'Zapomněli jste heslo? Klikněte ',
    'login.forgetPasswordClick': 'zde',
    'login.logIn': 'Přihlásit se',
    'login.langTooltip': 'Vyberte jazyk',
    'language': 'Jazyk',
    'login.wrongLoginPassword': 'Chybně zadané heslo nebo uživatelské jméno',
    'login.sessionExpired': 'Vaše přihlášení vypršelo. Přihlaste se znovu.',
    'login.logInHere': 'Přihlašte se ',
    'login.logInHereClick': 'zde',
    'login.passwordReset': 'Obnovení hesla',
    'login.passwordReset.email': 'Váš e-mail',
    'login.resetPassword': 'Odeslat e-mail',
    'login.resetPasswordSuccess': 'Byl Vám odeslán email s informacemi o změně hesla',
    'login.resetPasswordError': 'Uživatel se zadaným emailem nebyl nalezen',
    'login.email': 'Email',
    'integration.statusesMappingTable.uid': 'E-shop UID',
    'integration.statusesMappingTable.name': 'E-shop stav obj.',
    'integration.statusesMappingTable.value': 'MySkladon stav obj.',
    'integration.statusesMappingTable.import': 'Import = E-shop -> MyS',
    'integration.statusesMappingTable.export': 'Export = MyS -> E-shop',
    'integration.statusesMappingTable.saved': 'Uloženo',
    'integration.shippingMethodsTable.uid': 'E-shop UID',
    'integration.shippingMethodsTable.name': 'E-shop doprava',
    'integration.shippingMethodsTable.shipper': 'MySkladon dopravce',
    'integration.shippingMethodsTable.shipperServiceCode': 'MySkladon služba dopravce',
    'integration.shippingMethodsTable.branchId': 'ID pobočky (B2Bc)',
    'integration.shippingMethodsTable.import': 'Import = E-shop -> MyS',
    'integration.shippingMethodsTable.export': 'Export = MyS -> E-shop',
    'integration.shippingMethodsTable.saved': 'Uloženo',
    'integration.paymentMethodsTable.uid': 'E-shop UID',
    'integration.paymentMethodsTable.name': 'E-shop platba',
    'integration.paymentMethodsTable.paymentMethod': 'MySkladon platbní metoda',
    'integration.paymentMethodsTable.paid': 'MySkladon zaplaceno',
    'integration.paymentMethodsTable.import': 'Import = E-shop -> MyS',
    'integration.paymentMethodsTable.saved': 'Uloženo',
    'integration.mappingTable.saved.yes': 'Ano',
    'integration.mappingTable.saved.notSaved': 'Neuloženo',
    'integrationDetail.statuses': 'Mapování stavů obj.',
    'integrationDetail.shippingMethods': 'Mapování dopravy',
    'integrationDetail.paymentMethods': 'Mapování plateb',
    'integrationDetail.others': 'Ostatní',
    'integrationDetail.productType': 'Nastavení měny a expediční metody pro nově vytvořené produkty',
    'integrationDetail.productTypeDescription': 'Nastavení měny a expediční metody pro nově vytvořené produkty',
    'integrationDetail.productTypeLabel': 'Vyberte hodnotu',
    'integrationDetail.orderType': 'B2B objednávky',
    'integrationDetail.orderTypeDescription': 'Nastavení IČO pro B2B objednávky ze Shoptetu',
    'integrationDetail.addOrderType': 'Přidat IČO pro B2B objednávky',
    'integrationDetail.retino': 'Retino',
    'integrationDetail.retinoDescription': 'Nastavení mapování pro Retino',
    'integrationDetail.addRetinoMapping': 'Přidat Retino mapování',
    'integrationDetail.historyTab': 'Historie',
    'integrationDetail.historySectionAll': 'Všechny sekce',
    'integrationDetail.historySectionFilter': 'Sekce',
    'integrationDetail.historyEmpty': 'Zatím nejsou žádné záznamy historie.',
    'integrationDetail.saveSuccess': 'Mapování bylo uloženo',

    'integrationMappingHistory.entry': 'Uložení mapování integrace',

    'integrationMappingHistory.newOrderStatuses': 'Nové stavy objednávek',
    'integrationMappingHistory.orderStatusesEdited': 'Stavy objednávek upraveny',
    'integrationMappingHistory.newShippingMethods': 'Nové dopravy',
    'integrationMappingHistory.shippingMethodsEdited': 'Dopravy upraveny',
    'integrationMappingHistory.newPaymentMethods': 'Nové platby',
    'integrationMappingHistory.paymentMethodsEdited': 'Platby upraveny',
    'integrationMappingHistory.newB2bOrders': 'Nové B2B objednávky',
    'integrationMappingHistory.b2bOrdersEdited': 'B2B objednávky upraveny',
    'integrationMappingHistory.b2bOrdersDeleted': 'B2B objednávky smazány',
    'integrationMappingHistory.currencyExpeditionSet': 'Měna a expediční metoda nastavena',
    'integrationMappingHistory.currencyExpeditionEdited': 'Měna a expediční metoda upravena',
    'integrationMappingHistory.othersDeleted': 'Smazáno',
    'integrationMappingHistory.newRetinoMappings': 'Nové Retino mapování',
    'integrationMappingHistory.retinoMappingsEdited': 'Retino mapování upraveno',

    'integrationMappingHistory.columns.eshopUid': 'E-shop UID',
    'integrationMappingHistory.columns.eshopName': 'E-shop název',
    'integrationMappingHistory.columns.mysStatus': 'MySkladon stav',
    'integrationMappingHistory.columns.import': 'Import',
    'integrationMappingHistory.columns.export': 'Export',
    'integrationMappingHistory.columns.shipper': 'Dopravce',
    'integrationMappingHistory.columns.serviceCode': 'Služba',
    'integrationMappingHistory.columns.branchId': 'ID pobočky (B2Bc)',
    'integrationMappingHistory.columns.paymentMethod': 'Platební metoda',
    'integrationMappingHistory.columns.paid': 'Zaplaceno',
    'integrationMappingHistory.columns.uid': 'UID / IČO',
    'integrationMappingHistory.columns.name': 'Název',
    'integrationMappingHistory.columns.value': 'Hodnota',
    'integrationMappingHistory.columns.summary': 'Shrnutí',
    'integrationMappingHistory.columns.key': 'Klíč',
    'integration.othersTable.key': 'Klíč',
    'integration.othersTable.uid': 'IČO',
    'integration.othersTable.name': 'Typ objednávky',
    'integration.othersTable.import': 'Import = E-shop -> MyS',
    'integration.othersTable.export': 'Export = MyS -> E-shop',
    'integration.othersTable.actions': 'Akce',
    'integration.othersTable.value': 'Hodnota',
    'integration.retinoTable.key': 'Klíč',
    'integration.retinoTable.uid': 'UID',
    'integration.retinoTable.value': 'Hodnota',
    'integration.retinoTable.name': 'Název',
    'integration.retinoTable.import': 'Import = E-shop -> MyS',
    'integration.retinoTable.export': 'Export = MyS -> E-shop',
    'integration.retinoTable.actions': 'Akce',
    'integration.action.mappingDetail': 'Mapování detail',
    'resetPassword.title': 'Změna hesla',
    'resetPassword.newPassword': 'Nové heslo',
    'resetPassword.comparePassword': 'Kontrola zadaného hesla',
    'resetPassword.sumbit': 'Uložit heslo',
    'resetPassword.login': 'Přihlásit se',
    'resetPassword.successx': 'Heslo bylo změněno, nyní se můžete přihlásit zde:',
    'resetPassword.success': 'Heslo bylo změněno, nyní se můžete přihlásit',
    'resetPassword.wrongData': 'Vaše relace vypršela',
    'resetPassword.incorretPasswordText':
        'Nové heslo musí mít více než 7 znaků a musí obsahovat malé a velké písmena a číslo',
    'resetPassword.incorretPasswordMatchText': 'Hesla se neshodují',

    'sidebar.overview': 'Přehled',
    'sidebar.tasks': 'Seznam úkolů',
    'sidebar.orders': 'Objednávky',
    'sidebar.claims': 'Reklamace',
    'sidebar.returns': 'Vratky',
    'sidebar.receivings': 'Příjem zboží',
    'sidebar.transports': 'Přeprava',
    'sidebar.products': 'Inventář',
    'sidebar.productTrash': 'Chyby produktů / EANů',
    'productTrash.title': 'Chyby pro synchronizaci produktů a EANů',
    'productTrash.noPermission': 'Nemáte oprávnění zobrazit tento seznam.',
    'productTrash.loadError': 'Nepodařilo se načíst záznamy.',
    'productTrash.resolveError': 'Nepodařilo se změnit stav vyřešení záznamu.',
    'productTrash.resolve': 'Vyřešit',
    'productTrash.column.createdAt': 'Datum',
    'productTrash.column.eventType': 'Typ události',
    'productTrash.column.source': 'Zdroj',
    'productTrash.column.sku': 'SKU',
    'productTrash.column.ean': 'EAN',
    'productTrash.column.message': 'Zpráva',
    'productTrash.column.resolved': 'Vyřešeno',
    'productTrash.source.DCIX_SYNC': 'WMS sync',
    'productTrash.source.UI': 'MyS UI',
    'productTrash.source.PIPES': 'PIPES',
    'productTrash.source.GWMS': 'GWMS',
    'productTrash.eventType.EAN_ALREADY_EXISTS': 'EAN již použit pro jiný produkt',
    'productTrash.eventType.SKU_CHANGE_REJECTED': 'Změna SKU nepovolena',
    'productTrash.eventType.EAN_CONFLICT_DCIX_SYNC': 'Konflikt EANu pro WMS sync',
    'productTrash.eventType.DUPLICATE_SKU_REJECTED': 'Vytvoření duplicitního SKU nepovoleno',
    'productTrash.eventType.EAN_WRITE_BLOCKED_BY_DCIX_LOCK': 'Zápis EANu zablokován zámkem WMS',
    'productTrash.eventType.PER_ESHOP_PROPAGATION_SKIPPED': 'Per-eshop pole nepropagována (identifikátor vypnutý)',
    'sidebar.documents': 'Dokumenty',
    'sidebar.commands': 'Příkazy',
    'sidebar.users': 'Správa uživatelů',
    'sidebar.settings': 'Nastavení',
    'sidebar.admin': 'Admin',
    'sidebar.integration': 'Integrace',

    'overview.title': 'Přehled',
    'overview.ordersInStatuses.title': 'Aktuální počet objednávek dle stavů',
    'overview.ordersInStatuses.titleInfo': 'Počet objednávek dle jednotlivých stavů, ve kterých se aktuálně nacházejí.',
    'overview.ordersInStatuses.titleDelivered': 'Doručené objednávky',
    'overview.ordersInStatuses.titleDeliveredInfo': 'Počet doručených objednávek za zvolené časové období',
    'overview.ordersInStatuses': 'Posledních 24 hodin',
    'overview.ordersTimeOption.last24Hours': '24 hodin',
    'overview.ordersTimeOption.last7Days': '7 dní',
    'overview.ordersTimeOption.last30Days': '30 dní',
    'overview.ordersTimeOption.last90Days': '90 dní',
    'overview.today': 'Dnes',
    'overview.totalNotifications': '{{count}} notifikací',
    'overview.totalTasks': '{{count}} úkolů',
    'overview.ordersAttention': 'Objednávky vyžadující vaši pozornost',
    'overview.ordersReason.productsNotAvailable': 'Nedostupné produkty',
    'overview.ordersReason.incorrect': 'Chyba',
    'overview.tasks': 'Seznam úkolů',
    'overview.timeRange': 'Časový rozsah',
    'overview.type': 'Typ',
    'overview.timePreview': 'Přehled',
    'overview.timeOption.actualMonth': 'Aktuální měsíc',
    'overview.timeOption.lastMonth': 'Minulý měsíc',
    'overview.timeOption.last30Days': 'Posledních 30 dnů',
    'overview.timeOption.last90Days': 'Posledních 90 dnů',
    'overview.timeOption.actualQuarter': 'Aktuální čtvrtletí',
    'overview.timeOption.lastQuarter': 'Minulý čtvrtletí',
    'overview.timeOption.actualYear': 'Aktuální rok',
    'overview.timeOption.lastYear': 'Minulý rok',
    'overview.timeOption.custom': 'Vlastní',
    'overview.orders': 'Objednávky',
    'overview.returns': 'Vratky',
    'overview.receivings': 'Příjem zboží',
    'overview.claims': 'Reklamace',
    'productsSelect.label': 'SKU | Název | EAN',
    'userProfil.title': 'Profil',

    'orders.title': 'Objednávky',
    'orders.allOrders': 'Všechny objednávky',
    'orders.b2cOordes': 'B2C Objednávky',
    'orders.b2bOordes': 'B2B Objednávky',
    'orders.transferOrders': 'Přesuny zboží',
    'orders.codOrders': 'Dobírky',
    'orders.expeditionPackages': 'Expediční balíky',
    'orders.messagesOnExpeditionBox': 'Zprávy na krabici',
    'orders.allProviders': 'Všechny e-shopy',

    'orders.action.createNew': 'Nová',
    'orders.action.pickCancelReason': 'Prosím vyberte důvod zrušení:',
    'orders.action.orderDetail': 'Detail objednávky',
    'orders.action.createReturn': 'Vytvořit vratku',
    'orders.action.importOrders': 'Import objednávek',
    'orders.action.createClaim': 'Vytvořit reklamaci',
    'orders.action.exportFile': 'Export objednávek',
    'orders.action.exportFileCOD': 'Export objednávek s dobírku',
    'orders.action.exportWithProducts': 'Export objednávek s produkty',
    'orders.action.exportWithProductsFileName': 'Export objednávek s produkty',
    'orders.action.exportWithSummarizedProductsFileName': 'Export objednávek se součtem produktů',
    'orders.action.exportFileName': 'Export objednávek',
    'orders.action.exportFileNameCOD': 'Export objednávek na dobírku',
    'orders.action.reorderShipping': 'Přeobjednat dopravu',
    'orders.action.reorderShippingText': 'Opravdu chcete přeobjednat dopravu {{count}} objednávkám?',
    'orders.action.dowlonadCn22': 'Stáhnout soubory CN22',
    'orders.action.synchronizeDcix': 'Synchronizovat objednávky do DCIx',
    'orders.action.synchronizeDcixText': 'Opravdu chcete synchronizovat {{count}} objednávek?',
    'orders.action.synchronizeTable': 'Synchronizovat tabulku',
    'orders.action.changeStatuses': 'Změnit stav objednávek',
    'orders.action.changeStatusesText': 'Opravdu chcete změnit stav {{count}} označeným objednávkám na:',
    'orders.action.allowExpeditions': 'Změnit povolení k odeslání',
    'orders.action.allowExpeditionsText': 'Opravdu chcete změnit povolení k odeslání {{count}} označeným objednávkám na:',
    'orders.action.printFiles': 'Povolit hromadný tisk',
    'orders.action.printFilesText': 'Opravdu chcete změnit soubor tisku {{count}} objednávek na:',
    'orders.action.addRemoveProducts' : 'Editace produktů v objednávce',
    'orders.action.addRemoveProductsText' : 'Opravdu chcete editovat produkty (promo) {{count}} označeným objednávkám na:',
    'orders.table.providerName': 'E-shop',
    'orders.table.orderId': 'ID obj.',
    'orders.table.eshopId': 'E-shop ID obj.',
    'orders.table.recipientName': 'Jméno příjemce',
    'orders.table.invoiceNumber': 'Číslo faktury',
    'orders.table.date': 'Datum vytvoření',
    'orders.table.trackingNumber': 'Sledovací číslo',
    'orders.table.returnTrackingNumber': 'Vratkové sledovací číslo',
    'orders.table.exchangeTrackingNumber': 'TN výměnné zásilky',
    'orders.table.shipper': 'Dopravce',
    'orders.table.status': 'Stav',
    'orders.table.allowExpedition': 'Povolit odeslání',
    'orders.table.actions': 'Akce',
    'orders.table.partnerOrderId': 'ID obj. partnera',
    'orders.table.recipientAttentionName': 'Příjemce kontaktní osoba',
    'orders.table.recipientEmail': 'Příjemce e-mail',
    'orders.table.recipientPhone': 'Příjemce telefon',
    'orders.table.recipientCompanyName': 'Příjemce název společnosti',
    'orders.table.recipientCompanyId': 'Příjemce ID společnosti',
    'orders.table.recipientTaxId': 'Příjemce DIČ',
    'orders.table.recipientStreet': 'Příjemce ulice',
    'orders.table.recipientAddressAdditionalInfo': 'Příjemce dodatečné informace o adrese',
    'orders.table.recipientAdditionalInformationForAddress2': 'Příjemce dodatečné informace o adrese 2',
    'orders.table.recipientCity': 'Příjemce město',
    'orders.table.recipientState': 'Příjemce stát',
    'orders.table.recipientProvinceCode': 'Příjemce provinční kód',
    'orders.table.recipientPostCode': 'Příjemce směrovací číslo',
    'orders.table.billingName': 'Fakturace jméno',
    'orders.table.billingAttentionName': 'Fakturace kontaktní osoba',
    'orders.table.billingEmail': 'Fakturace e-mail',
    'orders.table.billingPhone': 'Fakturace telefon',
    'orders.table.billingCompanyName': 'Fakturace název společnosti',
    'orders.table.billingCompanyId': 'Fakturace ID společnosti',
    'orders.table.billingTaxId': 'Fakturace DIČ',
    'orders.table.billingStreet': 'Fakturace ulice',
    'orders.table.billingAddressAdditionalInfo': 'Fakturace dodatečné informace o adrese',
    'orders.table.billingAdditionalInformationForAddress2': 'Fakturace dodatečné informace o adrese 2',
    'orders.table.billingCity': 'Fakturace město',
    'orders.table.billingState': 'Fakturace stát',
    'orders.table.billingProvinceCode': 'Fakturace provinční kód',
    'orders.table.billingPostCode': 'Fakturace směrovací číslo',
    'orders.table.weight': 'Hmotnost/kg',
    'orders.table.price': 'Cena',
    'orders.table.shippingPrice': 'Cena dopravy',
    'orders.table.currency': 'Měna',
    'orders.table.shippingCurrency': 'Měna dopravy',
    'orders.table.paid': 'Zaplaceno',
    'orders.table.method': 'Method',
    'orders.table.shipperServiceCode': 'Kód služby dopravce',
    'orders.table.boxId': 'Box ID',
    'orders.table.branchId': 'ID pobočky (B2Bc)',
    'orders.table.codPrice': 'Cena za dobírku',
    'orders.table.codCurrency': 'Měna dobírky',
    'orders.table.codRefNumber': 'VS dobírky',
    'orders.table.message': 'Poznámka pro kurýra',
    'orders.table.shippedAt': 'Odesláno v',
    'orders.table.atPickupPointAt': 'Na výdejním místě v',
    'orders.table.inProcessAt': 'V procesu v',
    'orders.table.addressId': 'ID výdej. místa',
    'orders.table.scannedAt': 'Oskenováno v',
    'orders.table.deliveredAt': 'Doručeno v',
    'orders.table.returningBackAt': 'Vrací se v',
    'orders.table.returnedBackAt': 'Vráceno v',
    'orders.table.canceledAt': 'Zrušeno v',

    'orders.table.packedAt': 'Zabalena v',
    'orders.table.waitingForCarrierAt': 'Čeká na dopravce v',
    'orders.table.invoiceDate': 'Datum fakturace',
    'orders.table.incorrectOrderMessage': 'Chybová zpráva',
    'orders.table.transportPaidBySkladon': 'Doprava placená Skladonem',
    'orders.table.holdByQuality': 'Vychystat z kvality',
    'orders.table.pickFromCustomsWarehouse': 'Vychystat z celního skladu',
    'orders.table.underSanction': 'Pod sankcí',
    'orders.table.orderBoxCount': 'Počet krabic',
    'orders.table.paymentMethod': 'Způsob platby',
    'orders.table.sourceSys': 'Zdrojový systém',
    'orders.table.note': 'Poznámka',
    'orders.table.eshopNote': 'E-shop poznámka',
    'orders.table.printFiles': 'Tisknout dokumenty',
    'orders.table.lastStatusCheckAt': 'Poslední kontrola stavu v',
    'orders.table.updatedAt': 'Poslední aktualizace v',
    'orders.table.releaseFromSuspendedAt': 'Uvolnění z pozastaveno v',
    'orders.table.preorderReleaseAt': 'Uvolnit ke zpracování v',
    'orders.table.marketplace': 'Marketplace',
    'orders.table.waitingForShipmentAt': 'Objednává se doprava v',
    'orders.table.shipmentOrderAt': 'Objednání dopravy v',
    'orders.table.orderType': 'Typ obj.',
    'orders.table.incorrectMessage': 'Chybová zpráva',
    'orders.table.slaDate': 'SLA datum',
    'orders.table.returnLabel': 'Vratkový štítek',
    'orders.table.recipientGln': 'Příjemce GLN',
    'orders.table.billingGln': 'Fakturace GLN',
    'orders.table.productSKU': 'Produkt SKU',
    'orders.table.productPrice': 'Produkt cena',
    'orders.table.productLOT': 'Produkt LOT',
    'orders.table.productCurrency': 'Produkt měna',
    'orders.table.productCount': 'Požadováno ks',
    'orders.table.productConfirmed': 'Potvrzeno ks',
    'orders.table.productMissingCount': 'Chybějící ks',
    'orders.table.productSerialNumber': 'Sériová čísla',
    'orders.table.productName': 'Název produktu',
    'orders.table.productEAN': 'EAN',
    'orders.table.overviewReason': 'Důvod',
    'orders.table.waitingDays': 'Čeká dní',
    'orders.table.requiredExpeditionDate': 'Požadované datum exp.',
    'orders.table.disableShippingReorder': 'Externí TN (Marketplace) - neobjednávat dopravu',
    'orders.table.parentOrderId': 'ID nadřazené obj.',
    'orders.table.parentEshopId': 'ID nadřazené e-shop obj.',

    'orders.message.orderCreated': 'Objednávka byla vytvořena',
    'orders.message.orderUpdate': 'Objednávka byla uložena',
    'orders.message.productsAddedToOrders': 'Produkty přidány do vybraných objednávek',
    'orders.message.productsRemovedFromOrders': 'Produkty odebrány z vybraných objednávek',
    'orders.message.orderPrint': 'Požadavek na tisk objednávky byl odeslán',
    'orders.message.orderIvoiceCreated': 'Faktura za objednávku byla vytvořena',
    'orders.message.orderImported': 'Objednávky byly importovány',
    'orders.message.synchronizeSuccessfull': 'Synchronizace byla úspěšná',
    'orders.message.requiredExpeditionDateRecalculated': 'Hodnota požadovaného datumu expedice byla automaticky posunuta na nejdřívejší možné datum expedice dle SLA.',

    'orderDetail.title': 'Detail {{orderType}} objednávky #{{idOrder}}',
    'orderDetail.titleNew': 'Vytvořit novou objednávku',
    'orderDetail.action.create': 'Vytvořit objednávku',
    'orderDetail.action.save': 'Uložit',
    'orderDetail.action.createReturn': 'Vytvořit vratku',
    'orderDetail.action.createClaim': 'Vytvořit reklamaci',
    'orderDetail.action.cloneOrder': 'Klonovat objednávku',
    'orderDetail.action.splitOrder': 'Rozdělit objednávku',
    'orderDetail.action.printOrder': 'Tisknout objednávku',
    'orderDetail.action.reorderShipping': 'Přeobjednat dopravu',
    'orderDetail.action.createInvoice': 'Vytvořit fakturu',
    'orderDetail.action.dowloadRecipientInfo': 'Stáhněte si informace o příjemci s TN',
    'orderDetail.action.nextStep': 'Další krok',
    'orderDetail.action.prevStep': 'Zpět',
    'orderDetail.action.claimDetail': 'Detail reklamace',
    'orderDetail.action.removeUnavailableProducts': 'Odebrat nedostupné ks produktů',
    'orderDetail.action.removeUnavailableProductsText': 'Opravdu chcete z objednávky odebrat všechny kusy nedostupných produktů?',
    'orderDetail.action.returnDetail': 'Detail vratky',
    'orderDetail.action.createTransport': 'Vytvořit přepravu',
    'orderDetail.transportsTable.id': 'ID',
    'orderDetail.transportsTable.role': 'Role',
    'orderDetail.transportsTable.status': 'Stav',
    'orderDetail.transportsTable.trackingNumber': 'Sledovací číslo',
    'orderDetail.transportsTable.shipper': 'Dopravce',
    'orderDetail.transportsTable.roleSystem': 'Systémová',
    'orderDetail.transportsTable.roleManual': 'Manuální',
    'orderDetail.tab.invoiceTransport': 'Fakturace a doprava',
    'orderDetail.tab.transport': 'Přeprava',
    'orderDetail.tab.history': 'Historie',
    'orderDetail.tab.transportHistory': 'Historie dopravy',
    'orderDetail.tab.transports': 'Přepravy',
    'orderDetail.tab.expeditionPackages': 'Expediční balíky',
    'orderDetail.tab.summary': 'Shrnutí',
    'orderDetail.tab.products': 'Produkty',
    'orderDetail.tab.claimsReturns': 'Reklamace a vratky',
    'orderDetail.tab.address': 'Adresa',
    'orderDetail.tab.pallets': 'Palety',
    'orderDetail.emptyData': 'Neobsahuje data',
    'orderDetail.addToRemove': 'Přidat k odebrání',
    'orderDetail.removeProduct': 'Odebrat produkt',
    'orderDetail.actions': 'Akce',
    'orderDetail.cancelReason': 'Důvod zrušení',
    'orderDetail.paidOrder': 'Objednávka zaplacená',
    'orderDetail.paidOrderOptions': 'Možnosti zaplacení objednávky',
    'orderDetail.addProduct': 'Přidat produkt',
    'orderDetail.productTable.action.add': 'Přidat',
    'orderDetail.productTable.action.addProduct': 'Přidat produkt',
    'orderDetail.productTable.action.removeProduct': 'Odebrat produkt',
    'orderDetail.productTable.action.orderProductDetail': 'Detail produktu objednávky',
    'orderDetail.titleOrderProductDetail': 'Detail produktu objednávky',
    'orderDetail.mainInfo': 'Hlavní informace',
    'orderDetail.invoice': 'Fakturace',
    'orderDetail.detail': 'Detail objednávky',
    'orderDetail.disableShippingReorder': 'Externí TN (Marketplace) - neobjednávat dopravu',
    'orderDetail.cashOnDelivery': 'Dobírka',
    'orderDetail.orderDocuments': 'Dokumenty objednávky',
    'orderDetail.recipientInfo': 'Informace o příjemci',
    'orderDetail.deliveryInfo': 'Informace o doručení',
    'orderDetail.billingInfo': 'Fakturační údaje',
    'orderDetail.contact': 'Kontakt',
    'orderDetail.placeOfDelivery': 'Doručovací adresa',
    'orderDetail.billingAddress': 'Fakturační adresa',
    'orderDetail.detailInfo': 'Detailní informace',
    'orderDetail.documentInfo': 'Informace o dokumentech',
    'orderDetail.printGroup': 'Tiskárna',
    'orderDetail.billingInfoSame': 'Stejné fakturační údaje',
    'orderDetail.selectProviderBilling': 'Zobrazit kontakty',
    'orderDetail.selectProviderRecipient': 'Zobrazit kontakty',
    'orderDetail.selectProviderCompanybilling': 'Zvolte fakturační kontakt (Jméno a příjmení / Kontaktní osoba / Název firmy)',
    'orderDetail.selectProviderCompanyrecipient': 'Zvolte kontakt příjemce (Jméno a příjmení / Kontaktní osoba / Název firmy)',
    'orderDetail.eshopID': 'E-shop ID',
    'orderDetail.parentIdEshopId': 'ID nadřazené obj. / ID nadřazené e-shop obj.',
    'orderDetail.orderType': 'Typ objednávky',
    'orderDetail.orderStatus': 'Stav objednávky',
    'orderDetail.incorrectMessage': 'Chybová hláška',
    'orderDetail.paymentMethod': 'Způsob platby',
    'orderDetail.paid': 'Zaplaceno',
    'orderDetail.printFiles': 'Tisknout dokumenty',
    'orderDetail.allowExpedition': 'Povolit odeslání',
    'orderDetail.receivedDate': 'Datum vytvoření objednávky',
    'orderDetail.requiredExpeditionDate': 'Požadované datum expedice',
    'orderDetail.requiredExpeditionDate.tooltip': 'Požadované datum expedice můžete zadat D+2 = nejdřívější termín pozítří, nebo pozdější. Hodnota v poli může být automaticky upravena dle velikosti objednávky.',
    'orderDetail.note': 'Poznámka',
    'orderDetail.eshopNote': 'E-shop poznámka',
    'orderDetail.underSanction': 'Pod sankcí',
    'orderDetail.underSanction.tooltip': 'Označení Pod sankcí slouží k identifikaci objednávek, u kterých může dojít k penalizaci za nesprávné dodání.',
    // 'orderDetail.invoice': 'Faktura',
    'orderDetail.invoiceNumber': 'Číslo faktury',
    'orderDetail.invoicePrice': 'Fakturovaná cena',
    'orderDetail.invoicePriceCurrency': 'Měna faktury',
    'orderDetail.invoiceDate': 'Datum fakturace',
    'orderDetail.documentType': 'Typ dokumentu',
    'orderDetail.transport': 'Doprava',
    'orderDetail.shipper': 'Dopravce',
    'orderDetail.shipperService': 'Služba dopravce',
    'orderDetail.dispensingPoint': 'Výdejní místo',
    'orderDetail.dispensingCountry': 'Stát výdej. místa',
    'orderDetail.countryOfDelivery': 'Stát doručení',
    'orderDetail.pickupPoint': 'Výdejní místo',
    'orderDetail.dhlSelectOnMapHint':
        'Vyberte výdejní místo na mapě, dle zadaných parametrů. Pokud je zadán pouze Stát doručení, jsou zobrazena výdejní místa v hlavním městě. Posunem mapy se načtou další výdejní místa.',
    'orderDetail.dhlSearchServicePointsHint':
        'Vyhledejte výdejní místa dle zadaných parametrů: Stát doručení / Směrovací číslo / Město. Pokud je zadán pouze Stát doručení, jsou vyhledána výdejní místa v hlavním městě. Vyhledáno je 50 výdejních míst.',
    'orderDetail.dhlNoPointsLoadedHint': 'Vyhledejte podle PSČ nebo města, nebo vyberte na mapě.',
    'orderDetail.dhlSelectFromListHint': 'Zvolte výdejní místo ze seznamu',
    'orderDetail.dhlSearchServicePoints': 'Hledat',
    'orderDetail.dhlSelectOnMap': 'Vybrat na mapě',
    'orderDetail.dhlSelectPoint': 'Zvolit toto výdejní místo',
    'orderDetail.dhlMapPanHint': 'Posuňte mapu pro načtení výdejních míst v okolí.',
    'orderDetail.dhlMapClickMarkerHint': 'Klikněte na marker na mapě pro zobrazení detailu výdejního místa.',
    'orderDetail.dhlServicePointId': 'ID výdejního místa',
    'orderDetail.dhlOpeningHours': 'Otevírací doba',
    'orderDetail.trackingNumber': 'Sledovací číslo',
    'orderDetail.returnTrackingNumber': 'Vratkové sledovací číslo',
    'orderDetail.exchangeTrackingNumber': 'TN výměnné zásilky',
    'orderDetail.shipperLabel': 'Zobrazit přepravní štítek',
    'orderDetail.shipperExchangeLabel': 'TN výměnné zásilky',
    'orderDetail.shipperReturnLabel': 'Zobrazit vratkový přepravní štítek',
    'orderDetail.shipperLabelDownload': 'Stáhnout soubor přepravního štítku',
    'orderDetail.shipperReturnLabelDownload': 'Stáhnout soubor vratkového přepravního štítku',
    'orderDetail.shippingPrice': 'Cena přepravy',
    'orderDetail.shippingPriceCurrency': 'Měna přepravy',
    'orderDetail.currency': 'Měna',
    'orderDetail.shippedAt': 'Odesláno',
    'orderDetail.shipperResponse': 'Odpověď dopravce',
    'orderDetail.transportPaidBySkladon': 'Doprava placená Skladonem',
    'orderDetail.printReturnLabel': 'Vratkový štítek',
    'orderDetail.holdByQuality': 'Vychystat z kvality',
    'orderDetail.pickFromCustomsWarehouse': 'Vychystat z celního skladu',
    'orderDetail.boxCount': 'Počet krabic',
    'orderDetail.branchId': 'ID pobočky (B2Bc)',
    'orderDetail.confirmBranchIdTitle': 'Zadané ID pobočky (B2Bc): {{id}}',
    'orderDetail.confirmBranchIdText':
        'Tato objednávka bude sloučena s ostatními objednávkami pro stejné ID pobočky a odeslána společně v jedné zásilce. Pro expedici použijeme adresu a dopravce nastavené pro toto ID pobočky, nikoliv údaje uvedené v této objednávce.',
    'orderDetail.removeBranchId': 'Odebrat ID pobočky (B2Bc): {{id}}',
    'orderDetail.shipmentPending': 'Objednává se doprava?',
    'orderDetail.marketplace': 'Marketplace',
    'orderDetail.cashOnDeliveryReferentionNumber': 'Variabilní symbol dobírky',
    'orderDetail.cashOnDeliveryPrice': 'Cena dobírky',
    'orderDetail.cashOnDeliveryCurrency': 'Měna dobírky',
    'orderDetail.cashOnDeliveryRefNumber': 'Variabilní symbol dobírky',
    'orderDetail.paymentMethodPaid': 'Způsob platby a platba',
    'orderDetail.fullName': 'Jméno a příjmení',
    'orderDetail.attentionName': 'Kontaktní osoba',
    'orderDetail.address': 'Adresa (ulice, číslo)',
    'orderDetail.recipientStreet': 'Doručovací adresa (ulice, číslo)',
    'orderDetail.billingStreet': 'Fakturační adresa (ulice, číslo)',
    'orderDetail.addressAdditionalInfo': 'Dodatečné informace o adrese',
    'orderDetail.addressAdditionalInfo2': 'Dodatečné informace o adrese 2',
    'orderDetail.city': 'Město',
    'orderDetail.country': 'Stát',
    'orderDetail.provinceCode': 'Provinční kód',
    'orderDetail.postCode': 'Směrovací číslo',
    'orderDetail.email': 'E-mail',
    'orderDetail.phone': 'Telefon',
    'orderDetail.companyName': 'Název firmy',
    'orderDetail.GLN': 'GLN',
    'orderDetail.companyId': 'ID společnosti',
    'orderDetail.taxId': 'DIČ',
    'orderDetail.recipientCompanyId': 'Příjemce ID společnosti',
    'orderDetail.documents': 'Dokumenty',
    'orderDetail.message': 'Poznámka pro kurýra',
    'orderDetail.message.tooltip': 'Poznámka pro kurýra se propisuje na přepravní štítek u těchto dopravců: DHL, DPD, GLS, PPL CZ a UPS. Ostatní dopravci (PBH, PPL EU, Zásilkovna) nedokážou poznámku na štítku zobrazit / nedokážou tyto informace přijmout v systému.',
    'orderDetail.messageOnExpeditionBox': 'Zpráva na krabici',
    'orderDetail.filterTrackingNumber': 'Filtrovani sledovací číslo',
    'orderDetail.delivery': 'Doručování',
    'orderDetail.status.received': 'Objednání dopravy',
    'orderDetail.status.processing': 'Zpracovává se',
    'orderDetail.status.waitingForCarrier': 'Čeká na dopravce',
    'orderDetail.status.onTheWay': 'Na cestě',
    'orderDetail.status.atPickupPoint': 'Na výdejním místě',
    'orderDetail.status.delivered': 'Doručena',
    'orderDetail.productTable.name': 'Název',
    'orderDetail.productTable.SKU': 'SKU',
    'orderDetail.productTable.id': 'ID',
    'orderDetail.productTable.EAN': 'EAN',
    'orderDetail.productTable.bcxCode': 'BCX',
    'orderDetail.productTable.productType': 'Typ produktu',
    'orderDetail.productTable.lot': 'Šarže',
    'orderDetail.productTable.customsProductType': 'Celní typ produktu',
    'orderDetail.productTable.customizationType': 'Typ přizpůsobení',
    'orderDetail.productTable.customizationText': 'Text přizpůsobení',
    'orderDetail.productTable.count': 'Požadováno ks',
    'orderDetail.productTable.LOT': 'Šarže',
    'orderDetail.productTable.missingCount': 'Chybějící ks',
    'orderDetail.productTable.price': 'Cena / ks',
    'orderDetail.productTable.totalPrice': 'Cena celkem',
    'orderDetail.productTable.currency': 'Měna',
    'orderDetail.productTable.confirmed': 'Potvrzeno ks',
    'orderDetail.productTable.serialNumber': 'Sériová čísla',
    'orderDetail.productTable.avaiable': 'Dostupné',
    'orderDetail.productTable.lineState': 'Stav',
    'orderDetail.productTable.orderProducts': 'Produkty',
    'orderDetail.productTable.available': 'Dostupné ks',
    'orderDetail.productTable.available.tooltip': 'Zobrazuje aktuálně dostupné kusy daného produktu skladem. Pro sady produktů je zobrazena 0, jelikož SKU sady nejsou naskladněny.',
    'orderDetail.productTable.hsCode': 'HS kód',
    'orderDetail.productTable.weight': 'Váha/kg',
    'orderDetail.productTable.agecheck': 'Kontrola věku (18+)',
    'orderDetail.productTable.description': 'Popis',
    'orderDetail.productTable.expeditionMethod': 'Expediční metoda',
    'orderDetail.productTable.insertType': 'Typ vložení',
    'orderDetail.productTable.ROP': 'Bod přeobjednání',
    'orderDetail.productTable.EXPIRATION_DAYS': 'Upozornění na expiraci',
    'orderDetail.productTable.scanSerialNumber': 'Skenovat IMEI / sériová čísla',
    'orderDetail.productTable.snRegex': 'Regulární výraz pro porovnávání IMEI / SN',
    'orderDetail.productTable.width': 'Šířka/cm',
    'orderDetail.productTable.height': 'Výška/cm',
    'orderDetail.productTable.length': 'Hloubka/cm',
    'orderDetail.productTable.catalogPrice': 'Cena',
    'orderDetail.productTable.unitPrice': 'Měna',
    'orderDetail.productTable.batteryType': 'Baterie v zařízení / součást balení',
    'orderDetail.productTable.customField1': 'Vlastní pole 1',
    'orderDetail.productTable.customField2': 'Vlastní pole 2',
    'orderDetail.productTable.customField3': 'Vlastní pole 3',
    'orderDetail.productTable.active': 'Aktivní',
    'orderDetail.productTable.createdAt': 'Vytvořeno dne',
    'orderDetail.productTable.updatedAt': 'Upraveno dne',
    'orderDetail.productTable.isDeleted': 'Smazaný',
    'orderDetail.productTable.deletedAt': 'Smazáno dne',
    'orderDetail.addPallet': 'Přidat paletu',
    'orderDetail.palletTable.palletType': 'Typ palety',
    'orderDetail.palletTable.count': 'Počet',
    'orderDetail.palletTable.width': 'Šířka/cm',
    'orderDetail.palletTable.length': 'Délka/cm',
    'orderDetail.palletTable.height': 'Výška/cm',
    'orderDetail.palletTable.weight': 'Hmotnost/kg',
    'orderDetail.palletTable.action.add': 'Přidat',

    'orderDetail.slaCalculation.result': 'SLA datum',
    'orderDetail.slaCalculation.previousSlaDate': 'Předchozí SLA',
    'orderDetail.slaCalculation.calculated': 'SLA vypočteno',
    'orderDetail.slaCalculation.cleared': 'SLA promazáno',
    'orderDetail.slaCalculation.reason': 'Důvod výpočtu',
    'orderDetail.slaCalculation.reason.shipment_ordered': 'Objednání dopravy',
    'orderDetail.slaCalculation.reason.status_change_to_received': 'Změna stavu na přijato',
    'orderDetail.slaCalculation.reason.products_available': 'Produkty dostupné',
    'orderDetail.slaCalculation.reason.required_expedition_change': 'Změna požadovaného data expedice',
    'orderDetail.slaCalculation.reason.status_change_to_suspended': 'Změna stavu na pozastaveno',
    'orderDetail.slaCalculation.reason.status_change_to_preorder': 'Změna stavu na předobjednávku',
    'orderDetail.slaCalculation.reason.shipper_change': 'Změna dopravce',
    'orderDetail.slaCalculation.reason.manual_postpone': 'Manuální posun SLA',
    'orderDetail.slaCalculation.reason.customs_delay': 'Celní zdržení',
    'orderDetail.slaCalculation.reason.order_created': 'Vytvoření objednávky',
    'orderDetail.slaCalculation.input.orderType': 'Order type',
    'orderDetail.slaCalculation.input.orderTimestamp': 'Čas vytvoření objednávky',
    'orderDetail.slaCalculation.input.currentStatus': 'Aktuální stav',
    'orderDetail.slaCalculation.input.previousStatus': 'Předchozí stav',
    'orderDetail.slaCalculation.input.providerCot': 'COT e-shopu',
    'orderDetail.slaCalculation.input.carrierCot': 'Shipper COT',
    'orderDetail.slaCalculation.input.productsCount': 'Počet produktů',
    'orderDetail.slaCalculation.input.requiredExpeditionDate': 'Požadované datum expedice',
    'orderDetail.slaCalculation.input.shipper': 'Dopravce',
    'orderDetail.slaCalculation.input.postponeDays': 'Počet dnů posunu',
    'orderDetail.slaCalculation.input.b2bD0': 'B2B hranice D+0 (ks)',
    'orderDetail.slaCalculation.input.b2bD1': 'B2B hranice D+1 (ks)',
    'orderDetail.slaCalculation.input.b2bD2': 'B2B hranice D+2 (ks)',
    'orderDetail.slaCalculation.input.b2bD3': 'B2B hranice D+3 (ks)',
    'orderDetail.slaCalculation.input.waitingForPaymentAt': 'Čeká na platbu od',
    'orderDetail.slaCalculation.input.suspendedAt': 'Pozastavena od',
    'orderDetail.slaCalculation.input.productsNotAvailableAt': 'Nedostupné produkty od',
    'orderDetail.slaCalculation.input.incorrectAt': 'V chybě od',
    'orderDetail.slaCalculation.calculation.baseDate': 'Výchozí datum pro výpočet SLA',
    'orderDetail.slaCalculation.calculation.pragueTime': 'Čas (Prague)',
    'orderDetail.slaCalculation.calculation.isBeforeCutTime': 'Před COT',
    'orderDetail.slaCalculation.calculation.isHolidayOrWeekend': 'Svátek/víkend',
    'orderDetail.slaCalculation.calculation.nextWorkingDate': 'Další pracovní den',
    'orderDetail.palletTable.action.removePallet': 'Odebrat paletu',
    'orderDetail.expeditionPackagesTable.id': 'ID',
    'orderDetail.expeditionPackagesTable.expeditionPackage': 'Číslo balení',
    'orderDetail.expeditionPackagesTable.width': 'Šířka/m',
    'orderDetail.expeditionPackagesTable.height': 'Výška/m',
    'orderDetail.expeditionPackagesTable.length': 'Hloubka/m',
    'orderDetail.expeditionPackagesTable.weight': 'Hmotnost/kg',
    'orderDetail.expeditionPackagesTable.trackingNumber': 'Sledovací číslo',
    'orderDetail.expeditionPackagesTable.packageSku': 'SKU obal. materiálu',
    'orderDetail.expeditionPackagesTable.palletSku': 'SKU palety',
    'orderDetail.expeditionPackagesTable.sscc': 'SSCC',
    'orderDetail.expeditionPackagesTable.productSKU': 'SKU produktu',
    'orderDetail.expeditionPackagesTable.serialNumber': 'IMEI / Sériová čísla',
    'orderDetail.expeditionPackagesTable.productCount': 'Množství produktu',
    'orderDetail.expeditionPackagesTable.productLot': 'Šarže',
    'orderDetail.expeditionPackagesTable.productExpDate': 'Datum expirace',
    'orderDetail.expeditionPackagesTable.exportFileName': 'Export expedičních balíku objednávky #{{idOrder}}',
    'orderDetail.expeditionPackagesTable.productName': 'Název produktu',
    'orderDetail.expeditionPackagesTable.productEan': 'EAN',
    'orderDetail.expeditionPackagesTable.expPal': 'Číslo palety',
    'orderDetail.claimsReturnsTable.type': 'Typ',
    'orderDetail.claimsReturnsTable.id': 'ID',
    'orderDetail.claimsReturnsTable.eshopId': 'E-shop ID',
    'orderDetail.claimsReturnsTable.typeKey': 'Číslo záznamu',
    'orderDetail.claimsReturnsTable.createdAt': 'Datum vytvoření',
    'orderDetail.claimsReturnsTable.status': 'Stav',
    'orderDetail.claimsReturnsTable.shipper': 'Dopravce',
    'orderDetail.claimsReturnsTable.trackingNumber': 'Sledovací číslo',
    'orderDetail.confirmNotAviableCount': 'Pozor, tyto produkty nejsou dostupné!',
    'orderDetail.confirmPaidAction': 'Změnit způsob platby',
    'orderDetail.confirmPaidActionText':
        'Změnou způsobu platby dojde k aktualizaci objednávky bez uložení ostatních zadaných změn.',
    'orderDetail.confirmPaidActionText2': 'Jste si jistí, že chcete nyní změnit způsob platby?',
    'orderDetail.confirmPaidActionTextCOD':
        'Jste si jisti, že chcete změnit doručení na dobírku? Prosím vyplňte informace níže:',
    'orderDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem objednávky',
    'orderDetail.confirmGetNewDataStorageText': 'Máte uložený návrh objednávky - chcete s ním pokračovat?',
    'orderDetail.confirmSaveNewDataStorage': 'Uložit návrh objednávky',
    'orderDetail.confirmSaveNewDataStorageText': 'Neuložili jste změny. Chcete uložit návrh?',
    'orderDetail.confirmSaveNewDataStorageTextComment': '(Návrh objednávky bude ztracen po obnovení stránky)',
    'orderDetail.confirmReleaseFromSuspendedAt': 'Datum uvolnění z Pozastavena',
    'orderDetail.confirmReleaseFromSuspendedAtText':
        'Nastavte prosím datum a čas uvolnění objednávky. V tento termín bude stav objednávky automaticky změněn z Pozastavena na Obdržena.',
    'orderDetail.releaseFromSuspendedAt': 'Uvolnění z Pozastavena',
    'orderDetail.preorderReleaseAt': 'Uvolnit ke zpracování v',
    'orderDetail.lateBecouseIncorrect': 'Opožděné zpracování z důvodu chyby',
    'orderDetail.lateBecousePNA': 'Opožděné zpracování z důvodu nedostupných produktů',

    'orderDetail.history.createOrder': 'Objednávka vytvořena',
    'orderDetail.history.orderWasCloned': 'Vytvořena nová objednávka - klon, ID: {{ID}}',
    'orderDetail.history.orderWasSplitted': 'Vytvořena nová objednávka - rozdělení, ID: {{ID}}',
    'orderDetail.history.createFromClone': 'Objednávka vytvořena jako klon objednávky ID: {{PARENT_ORDER_ID}} ',
    'orderDetail.history.createFromSplit': 'Objednávka vytvořena rozdělením z objednávky ID: {{PARENT_ORDER_ID}}',
    'orderDetail.history.updateOrder': 'Objednávka upravena',
    'orderDetail.history.createReturn': 'Vratka {{RMA}} vytvořena',
    'orderDetail.history.createReturnWithoutRma': 'Vratka vytvořena',
    'orderDetail.history.updateOrderToStatus': 'Upraven stav objednávky {{STATUS.old}} -> {{STATUS.new}}',
    'orderDetail.history.updateOrderStatusSucces': 'Objednání dopravy bylo úspěšné: {{STATUS.old}} -> {{STATUS.new}}',
    'orderDetail.history.updateOrderStatusFailure':
        'Objednání dopravy bylo neúšpěšné: {{STATUS.old}} -> {{STATUS.new}}',
    'orderDetail.history.importShippingSuccess': 'Doprava úspěšně importována',
    'orderDetail.history.waitingForShipmentBecauseOfDelay': 'Objednání dopravy odloženo',
    'orderDetail.history.shipmentCancelledSuccess': 'Doprava zrušena',
    'orderDetail.history.orderShipmentCancelledFailed': 'Zrušení dopravy se nezdařilo',
    'orderDetail.history.errorWhileWrittingToDB': 'Chyba během zápisu dat do databáze: {{errorData}}',
    'orderDetail.history.recipient': 'Příjemce',
    'orderDetail.history.billing': 'Fakturace',
    'orderDetail.history.ORDER_PRODUCTS.new': 'Nový produkt',
    'orderDetail.history.ORDER_PRODUCTS.edit': 'Upraven produkt',
    'orderDetail.history.ORDER_PRODUCT_SETS.new': 'Nová sada produktů',
    'orderDetail.history.ORDER_PRODUCT_SETS.edit': 'Upravena sada produktů',
    'orderDetail.history.ORDER_FILES.new': 'Nový soubor objednávky',
    'orderDetail.history.ORDER_FILES.edit': 'Upraven soubor objednávky',
    'orderDetail.history.ORDER_FILES.delete': 'Smazán soubor objednávky',
    'orderDetail.history.ORDER_PRODUCT_FILES.new': 'Nový soubor produktu objednávky',
    'orderDetail.history.ORDER_PRODUCT_FILES.edit': 'Upraven soubor produktu objednávky',
    'orderDetail.history.ORDER_PRODUCT_FILES.delete': 'Smazán soubor produktu objednávky',
    'orderDetail.history.fileName': 'Název souboru',
    'orderDetail.history.fileType': 'Typ souboru',
    'orderDetail.history.fileCategory': 'Kategorie souboru',
    'orderDetail.history.ORDER_PALLETS.new': 'Nová paleta',
    'orderDetail.history.ORDER_PALLETS.edit': 'Upravena paleta',
    'orderDetail.history.ORDER_PALLETS.delete': 'Smazána paleta',
    'orderDetail.history.SLA_CALCULATION.new': 'Výpočet SLA',
    'orderDetail.history.SLA_CALCULATION.edit': 'Přepočet SLA',
    'orderDetail.history.slaCalculation': 'Výpočet SLA',
    'orderDetail.history.slaCalculation.shipment_ordered': 'SLA: Objednání dopravy → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_received': 'SLA: Změna stavu na přijato → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.products_available': 'SLA: Produkty dostupné → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.required_expedition_change': 'SLA: Změna požadovaného data expedice → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_suspended': 'SLA: Pozastavení objednávky → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_preorder': 'SLA: Změna na předobjednávku → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_canceled': 'SLA: Objednávka zrušena → SLA smazáno',
    'orderDetail.history.slaCalculation.shipper_change': 'SLA: Změna dopravce → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.manual_postpone': 'SLA: Manuální posun → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.customs_delay': 'SLA: Celní zdržení → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.order_created': 'SLA: Vytvoření objednávky → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.expedition_disabled': 'SLA: Odeslání zakázáno → SLA smazáno',
    'orderDetail.history.slaCalculation.expedition_enabled': 'SLA: Odeslání povoleno → SLA vypočteno',
    'orderDetail.history.SET_SKU': 'SKU sady',
    'orderDetail.history.SKU': 'SKU',
    'orderDetail.history.PRODUCT.SKU': 'SKU',
    'orderDetail.history.PRODUCT_NAME': 'Název',
    'orderDetail.history.orderAnonymization': 'Anonymizace',
    'orderDetail.history.PRODUCT.NAME': 'Název',
    'orderDetail.history.PALLET_TYPE': 'Typ palety',

    'orderDetail.paidAction.transferPaymentPaid': 'Bankovním převodem - zaplaceno',
    'orderDetail.paidAction.transferPaymentNotPaid': 'Bankovním převodem - nezaplaceno',
    'orderDetail.paidAction.cashOnDeliveryPaid': 'Dobírka - zaplaceno (reklamace/výměna)',
    'orderDetail.paidAction.cashOnDeliveryNotPaid': 'Dobírka - nezaplaceno',
    'orderDetail.paidAction.cashOnDelivery': 'Dobírka',
    'orderDetail.paidAction.onlinePaymentPaid': 'Kartou online - zaplaceno',
    'orderDetail.paidAction.onlinePaymentNotPaid': 'Kartou online - nezaplaceno',
    'orderDetail.paidAction.transferPaymentSend': 'Platba převodem je připravena k odeslání',

    'orderDetail.history.FILE.ORIGINAL_FILE_NAME': 'Název souboru',
    'orderDetail.history.FILE.FILE_TYPE': 'Typ souboru',
    'orderDetail.history.FILE.TYPE': 'Typ',
    'orderDetail.history.incorrectAt': 'Chybná v',
    'orderDetail.history.processingAt': 'Zpracovává se v',
    'orderDetail.history.productsNotAvailableAt': 'Produkty nedostupné v',
    'orderDetail.history.suspendedAt': 'Pozastavena v',
    'orderDetail.history.waitingForPaymentAt': 'Čeká na platbu v',
    'orderDetail.history.unit': 'Jednotka',
    'orderDetail.history.orderDate': 'Datum objednávky',
    'orderDetail.history.subStatus': 'Podstav',
    'orderDetail.history.shipperZone': 'Zóna dopravce',
    'orderDetail.history.shipperLabelPrinted': 'Štítek dopravce vytištěn',
    'orderDetail.history.dcixExport': 'DCIx export',
    'orderDetail.history.deliveredHook': 'Delivered hook',

    'ordersImport.title': 'Import objednávek',
    'ordersImport.error': 'Chyba',
    'ordersImport.incorrectFile': 'Nesprávný soubor',
    'ordersImport.incorrectFileData': 'Nesprávná data souboru',
    'ordersImport.excelFilePattern': 'Stáhnout šablonu pro importování objednávek:',
    'ordersImport.action.showCarriers': 'Zobrazit dopravce',
    'ordersImport.action.import': 'Importovat objednávky',
    'ordersImport.importConfirm': 'Opravdu chcete importovat objednávky?',
    'ordersImport.columnsOptions': 'Možnosti sloupců',
    'ordersImport.detailOrder': 'Detail objednávky',
    'ordersImport.confirmNotAviableCount': 'Pozor, tyto produkty nejsou dostupné!',
    'ordersImport.table.id': 'ID',
    'ordersImport.table.validity': 'Validace',
    'ordersImport.table.detail': 'Detail',
    'ordersImport.table.result': 'Výsledky',
    'ordersImport.table.eshopOrderId': 'Číslo objednávky e-shopu',
    'ordersImport.table.recipientName': 'Jméno příjemce',
    'ordersImport.table.recipientEmail': 'Příjemce e-mail',
    'ordersImport.table.actions': 'Akce',
    'ordersImport.notAlocatedtable.name': 'Název',
    'ordersImport.notAlocatedtable.sku': 'SKU',
    'ordersImport.notAlocatedtable.count': 'Požadováno ks',
    'ordersImport.notAlocatedtable.avaiable': 'Dostupné',
    'ordersImport.notAlocatedtable.missingCount': 'Chybějící ks',
    // 'ordersImport.notAlocatedtable.productType':'Typ produktu',
    // 'ordersImport.notAlocatedtable.ean':'EAN',
    // 'ordersImport.notAlocatedtable.expeditionMethod':'Expediční metoda',
    'ordersImport.action.create': 'Vytvořit',
    'ordersImport.action.update': 'Upravit',
    'ordersImport.action.showOrderDetail': 'Detail objednávky',
    'ordersImport.totalCountToImport': 'Počet objednávek pro importování - vytvořit: {{create}} upravit: {{update}}',
    'ordersImport.totalCountImported': 'Počet importů. Vytvořeno: {{created}}, Upraveno: {{updated}}',
    'ordersImport.tab.general': 'Všeobecné',
    'ordersImport.tab.created': 'Vytvořeno',
    'ordersImport.tab.updated': 'Upraveno',
    'ordersImport.carriers.title': 'Carriers',
    'ordersImport.carriers.table.label': 'Název',
    'ordersImport.carriers.table.value': 'ID',
    'ordersImport.tooltip.status': 'Stav objednávky: preOrder (Předobjednávka), preReceived (výchozí)',
    'ordersImport.tooltip.countProduct': 'Požadováno ks',
    'ordersImport.tooltip.addressId': 'ID výdejního místa zvoleného dopravce',
    'ordersImport.tooltip.branchId':
        'ID pobočky (B2Bc) - pro sloučení více malých B2C objednávek do jedné větší B2B (nutné nastavení ve Skladonu)',
    'ordersImport.tooltip.price': 'Fakturovaná cena',
    'ordersImport.status.preOrder': 'Předobjednávka',
    'ordersImport.status.preReceived': 'Přijato (výchozí)',
    'ordersImport.paymentMethod.cardOnline': 'Karta online',
    'ordersImport.paymentMethod.bankTransfer': 'Bankovní převod',
    'ordersImport.paymentMethod.cashOnDelivery': 'Dobírka',

    'orderExpeditionPackages.title': 'Expediční balíky',
    'orderExpeditionPackages.action.orderExpeditionPackageDetail': 'Detail expedičního balíku',
    'orderExpeditionPackages.action.orderDetail': 'Detail objednávky',
    'orderExpeditionPackages.action.synchronizeTable': 'Synchronizovat tabulku',
    'orderExpeditionPackages.action.exportFile': 'Export expedičních balíků',
    'orderExpeditionPackages.action.exportFileName': 'Export expedičních balíku',
    'orderExpeditionPackages.action.exportWithProducts': 'Export expedičních balíků s produkty',
    'orderExpeditionPackages.action.exportWithProductsFileName': 'Export expedičních balíků s produkty',
    'orderExpeditionPackages.table.id': 'ID',
    'orderExpeditionPackages.table.orderId': 'ID obj.',
    'orderExpeditionPackages.table.eshopOrderId': 'E-shop ID obj.',
    'orderExpeditionPackages.table.expeditionPackage': 'Číslo balení',
    'orderExpeditionPackages.table.width': 'Šířka/m',
    'orderExpeditionPackages.table.height': 'Výška/m',
    'orderExpeditionPackages.table.length': 'Hloubka/m',
    'orderExpeditionPackages.table.weight': 'Hmotnost/kg',
    'orderExpeditionPackages.table.trackingNumber': 'Sledovací číslo',
    'orderExpeditionPackages.table.packageSku': 'SKU obal. materiálu',
    'orderExpeditionPackages.table.expPal': 'Číslo palety',
    'orderExpeditionPackages.table.palletSku': 'SKU palety',
    'orderExpeditionPackages.table.createdAt': 'Vytvořeno',
    'orderExpeditionPackages.table.updatedAt': 'Upraveno',
    'orderExpeditionPackages.table.sscc': 'SSCC',
    'orderExpeditionPackages.table.productSKU': 'SKU produktu',
    'orderExpeditionPackages.table.productName': 'Název produktu',
    'orderExpeditionPackages.table.productEAN': 'EAN',
    'orderExpeditionPackages.table.productCount': 'Množství produktu',
    'orderExpeditionPackages.table.productSerialNumber': 'Sériová čísla',
    'orderExpeditionPackages.table.actions': 'Akce',
    'orderExpeditionPackages.message.orderExpeditionPackageUpdated': 'Expediční balík byl uložen',
    'orderExpeditionPackages.message.orderExpeditionPackageDeleted': 'Expediční balík byl smazán',

    'orderExpeditionPackageDetail.title': 'Detail expedičního balíku #{{idOrderExpeditionPackage}}',
    'orderExpeditionPackageDetail.titleNew': 'Vytvořit nový expediční balík',
    'orderExpeditionPackageDetail.action.save': 'Uložit',
    'orderExpeditionPackageDetail.action.delete': 'Smazat expediční balík',
    'orderExpeditionPackageDetail.createOrderExpeditionPackage': 'Vytvořit expediční balík',
    'orderExpeditionPackageDetail.editOrderExpeditionPackage': 'Uložit expediční balík',
    'orderExpeditionPackageDetail.order': 'ID objednávky',
    'orderExpeditionPackageDetail.expeditionPackage': 'Číslo balení',
    'orderExpeditionPackageDetail.trackingNumber': 'Sledovací číslo',
    'orderExpeditionPackageDetail.width': 'Šířka/m',
    'orderExpeditionPackageDetail.height': 'Výška/m',
    'orderExpeditionPackageDetail.length': 'Hloubka/m',
    'orderExpeditionPackageDetail.weight': 'Hmotnost/kg',
    'orderExpeditionPackageDetail.package': 'Balíček',
    'orderExpeditionPackageDetail.pallet': 'Paleta',
    'orderExpeditionPackageDetail.deleteOrderExpeditionPackage': 'Smazat expediční balík',
    'orderExpeditionPackageDetail.deleteOrderExpeditionPackageConfirm':
        'Opravdu chcete smazat tento expediční balík?',
    'orderExpeditionPackageDetail.productTable.title': 'Produkty',
    'orderExpeditionPackageDetail.productTable.id': 'ID',
    'orderExpeditionPackageDetail.productTable.SKU': 'SKU',
    'orderExpeditionPackageDetail.productTable.serialNumber': 'IMEI / Sériová čísla',
    'orderExpeditionPackageDetail.productTable.count': 'Množství',
    'orderExpeditionPackageDetail.productTable.lot': 'LOT',
    'orderExpeditionPackageDetail.productTable.expDate': 'Datum expirace',
    'orderExpeditionPackageDetail.productTable.exportFileName':
        'Export produktu expedičního balíku #{{idOrderExpeditionPackage}}',

    'orderMessagesOnExpeditionBox.title': 'Zprávy na krabici',
    'orderMessagesOnExpeditionBox.action.createNew': 'Nová',
    'orderMessagesOnExpeditionBox.action.exportFile': 'Export zpráv na krabici',
    'orderMessagesOnExpeditionBox.action.exportFileName': 'Export zpráv na krabici',
    'orderMessagesOnExpeditionBox.action.synchronizeTable': 'Synchronizovat tabulku',
    'orderMessagesOnExpeditionBox.action.messageOnExpeditionBoxDetail': 'Detail zprávy na krabici',
    'orderMessagesOnExpeditionBox.table.id': 'ID',
    'orderMessagesOnExpeditionBox.table.message': 'Zpráva na krabici',
    'orderMessagesOnExpeditionBox.table.country': 'Stát příjemce',
    'orderMessagesOnExpeditionBox.table.actions': 'Akce',

    'orderMessagesOnExpeditionBoxDetail.title': 'Detail zprávy na krabici #{{idOrderMessagesOnExpeditionBox}}',
    'orderMessagesOnExpeditionBoxDetail.titleNew': 'Vytvořit novou zprávu na krabici',
    'orderMessagesOnExpeditionBoxDetail.action.save': 'Uložit',
    'orderMessagesOnExpeditionBoxDetail.action.create': 'Vytvořit',
    'orderMessagesOnExpeditionBoxDetail.message': 'Zpráva na krabici',
    'orderMessagesOnExpeditionBoxDetail.country': 'Stát příjemce',
    'orderMessagesOnExpeditionBoxDetail.action.deleteMessageOnExpeditionBoxDetail': 'Smazat zprávu na krabici',
    'orderMessagesOnExpeditionBoxDetail.action.deleteMessageOnExpeditionBoxDetailConfirm':
        'Opravdu chcete smazat tuto zprávu na krabici?',

    'orderMessagesOnExpeditionBox.message.created': 'Zpráva na krabici byla vytvořena',
    'orderMessagesOnExpeditionBox.message.updated': 'Zpráva na krabici byla uložena',
    'orderMessagesOnExpeditionBox.message.deleted': 'Zpráva na krabici byla smazána',

    'claims.title': 'Reklamace',
    'claims.allProviders': 'Všechny e-shopy',
    'claims.action.exportFile': 'Export reklamací',
    'claims.action.exportFileName': 'Export reklamací',
    'claims.action.exportWithProductsFileName': 'Export reklamací s produkty',
    'claims.action.claimDetail': 'Detail reklamace',
    'claims.action.orderDetail': 'Detail objednávky',
    'claims.action.synchronizeTable': 'Synchronizovat tabulku',
    'claims.action.changeStatuses': 'Změnit stav reklamací',
    'claims.action.changeStatusesText': 'Opravdu chcete změnit stav {{count}} označeným reklamacím na:',
    'claims.action.exportWithProducts': 'Export reklamací s produkty',
    'claims.action.importClaims': 'Import reklamací z Excelu',
    'claims.message.claimsImported': 'Reklamace byly importovány',
    'claimsImport.title': 'Import reklamací',
    'claimsImport.excelFilePattern': 'Stáhnout šablonu pro import reklamací:',
    'claimsImport.columnsOptions': 'Možnosti sloupců',
    'claimsImport.requiredColumn': 'povinný sloupec',
    'claimsImport.incorrectFileData': 'Nesprávná data souboru',
    'claimsImport.previewTableTitle': 'Náhled importovaných dat',
    'claimsImport.importConfirm': 'Opravdu chcete importovat reklamace?',
    'claimsImport.action.import': 'Importovat reklamace',
    'claimsImport.table.validity': 'Validace',
    'claimsImport.table.fcn': 'FCN',
    'claimsImport.table.status': 'Stav',
    'claimsImport.table.transportPrice': 'Cena přepravy',
    'claimsImport.table.goodsPrice': 'Cena zboží',
    'claimsImport.table.totalServicePrice': 'Cena služby celkem',
    'claimsImport.table.compensationCurrency': 'Měna kompenzace',
    'claimsImport.table.carrierInvoiceReference': 'Variabilní symbol dopravce',
    'claimsImport.table.issuesMonthOrigin': 'Datum kompenzace klientovi',
    'error.claimNotFound': 'Reklamace s tímto FCN neexistuje',
    'error.duplicateFcn': 'Duplicitní FCN v souboru',
    'error.noChanges': 'Řádek neobsahuje žádná data k aktualizaci',
    'error.notPositiveNumber': 'Hodnota musí být kladné číslo',
    'claims.table.providerName': 'E-shop',
    'claims.table.id': 'ID',
    'claims.table.fcn': 'FCN',
    'claims.table.eshopClaimId': 'E-shop ID reklamace',
    'claims.table.orderId': 'ID objednávky',
    'claims.table.trackingNumber': 'Sledovací číslo',
    'claims.table.cctv': 'CCTV',
    'claims.table.shipper': 'Dopravce',
    'claims.table.orderType': 'Typ obj.',
    'claims.table.createdAt': 'Datum vytvoření',
    'claims.table.updatedAt': 'Poslední aktualizace',
    'claims.table.resolver': 'Řešitel',
    'claims.table.statusOfClaim': 'Stav reklamace',
    'claims.table.closedAt': 'Datum uzavření',
    'claims.table.informationAddedAt': 'Informace doplněny v',
    'claims.table.eshopOrderId': 'E-shop ID objednávky',
    'claims.table.claimCause': 'Důvod reklamace',
    'claims.table.otherClaimCause': 'Jiný důvod reklamace',
    'claims.table.note': 'Skladon poznámka',
    'claims.table.eshopNote': 'E-shop poznámka',
    'claims.table.description': 'Popis',
    'claims.table.returnTrackingNumber': 'Vratkové trasovací číslo',
    'claims.table.transportPrice': 'Cena přepravy',
    'claims.table.goodsPrice': 'Cena zboží',
    'claims.table.totalServicePrice': 'Cena služby',
    'claims.table.compensationCurrency': 'Měna',
    'claims.table.carrierInvoiceReference': 'Variabilní symbol dopravce',
    'claims.table.issuesMonthOrigin': 'Datum kompenzace klientovi',
    'claims.table.productSKU': 'SKU',
    'claims.table.productName': 'Název produktu',
    'claims.table.productClaimedQuantity': 'Reklamováno ks',
    'claims.table.productResendQuantity': 'Doposláno ks',
    'claims.table.inProcessAtFirst': 'Zpracovává se v (první)',
    'claims.table.inProcessAtLast': 'Zpracovává se v (poslední)',
    'claims.table.inProcessAt': 'Zpracovává se v',
    'claims.table.moreInfoNeededAt': 'Nedostačující informace v',
    'claims.table.acceptedExpectCompensationAt': 'Akceptována - očekáváme kompenzaci v',
    'claims.table.acceptedPendingClientCompensationAt': 'Akceptována - čeká na kompenzaci klientovi v',
    'claims.table.rejectedAt': 'Datum zamítnutí',
    'claims.table.canceledAt': 'Datum zrušení',
    'claims.table.packedAt': 'Zabalena v',
    'claims.table.packerName': 'Jméno baliče',
    'claims.table.errorResponsible': 'Zodpovědný za chybu',
    'claims.table.errorDepartment': 'Oddělení',
    'claims.table.errorCategory': 'Kategorie chyby',
    'claims.table.errorDescription': 'Popis chyby',
    'claims.table.errorSeverity': 'Závažnost chyby',
    'claims.table.videoLink': 'Odkaz na video',

    'claims.message.claimCreated': 'Reklamace byla vytvořena',
    'claims.message.claimUpdate': 'Reklamace byla uložena',

    'claimDetail.title': 'Detail reklamace #{{idClaim}}',
    'claimDetail.compensations': 'Kompenzace',
    'claimDetail.products': 'Reklamované produkty',
    'claimDetail.titleNew': 'Vytvořit novou reklamaci',
    'claimDetail.history': 'Historie',
    'claimDetail.history.PRODUCTS.new': 'Nový produkt',
    'claimDetail.history.PRODUCTS.edit': 'Upraven produkt',
    'claimDetail.history.SKU': 'SKU',
    'claimDetail.detail': 'Detail reklamace',
    'claimDetail.errorLogging': 'Evidence chyb',
    'claimDetail.packedAt': 'Zabalena v',
    'claimDetail.packerName': 'Jméno baliče',
    'claimDetail.errorResponsible': 'Zodpovědný za chybu',
    'claimDetail.errorDepartment': 'Oddělení',
    'claimDetail.errorDepartment.b2c': 'B2C',
    'claimDetail.errorDepartment.b2b': 'B2B',
    'claimDetail.errorCategory': 'Kategorie chyby',
    'claimDetail.errorCategory.packagingNonCompliance': 'Nedodržení balícího předpisu',
    'claimDetail.errorCategory.physicalHandlingError': 'Chyba fyzické manipulace',
    'claimDetail.errorCategory.scanningError': 'Chyba skenování',
    'claimDetail.errorCategory.insufficientPackaging': 'Nedostatečné zabalení',
    'claimDetail.errorCategory.others': 'Ostatní',
    'claimDetail.errorDescription': 'Popis chyby',
    'claimDetail.errorSeverity': 'Závažnost chyby',
    'claimDetail.errorSeverity.1': '1 - Nízká',
    'claimDetail.errorSeverity.2': '2 - Střední',
    'claimDetail.errorSeverity.3': '3 - Vysoká',
    'claimDetail.errorSeverityTooltip':
        'Tato hodnota určuje závažnost chyby, kdy 3 je nejzávažnější.',
    'claimDetail.videoLink': 'Odkaz na video',
    'claimDetail.action.create': 'Vytvořit',
    'claimDetail.action.save': 'Uložit',
    'claimDetail.action.createOrder': 'Vytvořit novou objednávku',
    'claimDetail.fcn': 'FCN',
    'claimDetail.cctv': 'CCTV',
    'claimDetail.eshopClaimId': 'E-shop ID reklamace',
    'claimDetail.orderId': 'ID objednávky',
    'claimDetail.trackingNumber': 'Sledovací číslo',
    'claimDetail.createdAt': 'Datum vytvoření',
    'claimDetail.status': 'Stav',
    'claimDetail.closedAt': 'Datum uzavření',
    'claimDetail.informationAddedAt': 'Informace doplněny v',
    'claimDetail.inProcessAt': 'V procesu v',
    'claimDetail.moreInfoNeededAt': 'Více informací potřebno v',
    'claimDetail.acceptedExpectCompensationAt': 'Přijato - očekávaná kompenzace v',
    'claimDetail.acceptedPendingClientCompensationAt': 'Akceptována - čeká na kompenzaci klientovi v',
    'claimDetail.rejectedAt': 'Zamítnuto v',
    'claimDetail.canceledAt': 'Zrušeno v',
    'claimDetail.claimCause': 'Důvod reklamace',
    'claimDetail.resolver': 'Řešitel',
    'claimDetail.causeOtherTypes': 'Jiný důvod reklamace',
    'claimDetail.description': 'Popis',
    'claimDetail.resolution': 'Řešení',
    'claimDetail.note': 'Skladon poznámka',
    'claimDetail.eshopNote': 'E-shop poznámka',
    'claimDetail.invoiceDocument': 'Prodejní a nabývací faktury',
    'claimDetail.invoiceDocumentText1': 'Přiložte prodejní a nabývací fakturu',
    'claimDetail.invoiceDocumentText2':
        ' - pro správné vyřízení reklamace je nezbytné vložit obě zmíněné faktury (pokud jste výrobce produktu, přiložte Čestné prohlášení o nabývací ceně zboží).',
    'claimDetail.invoiceImageDocumentText1': 'Přiložte fotodokumentaci',
    'claimDetail.invoiceImageDocumentText2':
        ' - při poškození zásilky je pro správné vyřízení reklamace nezbytné vložit fotodokumentaci poškozeného zboží i krabice/obalu, včetně adresního štítku.',
    'claimDetail.image': 'Fotky a další dokumenty',
    'claimDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem reklamace',
    'claimDetail.confirmGetNewDataStorageText': 'Máte uložený návrh reklamace - chcete s ním pokračovat?',
    'claimDetail.claimExistsTitle': 'Reklamace již existuje',
    'claimDetail.claimExistsBlocked':
        'Pro tuto objednávku (ID: {{orderId}} / E-shop ID obj.: {{eshopOrderId}}) již existuje reklamace ({{claimLinks}}), a proto není možné vytvořit další. V případě potřeby upravte stávající reklamaci, případně kontaktujte Skladon podporu.',
    'claimDetail.claimExistsConfirm':
        'Pro tuto objednávku (ID: {{orderId}} / E-shop ID obj.: {{eshopOrderId}}) již existuje reklamace ({{claimLinks}}). Chcete opravdu vytvořit další novou reklamaci?',

    'claimDetail.history.updateClaimToStatus': 'Upraven stav reklamace {{STATUS.old}} -> {{STATUS.new}}',
    'claimDetail.history.updateClaim': 'Reklamace upravena',
    'claimDetail.history.createClaim': 'Reklamace vytvořena',
    'claimDetail.history.claimAnonymization': 'Anonymizace',
    'claimDetail.eshopID': 'E-shop ID objednávky',
    'claimDetail.attachmentsHistoryType': 'Typ přílohy',
    'claimDetail.attachmentsHistoryFileName': 'Soubor',
    'claimDetail.attachmentsHistoryFileExtension': 'Typ souboru',
    'claimDetail.history.CLAIM_FILES.new': 'Nová příloha reklamace',
    'claimDetail.history.CLAIM_FILES.edit': 'Upravena příloha reklamace',
    'claimDetail.history.CLAIM_FILES.delete': 'Odstraněna příloha reklamace',
    'claimDetail.history.FILE.ORIGINAL_FILE_NAME': 'Soubor',
    'claimDetail.returnTrackingNumber': 'Vratkové trasovací číslo',
    'claimDetail.transportPrice': 'Cena přepravy',
    'claimDetail.goodsPrice': 'Cena zboží',
    'claimDetail.totalServicePrice': 'Cena služby',
    'claimDetail.compensationCurrency': 'Měna',
    'claimDetail.carrierInvoiceReference': 'Variabilní symbol dopravce',
    'claimDetail.issuesMonthOrigin': 'Datum kompenzace klientovi',
    'claimDetail.productTable.name': 'Název',
    'claimDetail.productTable.sku': 'SKU',
    'claimDetail.productTable.nameSku': 'SKU / Název produktu',
    'claimDetail.productTable.claimedQuantity': 'Reklamováno ks',
    'claimDetail.productTable.resendQuantity': 'Doposláno ks',

    'returns.title': 'Vratky',
    'returns.allProviders': 'Všechny e-shopy',
    'returns.action.exportFile': 'Export vratek',
    'returns.action.exportFileName': 'Export vratek',
    'returns.action.exportWithProducts': 'Export vratek s produkty',
    'returns.action.exportWithProductsFileName': 'Export vratek s produkty',
    'returns.action.returnDetail': 'Detail vratky',
    'returns.action.orderDetail': 'Detail objednávky',
    'returns.action.synchronizeTable': 'Synchronizovat tabulku',
    'returns.action.synchronizeDcix': 'Synchronizovat vratky do DCIx',
    'returns.action.synchronizeDcixText': 'Opravdu chcete synchronizovat {{count}} vratek?',
    'returns.action.changeStatuses': 'Změnit stav vratek',
    'returns.action.changeStatusesText': 'Opravdu chcete změnit stav na {{count}} vratkách na:',

    'returns.table.providerName': 'E-shop',
    'returns.table.id': 'ID',
    'returns.table.rma': 'RMA',
    'returns.table.eshopId': 'E-shop ID',
    'returns.table.eshopReturnId': 'E-shop ID vratky',
    'returns.table.createdAt': 'Datum vytvoření',
    'returns.table.receivedAt': 'V procesu v',
    'returns.table.confirmedAt': 'Potvrzeno v',
    'returns.table.sourceSystem': 'Vytvořeno v systému',
    'returns.table.orderId': 'ID obj.',
    'returns.table.recipientFullName': 'Jméno příjemce',
    'returns.table.invoiceNumber': 'Číslo faktury',
    'returns.table.statusOfReturn': 'Stav vratky',
    'returns.table.resolution': 'Řešení',
    'returns.table.trackingNumber': 'Sledovací číslo vratky',
    'returns.table.shipper': 'Dopravce vratky',
    'returns.table.shipperServiceCode': 'Služba dopravce vratky',
    'returns.table.orderType': 'Typ obj.',
    'returns.table.actions': 'Akce',
    'returns.table.resendOrder': 'Znovu odeslat objednávku',
    'returns.table.productQuantity': 'Vráceno ks',
    'returns.table.productReceived': 'Obdrženo ks',
    'returns.table.productResolution': 'Produkt řešení',
    'returns.table.productSerialNumber': 'Produkt IMEI / sériová čísla',
    'returns.table.productSKU': 'Produkt SKU',
    'returns.table.productName': 'Produkt název',
    'returns.table.eshopOrderId': 'E-shop ID obj.',
    'returns.table.partnerOrderId': 'ID obj. partnera',
    'returns.table.note': 'Poznámka',
    'returns.table.eshopNote': 'E-shop poznámka',
    'returns.table.dispatcherContact': 'Kontakt na dispečera',
    'returns.table.returnDescription': 'Popis vratky',
    'returns.table.transportPaidBy': 'Dopravu vratky platí',
    'returns.table.recipientName': 'Jméno příjemce',
    'returns.table.orderShipper': 'Dopravce objednávky',
    'returns.table.orderShipperService': 'Služba dopravce objednávky',
    'returns.table.orderTrackingNumber': 'Sledovací číslo objednávky',
    'returns.table.canceledAt': 'Zrušeno v',

    'returns.message.returnCreated': 'Vratka byla vytvořena',
    'returns.message.returnUpdate': 'Vratka byla uložena',
    'returns.message.returnDeleted': 'Vratka byla smazána',
    'returns.message.returnConfirmed': 'Vratka byla potvrzena',
    'returns.message.synchronizeSuccessfull': 'Synchronizace byla úspěšná',

    'returnDetail.title': 'Detail vratky #{{idReturn}}',
    'returnDetail.titleNew': 'Vytvořit novou vratku',
    'returnDetail.detail': 'Detail',
    'returnDetail.history': 'Historie',
    'returnDetail.editReturn': 'Uložit vratku',
    'returnDetail.createReturn': 'Vytvořit vratku',
    'returnDetail.action.create': 'Vytvořit',
    'returnDetail.action.save': 'Uložit',
    'returnDetail.action.confirm': 'Potvrdit',
    'returnDetail.action.showPdfForm': 'PDF formát',
    'returnDetail.detailInfo': 'Podrobné informace',
    'returnDetail.transport': 'Přeprava',
    'returnDetail.products': 'Produkty',
    'returnDetail.returnTitle': 'Vratka',
    'returnDetail.orderTitle': 'Objednávka',
    'returnDetail.addProduct': 'Přidání produktu',
    'returnDetail.returnReason': 'Důvod vratky',
    'returnDetail.eshopReturnId': 'E-shop ID vratky',
    'returnDetail.rma': 'RMA',
    'returnDetail.orderId': 'Číslo objednávky',
    'returnDetail.orderType': 'Typ objednávky',
    'returnDetail.order.eshopOrderId': 'E-shop ID objednávky',
    'returnDetail.order.shipper': 'Dopravce objednávky',
    'returnDetail.order.shipperService': 'Služba dopravce objednávky',
    'returnDetail.order.trackingNumber': 'Sledovací číslo objednávky',
    'returnDetail.order.deliveredAt': 'Datum doručení',
    'returnDetail.order.transportPaidBySkladon': 'Přeprava placená Skladonems',
    'returnDetail.eshopID': 'Číslo objednávky e-shopu',
    'returnDetail.partnerOrderId': 'ID objednávky partnera',
    'returnDetail.statusOfReturn': 'Stav vratky',
    'returnDetail.createdAt': 'Datum vytvoření',
    'returnDetail.sourceSystem': 'Vytvořeno v systému',
    'returnDetail.returnDescription': 'Popis vratky',
    'returnDetail.order': 'Objednávka',
    'returnDetail.shipper': 'Dopravce vratky',
    'returnDetail.trackingNumber': 'Sledovací číslo vratky',
    'returnDetail.shipperServiceCode': 'Služba dopravce vratky',
    'returnDetail.transportPaidBySkladon': 'Přeprava placena Skladonem',
    'returnDetail.shipperService': 'Služba dopravce',
    'returnDetail.shippingPrice': 'Cena dopravy',
    'returnDetail.currency': 'Měna',
    'returnDetail.deliveredAt': 'Doručeno',
    'returnDetail.note': 'Poznámka',
    'returnDetail.eshopNote': 'E-shop poznámka',
    'returnDetail.transportPaidBy': 'Dopravu vratky platí',
    'returnDetail.sourceSys': 'Vytvořeno v systému',
    'returnDetail.files': 'Soubory',
    'returnDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem vratky',
    'returnDetail.confirmGetNewDataStorageText': 'Máte uložený návrh vratky - chcete s ním pokračovat?',
    'returnDetail.confirmReturnExists': 'Vratka již existuje',
    'returnDetail.confirmReturnExistsText': 'Pro objednávku ID: {{orderId}} E-shop ID: {{eshopOrderId}} již vratka existuje:\n{{rmaList}}\nChcete opravdu vytvořit další novou vratku?',

    'returnDetail.productTable.action.add': 'Přidat',
    'returnDetail.productTable.action.addProduct': 'Přidat produkt',
    'returnDetail.productTable.action.removeProduct': 'Odebrat produkt',
    'returnDetail.productTable.name': 'Název',
    'returnDetail.productTable.sku': 'SKU',
    'returnDetail.productTable.id': 'ID',
    'returnDetail.productTable.EAN': 'EAN',
    'returnDetail.productTable.productType': 'Typ produktu',
    'returnDetail.productTable.count': 'Kusů v obj.',
    'returnDetail.productTable.quantity': 'Vráceno ks',
    'returnDetail.productTable.received': 'Obdrženo ks',
    'returnDetail.productTable.resolution': 'Řešení',
    'returnDetail.productTable.returnReason': 'Důvod vratky',
    'returnDetail.productTable.serialNumber': 'Sériová čísla',
    'returnDetail.productTable.actions': 'Akce',
    'returnDetail.productTable.hsCode': 'HS kód',
    'returnDetail.productTable.weight': 'Váha/kg',
    'returnDetail.productTable.agecheck': 'Kontrola věku (18+)',
    'returnDetail.productTable.description': 'Popis',
    'returnDetail.productTable.expeditionMethod': 'Expediční metoda',
    'returnDetail.productTable.insertType': 'Typ vložení',
    'returnDetail.productTable.ROP': 'Bod přeobjednání',
    'returnDetail.productTable.EXPIRATION_DAYS': 'Upozornění na expiraci',
    'returnDetail.productTable.scanSerialNumber': 'Skenovat IMEI / sériová čísla',
    'returnDetail.productTable.snRegex': 'Regulární výraz pro porovnávání IMEI / SN',
    'returnDetail.productTable.width': 'Šířka/cm',
    'returnDetail.productTable.height': 'Výška/cm',
    'returnDetail.productTable.length': 'Hloubka/cm',
    'returnDetail.productTable.catalogPrice': 'Cena',
    'returnDetail.productTable.unitPrice': 'Měna',
    'returnDetail.productTable.batteryType': 'Baterie v zařízení / součást balení',
    'returnDetail.productTable.customField1': 'Vlastní pole 1',
    'returnDetail.productTable.customField2': 'Vlastní pole 2',
    'returnDetail.productTable.customField3': 'Vlastní pole 3',
    'returnDetail.productTable.active': 'Aktivní',
    'returnDetail.productTable.createdAt': 'Vytvořeno dne',
    'returnDetail.productTable.updatedAt': 'Upraveno dne',
    'returnDetail.productTable.isDeleted': 'Smazaný',
    'returnDetail.productTable.deletedAt': 'Smazáno dne',

    'returnDetail.history.confirmReturn': 'Potvrzena vratka',
    'returnDetail.history.updateReturn': 'Vratka upravena',
    'returnDetail.history.createReturn': 'Vratka vytvořena',
    'returnDetail.history.updateReturnToStatus': 'Upravena stav vratky {{STATUS.old}} -> {{STATUS.new}}',
    'returnDetail.history.RETURNED_ORDER_PRODUCTS.new': 'Nový produkt',
    'returnDetail.history.RETURNED_ORDER_PRODUCTS.edit': 'Upravený produkt',
    'returnDetail.history.FILES.new': 'Nová příloha vratky',
    'returnDetail.history.FILES.edit': 'Upravena příloha vratky',
    'returnDetail.history.FILES.delete': 'Odstraněna příloha vratky',
    'returnDetail.history.fileName': 'Soubor',
    'returnDetail.attachmentsHistoryType': 'Typ souboru',
    'returnDetail.attachmentsHistoryFileName': 'Soubor',
    'returnDetail.attachmentsHistoryFileExtension': 'Typ souboru',
    'returnDetail.attachmentsHistoryFileSize': 'Velikost souboru',
    'returnDetail.canceledAt': 'Zrušeno v',
    'returnDetail.confirmedAt': 'Potvrzeno v',
    'returnDetail.receivedAt': 'V procesu v',
    'returnDetail.stockPosition': 'Skladová pozice',
    'returnDetail.dcixExport': 'DCIx export',
    'returnDetail.history.senderName': 'Jméno odesílatele',
    'returnDetail.history.senderStreet': 'Ulice odesílatele',
    'returnDetail.history.senderCity': 'Město odesílatele',
    'returnDetail.history.senderState': 'Stát odesílatele',
    'returnDetail.history.senderPostCode': 'PSČ odesílatele',
    'returnDetail.history.senderPhone': 'Telefon odesílatele',
    'returnDetail.history.recipientName': 'Jméno příjemce',
    'returnDetail.history.returnAnonymization': 'Anonymizace',
    'returnDetail.history.PRODUCT_ID': 'ID',
    'returnDetail.history.SKU': 'SKU',

    'receivings.title': 'Příjmy zboží',
    'receivings.allProviders': 'Všechny e-shopy',
    'receivings.action.exportFile': 'Export příjmů',
    'receivings.action.exportFileName': 'Export příjmů',
    'receivings.action.exportWithProducts': 'Export příjmů s produkty',
    'receivings.action.exportWithProductsFileName': 'Export příjmů s produkty',
    'receivings.action.receivingDetail': 'Detail příjmu zboží',
    'receivings.action.createNew': 'Nový',
    'receivings.action.synchronizeDcix': 'Synchronizovat příjmy do DCIx',
    'receivings.action.synchronizeDcixText': 'Opravdu chcete synchronizovat {{count}} příjmů?',
    'receivings.action.synchronizeTable': 'Synchronizovat tabulku',
    'receivings.action.importReceiving': 'Importovat příjmy',
    'receivings.action.changeStatuses': 'Změnit stav příjmu zboží',
    'receivings.action.changeStatusesText': 'Opravdu chcete změnit stav {{count}} označeným příjmům zboží na:',
    'receivings.table.providerName': 'E-shop',
    'receivings.table.status': 'Stav',
    'receivings.table.dateCreated': 'Datum vytvoření',
    'receivings.table.asn': 'Číslo příkazu',
    'receivings.table.supplier': 'Název dodavatele',
    'receivings.table.eshopReceivingId': 'E-shop ID',
    'receivings.table.estimatedDelivery': 'Plánované doručení',
    'receivings.table.awaitingQuantity': 'Avizováno ks',
    'receivings.table.receivedQuantity': 'Doručeno ks',
    'receivings.table.differentialQuantity': 'Odchylka ks',
    'receivings.table.unitsAmount': 'Avizováno kartonů',
    'receivings.table.id': 'ID',
    'receivings.table.carrierInfo': 'Informace dopravce',
    'receivings.table.deliveryNoteNumber': 'Číslo dodacího listu',
    'receivings.table.deliveryType': 'Typ přepravy',
    'receivings.table.duty': 'Celní povinnost',
    'receivings.table.urgent': 'Stav vytvoření ASN',
    'receivings.table.typeOfHandlingUnits': 'Typ manipulačních jednotek',
    'receivings.table.description': 'Poznámka k ASN',
    'receivings.table.trackingNumber': 'Sledovací číslo',
    'receivings.table.driverCompany': 'Přepravní společnost',
    'receivings.table.driverCompanyOtherName': 'Název jiné přepravní společnosti',
    'receivings.table.driverTrailerLicensePlate': 'SPZ vozidla',
    'receivings.table.driverName': 'Jméno řidiče',
    'receivings.table.driverPhone': 'Telefon na řidiče',
    'receivings.table.dispatcherContact': 'Kontakt na dispečera',
    'receivings.table.priority': 'Priorita',
    'receivings.table.containerNumber': 'Číslo kontejneru',
    'receivings.table.announcedPalletsCount': 'Avizováno palet',
    'receivings.table.receivingType': 'Typ příjmu',
    'receivings.table.realDelivery': 'Skutečné doručení',
    'receivings.table.slaDate': 'SLA datum',
    'receivings.table.slaSuspended': 'SLA pozastaveno',
    'receivings.table.photoDocumentationTaken': 'Fotodokumentace pořízena',
    'receivings.table.deliveredPalletsCount': 'Doručeno EUR palet',
    'receivings.table.returnedEurPalletsCount': 'Vráceno EUR palet',
    'receivings.table.deliveredStandardPalletsCount': 'Doručeno STANDARD palet',
    'receivings.table.returnedStandardPalletsCount': 'Vráceno STANDARD palet',
    'receivings.table.deliveredOtherPalletsCount': 'Doručeno OSTATNÍCH palet',
    'receivings.table.deliveredBrokenPalletsCount': 'Doručeno ROZBITÝCH palet',
    'receivings.table.deliveredCartonsCount': 'Doručeno kartonů',
    'receivings.table.skladonNote': 'Skladon poznámka',
    'receivings.table.incoterms': 'Dodací podmínky (Incoterms)',
    'receivings.table.actions': 'Akce',
    'receivings.table.productSKU': 'Produkt SKU',
    'receivings.table.productName': 'Produkt název',
    'receivings.table.productQuantity': 'Avizováno ks',
    'receivings.table.productReceived': 'Doručeno ks',
    'receivings.table.productDiffQuantity': 'Odchylka ks',
    'receivings.table.eshopNote': 'E-shop poznámka',
    'receivings.table.unloadedAt': 'Datum vyložení',
    'receivings.table.receivedAt': 'Zpracovává se v',
    'receivings.table.confirmedAt': 'Datum potvrzení',
    'receivings.table.canceledAt': 'Zrušeno v',

    'receivings.message.receivingCreated': 'Příjem zboží byl vytvořen',
    'receivings.message.receivingUpdate': 'Příjem zboží byl uložen',
    'receivings.message.receivingDeleted': 'Příjem zboží byl smazán',
    'receivings.message.synchronizeSuccessfull': 'Synchronizace byla úspěšná',

    'receivingDetail.title': 'Detail příjmu #{{idReceiving}}',
    'receivingDetail.titleNew': 'Vytvořit nový příjem',
    'receivingDetail.filesTitle': 'Dokumenty k příjmu',
    'receivingDetail.filesColFile': 'Soubor',
    'receivingDetail.filesColDescription': 'Popis',
    'receivingDetail.filesColUploadedBy': 'Nahrál',
    'receivingDetail.filesColActions': 'Akce',
    'receivingDetail.infoSection': 'ASN detail',
    'receivingDetail.history': 'Historie',
    'receivingDetail.detail': 'Detail',
    'receivingDetail.action.create': 'Vytvořit',
    'receivingDetail.action.save': 'Uložit',
    'receivingDetail.action.confirm': 'Potvrdit příjem',
    'receivingDetail.action.showPdfForm': 'ASN štítek',
    'receivingDetail.asnLabel.selectFormat': 'Vybrat formát',
    'receivingDetail.asnLabel.format.a4': '210 x 297 mm (A4)',
    'receivingDetail.asnLabel.format.a6': '100 x 150 mm (A6 - Zebra tiskárna)',
    'receivingDetail.createReceiving': 'Vytvořit příjem',
    'receivingDetail.editReceiving': 'Uložit příjem',
    'receivingDetail.packaging': 'Balení',
    'receivingDetail.products': 'Produkty',
    'receivingDetail.addProduct': 'Přidání produktu',
    'receivingDetail.addPacking': 'Přidání palety',
    'receivingDetail.removePackaging': 'Odebrat palety',
    'receivingDetail.supplier': 'Dodavatel',
    'receivingDetail.content': 'Obsah',
    'receivingDetail.createdAt': 'Datum vytvoření',
    'receivingDetail.status': 'Stav příjmu',
    'receivingDetail.asn': 'Číslo příkazu',
    'receivingDetail.urgent': 'Stav vytvoření ASN',
    'receivingDetail.trackingNumber': 'Sledovací číslo',
    'receivingDetail.eshopReceivingId': 'E-shop ID příjmu',
    'receivingDetail.estimatedDelivery': 'Plánované doručení',
    'receivingDetail.suplplier': 'Název dodavatele',
    'receivingDetail.typeOfHandlingUnits': 'Typ manipulačních jednotek',
    'receivingDetail.amountOfHandlingUnits': 'Počet avizovaných kartonů',
    'receivingDetail.description': 'Poznámka k ASN',
    'receivingDetail.carrierInfo': 'Informace dopravce',
    'receivingDetail.deliveryType': 'Typ přepravy',
    'receivingDetail.deliveryNoteNumber': 'Číslo dodacího listu',
    'receivingDetail.asnLabelEmail': 'E-mail pro zaslání ASN štítku',
    'receivingDetail.duty': 'Celní povinnost',
    'receivingDetail.driver': 'Dopravce',
    'receivingDetail.driverCompany': 'Přepravní společnost',
    'receivingDetail.driverCompanyOtherName': 'Název jiné přepravní společnosti',
    'receivingDetail.driverName': 'Jméno řidiče',
    'receivingDetail.driverPhone': 'Telefon na řidiče',
    'receivingDetail.dispatcherContact': 'Kontakt na dispečera',
    'receivingDetail.driverTrailerLicensePlate': 'SPZ vozidla',
    'receivingDetail.eshopNote': 'E-shop poznámka',
    'receivingDetail.priority': 'Priorita',
    'receivingDetail.containerNumber': 'Číslo kontejneru',
    'receivingDetail.announcedPalletsCount': 'Počet avizovaných palet',
    'receivingDetail.receivingType': 'Typ příjmu',
    'receivingDetail.incoterms': 'Dodací podmínky (Incoterms)',
    'receivingDetail.dcixInfo': 'Informace z DCIx',
    'receivingDetail.slaDate': 'SLA datum',
    'receivingDetail.realDelivery': 'Skutečné doručení',
    'receivingDetail.slaSuspended': 'SLA pozastaveno',
    'receivingDetail.photoDocumentationTaken': 'Fotodokumentace pořízena',
    'receivingDetail.deliveredPalletsCount': 'Počet doručených EUR palet',
    'receivingDetail.deliveredCartonsCount': 'Počet doručených kartonů',
    'receivingDetail.skladonNote': 'Skladon poznámka',
    'receivingDetail.returnedEurPalletsCount': 'Vráceno EUR palet',
    'receivingDetail.deliveredStandardPalletsCount': 'Počet doručených STANDARD palet',
    'receivingDetail.returnedStandardPalletsCount': 'Vráceno STANDARD palet',
    'receivingDetail.deliveredOtherPalletsCount': 'Počet doručených OSTATNÍ palety',
    'receivingDetail.deliveredBrokenPalletsCount': 'Počet doručených ROZBITÉ palety',
    'receivingDetail.unloadedAt': 'Datum vyložení',
    'receivingDetail.receivedAt': 'Zpracovává se v',
    'receivingDetail.confirmedAt': 'Datum potvrzení',
    'receivingDetail.note': 'Poznámka',
    'receivingDetail.canceledAt': 'Zrušeno v',
    'receivingDetail.dcixExport': 'DCIx export',

    // Tooltips
    'receivingDetail.estimatedDeliveryTooltip': 'Zadejte očekávané datum a čas doručení zboží do skladu.',
    'receivingDetail.deliveryTypeTooltip': 'Vyberte typ přepravy, jakým bude zboží doručeno do skladu - ovlivňuje způsob manipulace na příjmu.',
    'receivingDetail.dutyTooltip': 'Zvolte ANO, pokud zásilka podléhá celnímu řízení.',
    'receivingDetail.receivingTypeTooltip': 'Vyberte způsob, jakým bude zboží přijímáno – ovlivňuje formu kontroly a zpracování při příjmu.',
    'receivingDetail.asnLabelEmailTooltip': 'Uveďte e-mail, na který se má odeslat štítek pro označení dodávky (ASN štítek).',
    'receivingDetail.announcedPalletsCountTooltip': 'Uveďte nulu (0), v případě že zboží není na paletách.',
    'receivingDetail.trackingNumberTooltip': 'Pokud příjem nemá sledovací číslo, vyplňte hodnotu 0, nebo Nemá.',

    'receivingDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem příjmu',
    'receivingDetail.confirmGetNewDataStorageText': 'Máte uložený návrh příjmu - chcete s ním pokračovat?',

    'receivingDetail.productTable.name': 'Název',
    'receivingDetail.productTable.sku': 'SKU',
    'receivingDetail.productTable.id': 'ID',
    'receivingDetail.productTable.quantity': 'Avizováno ks',
    'receivingDetail.productTable.receivedQuantity': 'Doručeno ks',
    'receivingDetail.productTable.differential': 'Odchylka ks',
    'receivingDetail.productTable.lot': 'Šarže',
    'receivingDetail.productTable.expirationDate': 'Datum expirace',
    'receivingDetail.productTable.ean': 'EAN',
    'receivingDetail.productTable.description': 'Popis',
    'receivingDetail.productTable.productType': 'Typ produktu',
    'receivingDetail.productTable.lineState': 'Stav',
    'receivingDetail.productTable.serialNumber': 'Sériová čísla',
    'receivingDetail.productTable.actions': 'Akce',
    'receivingDetail.productTable.action.add': 'Přidat',
    'receivingDetail.productTable.action.addProduct': 'Přidat produkt',
    'receivingDetail.productTable.action.removeProduct': 'Odebrat produkt',
    'receivingDetail.productTable.hsCode': 'HS kód',
    'receivingDetail.productTable.weight': 'Váha/kg',
    'receivingDetail.productTable.agecheck': 'Kontrola věku (18+)',
    'receivingDetail.productTable.expeditionMethod': 'Expediční metoda',
    'receivingDetail.productTable.insertType': 'Typ vložení',
    'receivingDetail.productTable.ROP': 'Bod přeobjednání',
    'receivingDetail.productTable.EXPIRATION_DAYS': 'Upozornění na expiraci',
    'receivingDetail.productTable.scanSerialNumber': 'Skenovat IMEI / sériová čísla',
    'receivingDetail.productTable.snRegex': 'Regulární výraz pro porovnávání IMEI / SN',
    'receivingDetail.productTable.width': 'Šířka/cm',
    'receivingDetail.productTable.height': 'Výška/cm',
    'receivingDetail.productTable.length': 'Hloubka/cm',
    'receivingDetail.productTable.catalogPrice': 'Cena',
    'receivingDetail.productTable.unitPrice': 'Měna',
    'receivingDetail.productTable.batteryType': 'Baterie v zařízení / součást balení',
    'receivingDetail.productTable.customField1': 'Vlastní pole 1',
    'receivingDetail.productTable.customField2': 'Vlastní pole 2',
    'receivingDetail.productTable.customField3': 'Vlastní pole 3',
    'receivingDetail.productTable.active': 'Aktivní',
    'receivingDetail.productTable.createdAt': 'Vytvořeno dne',
    'receivingDetail.productTable.updatedAt': 'Upraveno dne',
    'receivingDetail.productTable.isDeleted': 'Smazaný',
    'receivingDetail.productTable.deletedAt': 'Smazáno dne',

    'receivingDetail.packagingTable.packagingType': 'Druh palety',
    'receivingDetail.packagingTable.pallet': 'Paleta - rozměry a typ',
    'receivingDetail.packagingTable.quantity': 'Množství',
    'receivingDetail.packagingTable.action.add': 'Přidat',
    'receivingDetail.packagingTable.action.removePacking': 'Odebrat paletu',

    'receivingDetail.history.PRODUCTS.new': 'Nový produkt',
    'receivingDetail.history.PRODUCTS.edit': 'Upraven produkt',
    'receivingDetail.history.PACKAGINGS.new': 'Nová paleta',
    'receivingDetail.history.PACKAGINGS.edit': 'Upravena paleta',
    'receivingDetail.history.PACKAGINGS.delete': 'Odstraněna paleta',
    'receivingDetail.history.RECEIVING_FILES.new': 'Nová příloha příjmu',
    'receivingDetail.history.RECEIVING_FILES.edit': 'Upravena příloha příjmu',
    'receivingDetail.history.RECEIVING_FILES.delete': 'Odstraněna příloha příjmu',
    'receivingDetail.history.ORIGINAL_FILE_NAME': 'Soubor',
    'receivingDetail.attachmentsHistoryType': 'Typ souboru',
    'receivingDetail.attachmentsHistoryFileName': 'Soubor',
    'receivingDetail.history.updateReceivingToStatus': 'Upraven stav příjmu {{STATUS.old}} -> {{STATUS.new}}',
    'receivingDetail.history.updateReceiving': 'Příjem upraven',
    'receivingDetail.history.createReceiving': 'Příjem vytvořen',
    'receivingDetail.history.SKU': 'SKU',

    'receivingDetailConfirm.title': 'Potvrdit příjem #{{idReceiving}}',
    'receivingDetailConfirm.note': 'Poznámka',
    'receivingDetailConfirm.addProduct': 'Přidat produkt',
    'receivingDetailConfirm.action.confirm': 'Potvrdit příjem',
    'receivingDetailConfirm.action.cancel': 'Zrušit',

    'receivingDetailConfirm.productTable.action.add': 'Přidat',
    'receivingDetailConfirm.productTable.action.removeProduct': 'Odebrat produkt',
    'receivingDetailConfirm.productTable.name': 'Název',
    'receivingDetailConfirm.productTable.sku': 'SKU',
    'receivingDetailConfirm.productTable.quantity': 'Avizováno ks',
    'receivingDetailConfirm.productTable.receivedQuantity': 'Doručeno ks',
    'receivingDetailConfirm.productTable.differential': 'Odchylka ks',
    'receivingDetailConfirm.productTable.lot': 'Šarže',
    'receivingDetailConfirm.productTable.expirationDate': 'Datum expirace',

    'receivingImport.title': 'Importovat příjem',
    'receivingImport.receivingFile': 'Soubor',
    'receivingImport.columnsOptions': 'Možnosti sloupců',
    'receivingImport.excelFilePattern': 'Stáhnout šablonu pro importování příjmu:',
    'receivingImport.eshopReceivingIdColumnDescription': 'Nepovinný. Pokud je vyplněn a příjemka s tímto e-shop ID existuje, import otevře tuto příjemku k editaci; jinak se vytvoří nová příjemka.',
    'receivingImport.fields.estimatedDelivery': 'Plánované doručení *',
    'receivingImport.fields.unitsAmount': 'Avizováno ks *',
    'receivingImport.fields.supplier': 'Název dodavatele *',
    'receivingImport.fields.deliveryType': 'Typ přepravy *',
    'receivingImport.fields.deliveryNoteNumber': 'Číslo dodacího listu *',
    'receivingImport.fields.containerNumber': 'Číslo kontejneru',
    'receivingImport.fields.announcedPalletsCount': 'Počet avizovaných palet *',
    'receivingImport.fields.duty': 'Celní povinnost *',
    'receivingImport.fields.driverCompany': 'Přepravní společnost *',
    'receivingImport.fields.trackingNumber': 'Sledovací číslo *',
    'receivingImport.fields.receivingType': 'Typ příjmu *',
    'receivingImport.fields.description': 'Popis',
    'receivingImport.fields.productSku': 'SKU produktu *',
    'receivingImport.fields.productQuantity': 'Množství produktu *',
    'receivingImport.fields.productLot': 'Šarže produktu',
    'receivingImport.fields.productExpirationDate': 'Datum expirace produktu',
    'receivingImport.productType.nonExistentSku': 'Neexistující SKU',
    'products.dcixSync.importedProviderProducts': 'Importováno {{count}} produktů pro e-shop ID: {{providerId}}.',
    'products.dcixSync.importedProviderProductEans': 'Importováno {{count}} produktových EANů pro e-shop ID: {{providerId}}.',
    'products.title': 'Inventář',
    'products.all': 'Všechny produkty',
    'products.active': 'Aktivní produkty',
    'products.inactive': 'Neaktivní produkty',
    'products.deleted': 'Smazané produkty',
    'products.sets': 'Sady produktů',
    'products.packgingMaterials': 'Obalové materiály',
    'products.promoMaterials': 'Promo materiály',
    'products.billOfMaterials': 'Kusovníky',
    'products.createNew': 'Nový',
    'products.massUpdate': 'Hromadná změna parametrů produktů',
    'products.massUpdateConfirm': 'Označte, jaké parametry chcete změnit pro {{count}} zvolených produktů a zadejte nově požadované hodnoty.',
    'products.action.importProducts': 'Importovat produkty',
    'products.action.withStock': 'Zobrazit skladové zásoby',
    'products.action.exportFileName': 'Export produktů',
    'products.action.dowloadProductsTable': 'Export produktů',
    'products.action.productDetail': 'Detail produktu',
    'products.action.allProviders': 'Všechny e-shopy',
    'products.action.allStock': 'Šarže / datum expirace',
    'products.action.stockTransfers': 'Převody skladových zásob',
    'products.action.synchronizeTable': 'Synchronizovat produkty',
    'products.action.activateProducts': 'Aktivovat produkty',
    'products.action.deactivateProducts': 'Deaktivovat produkty',
    'products.action.syncProductsToDcix': 'Synchronizovat produkty do DCIx',
    'products.action.syncEansToDcix': 'Synchronizovat EANy do DCIx',
    'products.action.massUpdate': 'Změnit parametry produktů',
    'products.activateProductsConfirm': 'Opravdu chcete aktivovat {{count}} produkty?',
    'products.activateProducts': 'Aktivovat produkty',
    'products.deactivateProducts': 'Deaktivovat produkty',
    'products.deactivateProductsConfirm': 'Opravdu chcete deaktivovat {{count}} produkty?',
    'products.stockRatio.label': 'Poměr zobrazovaných zásob',
    'products.stockRatio.tooltip': 'Zobrazení dostupných skladových zásob produktů - sloupec Dostupné. 100% = všechny dostupné zásoby jsou zobrazeny a případně synchronizovány na platformu e-shopu.',

    'products.table.SKU': 'SKU',
    'products.table.id': 'ID',
    'products.table.name': 'Název',
    'products.table.EAN': 'EAN',
    'products.table.eanLockedByWms': 'EAN spravuje WMS',
    'products.table.insertType': 'Typ vložení',
    'products.table.insertByOrderType': 'Vložit dle typu obj.',
    'products.table.lot': 'Šarže',
    'products.table.expirationDate': 'Datum expirace',
    'products.table.providerName': 'E-shop',
    'products.table.allocated': 'Rezervováno',
    'products.table.onExpedition': 'Vychystává se',
    'products.table.available': 'Dostupné',
    'products.table.onHoldQuality': 'Zadrženo kvalitou',
    'products.table.awaiting': 'Očekáváno',
    'products.table.customsWarehouse': 'Celní sklad',
    'products.table.active': 'Aktivní',
    'products.table.all': 'Všechny',
    'products.table.all.tooltip': 'Kompletní počet kusů produktu, které jsou na skladě – včetně kusů, které se aktuálně nachází na nedisponibilních pozicích = nejsou ještě zaskladněny na disponibilní pozici. Jde například o produkty na příjmu zboží nebo kompletaci. Viz Znalostní databáze – článek Inventář, odstavec Skladové zásoby.',
    'products.table.allocated.tooltip': 'Počet kusů produktů rezervovaných v objednávkách, které dosud nebyly odeslány. Viz Znalostní databáze - článek Inventář, odstavec Skladové zásoby.',
    'products.table.available.tooltip': 'Počet kusů produktů, které jsou skladem a nejsou rezervovány do objednávek. Viz Znalostní databáze - článek Inventář, odstavec Skladové zásoby.',
    'products.table.hsCode': 'HS kód',
    'products.table.batteryType': 'Baterie v zařízení / součást balení',
    'products.table.productType': 'Typ produktu',
    'products.table.expeditionMethod': 'Expediční metoda',
    'products.table.description': 'Popis',
    'products.table.ROP': 'Bod přeobjednání',
    'products.table.EXPIRATION_DAYS': 'Upozornění na expiraci',
    'products.table.agecheck': 'Kontrola věku (18+)',
    'products.table.globalProduct': 'Globální produkt',
    'products.table.quantityConversion': 'Přepočet množství',
    'products.table.scanSerialNumber': 'Skenovat IMEI / SN',
    'products.table.snRegex': 'Regulární výraz pro porovnávání IMEI / SN',
    'products.table.weight': 'Váha/kg',
    'products.table.width': 'Šířka/cm',
    'products.table.height': 'Výška/cm',
    'products.table.length': 'Hloubka/cm',
    'products.table.price': 'Cena',
    'products.table.unitPrice': 'Měna',
    'products.table.customField1': 'Vlastní pole 1',
    'products.table.customField2': 'Vlastní pole 2',
    'products.table.customField3': 'Vlastní pole 3',
    'products.table.originCountry': 'Země původu',
    'products.table.isDeleted': 'Smazaný',
    'products.table.sourceSys': 'Zdrojový systém',
    'products.table.sourceSys.myskladon': 'MySkladon',
    'products.table.sourceSys.pipes': 'Pipes',
    'products.table.sourceSys.api': 'API',
    'products.table.createdAt': 'Vytvořeno dne',
    'products.table.updatedAt': 'Upraveno dne',
    'products.table.dimensionsChangedAt': 'Rozměry upraveny',
    'products.table.deletedAt': 'Smazáno dne',
    'products.message.productCreated': 'Produkt byl vytvořen',
    'products.message.productUpdate': 'Produkt byl uložen',
    'products.message.productDeleted': 'Produkt byl smazán',
    'products.message.productActivated': 'Produkt byl aktivován',
    'products.message.productDeactivated': 'Produkt byl deaktivován',
    'products.message.productsActivated': 'Produkty byly aktivovány',
    'products.message.productsDeactivated': 'Produkty byly deaktivovány',
    'products.message.productImported': 'Produkty byly importovány',

    'productDetail.title': 'Detail produktu #{{idProduct}} SKU: {{SKU}}',
    'productDetail.titleNew': 'Vytvořit nový produkt',
    'productDetail.history': 'Historie',
    'productDetail.detail': 'Detail',
    'productDetail.create': 'Vytvořit produkt',
    'productDetail.save': 'Uložit',
    'productDetail.saveChanges': 'Uložit změny produktu',
    'productDetail.deleteProduct': 'Smazat produkt',
    'productDetail.deleteProductConfirm': 'Opravdu chcete smazat tento produkt?',
    'productDetail.billsOfMaterials': 'Kusovníky',
    'productDetail.productStock': 'Šarže / datum expirace',
    'productDetail.titleProductStock': 'Šarže / datum expirace',
    'productDetail.activateProduct': 'Aktivovat produkt',
    'productDetail.deactivateProduct': 'Deaktivovat produkt',
    'productDetail.createConfirm': 'Opravdu chcete vytvořit produkt?',
    'productDetail.saveConfirm': 'Opravdu chcete uložit změny u tohoto produktu?',
    'productDetail.activateProductConfirm': 'Opravdu chcete aktivovat tento produkt?',
    'productDetail.deactivateProductConfirm': 'Opravdu chcete deaktivovat tento produkt?',
    'productDetail.productOrders': 'Objednávky produktu',
    'productDetail.titleProductOrders': 'Objednávky produktu SKU: {{SKU}}',
    'productDetail.productOrdersTimeFrom': 'Od',
    'productDetail.productSetChangeWarning.info': 'Nezpracované objednávky ({{count}}) obsahují původní sadu produktů.',
    'productDetail.productSetChangeWarning.text':
        'Opravdu chcete změnit sadu SKU: {{sku}}, i když existují nezpracované objednávky s touto sadou produktů? Změnou sady nebude možné v těchto objednávkách již sadu / produkty v této sadě upravit.',
    'productDetail.productSetChangeWarning.ordersPrefix': 'Objednávky se sadou:',
    'productDetail.productTypeChangeOrdersConfirm.line1':
        'Opravdu chcete uložit změny, včetně změny typu produktu z {{originalType}} na {{newType}}?',
    'productDetail.productTypeChangeOrdersConfirm.line2':
        'Uložením této změny typu produktu bude produkt SKU: {{sku}} aktualizován v {{count}} nezpracovaných objednávkách.',
    'productDetail.productType': 'Typ produktu',
    'productDetail.SKU': 'SKU produktu',
    'productDetail.SKU.tooltip': 'SKU nelze uživatelsky měnit - jde o primární identifikátor produktů a je navázáno na skladové hospodářství. Prosíme neměňte SKU produktů ani ve Vašem systému - změnou SKU u Vás vytvoříte nový produkt v MyS, což způsobí problémy. Při potřebě změnit SKU prosím kontaktujte Skladon - customercare@skladon.cz.',
    'productDetail.incorretSkuText': 'Diakritika není povolena pro SKU produktu',
    'productDetail.name': 'Název produktu',
    'productDetail.description': 'Popis',
    'productDetail.hsCode': 'HS kód',
    'productDetail.batteryType': 'Baterie v zařízení / součást balení',
    'productDetail.inserType': 'Typ vložení',
    'productDetail.insertByOrderType': 'Vložit dle typu objednávky',
    'productDetail.insertByOrderType.all': 'B2B i B2C objednávky',
    'productDetail.insertByOrderType.b2c': 'Pouze B2C objednávky',
    'productDetail.insertByOrderType.b2b': 'Pouze B2B objednávky',
    'productDetail.insertPriceFrom': 'Vložení od ceny',
    'productDetail.insertPriceTo': 'Vložení do ceny',
    'productDetail.productInsertToCountries': 'Vložení dle státu doručení',
    'productDetail.agecheck': 'Kontrola věku (18+)',
    'productDetail.quantityConversion': 'Přepočet množství',
    'productDetail.globalProduct': 'Globální produkt',
    'productDetail.scanSerialNumber': 'Skenovat IMEI / SN',
    'productDetail.snRegex': 'Regulární výraz pro porovnávání IMEI / SN',
    'productDetail.snRegex.tooltip': 'Zadejte regulární výraz pro porovnávání SN (sériových čísel), například: ^H[A-Z0-9]+$ nebo ^[A-Za-z0-9]{12}$ a podobně. Pro porovnání IMEI je regulární výraz ^[0-9]{14,16}$ doplněn automaticky.',
    'productDetail.ROP': 'Bod přeobjednání',
    'productDetail.EXPIRATION_DAYS': 'Upozornění na expiraci - dny předem',
    'productDetail.EAN': 'EAN',
    'productDetail.EAN.tooltip': 'Pro změnu EANu u produktu se skladovou zásobou prosím kontaktujte Skladon - customercare@skladon.cz, je nutné změnit/přelepit štítek s EANem u stávajících naskladněných produktů ',
    'productDetail.eanLockedByDcix': 'EAN spravuje WMS',
    'productDetail.eansTab.title': 'EANy',
    'productDetail.eansTab.addEan': 'Přidat EAN',
    'productDetail.eansTab.add': 'Přidat',
    'productDetail.eansTab.ean': 'EAN',
    'productDetail.eansTab.duplicateEan': 'Tento EAN je již u produktu zadán',
    'productDetail.eansTab.deactivateEan': 'Deaktivovat EAN',
    'productDetail.eansTab.activateEan': 'Aktivovat EAN',
    'productDetail.eansTab.removeEan': 'Odebrat EAN',
    'productDetail.eansTab.lockedInfo': 'EANy u tohoto produktu řídí WMS. Bez oprávnění PRODUCT.EAN.EDIT můžete pouze přidat nový EAN.',
    'productDetail.eansTab.table.ean': 'EAN',
    'productDetail.eansTab.table.active': 'Aktivní',
    'productDetail.eansTab.editOnEansTab': 'EANy se upravují na záložce EANy',
    'productDetail.eansTab.goToEans': 'Přejít na záložku EANy',
    'productDetail.eansTab.goToEansButton': 'EANy',
    'productDetail.history.EANS.new': 'Nový EAN produktu',
    'productDetail.history.EANS.edit': 'Upraven EAN produktu',
    'productDetail.history.EANS.delete': 'Odebrán EAN produktu',
    'productDetail.history.ean': 'EAN',
    'productDetail.history.eanActive': 'Aktivní',
    'productDetail.expMethod': 'Expediční metoda',
    'productDetail.width': 'Šířka/cm',
    'productDetail.height': 'Výška/cm',
    'productDetail.length': 'Hloubka/cm',
    'productDetail.weight': 'Váha/kg',
    'productDetail.price': 'Cena',
    'productDetail.unitPrice': 'Měna',
    'productDetail.customField1': 'Vlastní pole 1',
    'productDetail.customField2': 'Vlastní pole 2',
    'productDetail.customField3': 'Vlastní pole 3',
    'productDetail.originCountry': 'Země původu',
    'productDetail.active': 'Aktivní',
    'productDetail.isDeleted': 'Smazaný',
    'productDetail.sourceSys': 'Zdrojový systém',
    'productDetail.stockMuCode': 'Skladová měrná jednotka',
    'productDetail.packingType': 'Typ balení',
    'productDetail.insertToProductId': 'ID produktu pro vložení',
    'productDetail.UPC': 'UPC',
    'productDetail.MPN': 'MPN',
    'productDetail.ISBN': 'ISBN',
    'productDetail.note': 'Poznámka',
    'productDetail.packagingMaterialSlots': 'Pozice obalového materiálu',
    'productDetail.eshopStock': 'E-shop sklad',
    'productDetail.refId': 'Referenční ID',
    'productDetail.guid': 'GUID',
    'productDetail.ownerEshopKey': 'E-shop klíč vlastníka',
    'productDetail.alias': 'Alias',
    'productDetail.dcixImport': 'DCIx import',
    'productDetail.dcixProviderId': 'DCIx ID providera',
    'productDetail.linkedEshop': 'Propojený e-shop',
    'productDetail.attachedIdentifier': 'Připojený identifikátor',
    'productDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem produktu',
    'productDetail.confirmGetNewDataStorageText': 'Máte uložený návrh produktu - chcete s ním pokračovat?',
    'productDetail.confirmSetAllProductRelation': 'Přidání všech produktů',
    'productDetail.confirmSetAllProductRelationText':
        'Přidáním všech produktů dojde ke smazání předchozích produktů a jejich typů vložení',
    'productDetail.exportProductOrders': 'Exportovat objednávky produktu',
    'productDetail.productOrdersTable.orderId': 'ID obj.',
    'productDetail.productOrdersTable.eshopId': 'E-shop ID obj.',
    'productDetail.productOrdersTable.date': 'Datum vytvoření',
    'productDetail.productOrdersTable.shipper': 'Dopravce',
    'productDetail.productOrdersTable.trackingNumber': 'Sledovací číslo',
    'productDetail.productOrdersTable.status': 'Stav',
    'productDetail.productOrdersTable.recipientState': 'Stát příjemce',
    'productDetail.productOrdersTable.count': 'Požadováno ks',
    'productDetail.productOrdersTable.missingCount': 'Chybějící ks',
    'productDetail.productOrdersTable.confirmed': 'Potvrzeno ks',
    'productDetail.history.createProduct': 'Produkt vytvořen',
    'productDetail.history.updateProduct': 'Produkt upraven',
    'productDetail.history.deleteProduct': 'Produkt smazán',
    'productDetail.history.PRODUCT_INSERT_COUNTRIES.new': 'Nova krajina vložení',
    'productDetail.history.PRODUCT_INSERT_COUNTRIES.delete': 'Odstraněna krajina vložení',
    'productDetail.country': 'Krajina',
    'productDetail.history.PRODUCT_RELATIONS_2.new': 'Nový produktový vztah',
    'productDetail.history.PRODUCT_RELATIONS_2.delete': 'Odstraněn produktový vztah',
    'productDetail.history.PRODUCT_SET.new': 'Nový produkt v sadě',
    'productDetail.history.PRODUCT_SET.edit': 'Upraven produkt v sadě',
    'productDetail.history.PRODUCT_SET.delete': 'Smazán produkt ze sady',
    'productDetail.history.FILES.new': 'Nová příloha produktu',
    'productDetail.history.FILES.edit': 'Upravena příloha produktu',
    'productDetail.history.FILES.delete': 'Odstraněna příloha produktu',
    'productDetail.history.ORIGINAL_FILE_NAME': 'Soubor',
    'productDetail.attachmentsHistoryType': 'Typ přílohy',
    'productDetail.attachmentsHistoryFileName': 'Soubor',
    'productDetail.history.PRODUCT_SKU': 'SKU',
    'productDetail.productRelationstable.Count': 'Počet',

    'productDetail.productRelationstable.nameSKU': 'SKU | Název',
    'productDetail.productRelationstable.name': 'Název',
    'productDetail.productRelationstable.SKU': 'SKU',
    'productDetail.productRelationstable.EAN': 'EAN',
    'productDetail.productRelationstable.productType': 'Typ produktu',
    'productDetail.productRelationstable.type': 'Typ',
    'productDetail.productRelationstable.remove': 'Odebrat produktový vztah',
    'productDetail.productRelationstable.removeSelectedProducts': 'Odebrat vybrané produktové vztahy',
    'productDetail.productRelationstable.confirmRemoveSelectedProducts': 'Odebrat vybrané produktové vztahy',
    'productDetail.productRelationstable.confirmRemoveSelectedProductsText':
        'Opravdu chcete odebrat vybrané produktové vztahy?',
    'productDetail.addProductRelation': 'Typ vložení: Specifické produkty - Přidat produktový vztah',
    'productDetail.productRelationstable.action.add': 'Přidat',
    'productDetail.allProductsOption': 'Všechny produkty ({{length}})',
    'productDetail.productSetTab.title': 'Produkty v sadě',
    'productDetail.productSetTab.addProduct': 'Přidat produkt do sady',
    'productDetail.productSetTab.productSku': 'SKU | Název | EAN',
    'productDetail.productSetTab.quantity': 'Množství',
    'productDetail.productSetTab.add': 'Přidat',
    'productDetail.productSetTab.removeProduct': 'Odebrat produkt ze sady',
    'productDetail.productSetTab.noProductsError': 'V sadě nejsou definovány žádné produkty! Zadejte prosím z jakých produktů se tato sada skládá.',
    'productDetail.productSetTab.table.sku': 'SKU',
    'productDetail.productSetTab.table.name': 'Název',
    'productDetail.productSetTab.table.ean': 'EAN',
    'productDetail.productSetTab.table.quantity': 'Množství',
    'productDetail.productReceivings': 'Příjmy produktu',
    'productDetail.exportProductReceivings': 'Exportovat příjmy produktu',
    'productDetail.productReceivingsTable.asn': 'Číslo příkazu',
    'productDetail.productReceivingsTable.eshopReceivingId': 'E-shop ID',
    'productDetail.productReceivingsTable.createdAt': 'Datum vytvoření',
    'productDetail.productReceivingsTable.productQuantity': 'Avizováno ks',
    'productDetail.productReceivingsTable.productReceived': 'Doručeno ks',
    'productDetail.productReceivingsTable.productDiffQuantity': 'Odchylka ks',
    'productDetail.productReceivingsTable.status': 'Stav',
    'productDetail.productReceivingsTable.estimatedDelivery': 'Plánované doručení',
    'productDetail.productReceivingsTable.unloadedAt': 'Datum vyložení',
    'productDetail.productReceivingsTable.receivedAt': 'Zpracovává se v',
    'productDetail.productReceivingsTable.confirmedAt': 'Datum potvrzení',
    'productDetail.productReturns': 'Vratky produktu',
    'productDetail.exportProductReturns': 'Exportovat vratky produktu',
    'productDetail.productReturnsTable.rma': 'RMA',
    'productDetail.productReturnsTable.eshopReturnId': 'E-shop ID vratky',
    'productDetail.productReturnsTable.createdAt': 'Datum vytvoření',
    'productDetail.productReturnsTable.confirmedAt': 'Datum potvrzení',
    'productDetail.productReturnsTable.status': 'Stav',
    'productDetail.productReturnsTable.quantity': 'Vráceno ks',
    'productDetail.productReturnsTable.received': 'Obdrženo ks',
    'productDetail.productReturnsTable.orderId': 'ID obj.',
    'productDetail.productReturnsTable.eshopOrderId': 'E-shop ID obj.',
    'productDetail.productReturnsTable.recipientName': 'Jméno příjemce',
    'productDetail.productReturnsTable.returnDescription': 'Popis vratky',
    'productDetail.stockMovements': 'Skladové pohyby',
    'productDetail.titleStockMovements': 'Skladové pohyby SKU: {{SKU}}',
    'productDetail.exportStockMovements': 'Exportovat skladové pohyby',
    'productDetail.stockMovementsTable.id': 'ID',
    'productDetail.stockMovementsTable.createdAt': 'Datum pohybu',
    'productDetail.stockMovementsTable.type': 'Typ pohybu',
    'productDetail.stockMovementsTable.count': 'Množství',
    'productDetail.stockMovementsTable.expirationDate': 'Datum expirace',
    'productDetail.stockMovementsTable.lot': 'Šarže',
    'productDetail.stockMovementType.stock_correction': 'Korekce zásob',
    'productDetail.stockMovementType.completition': 'Kompletace',
    'productDetail.stockMovementType.order': 'Objednávka',
    'productDetail.stockMovementType.return': 'Vratka',
    'productDetail.stockMovementType.receiving': 'Příjem',
    'productDetail.stockMovementType.inventory': 'Inventura',
    'productDetail.stockMovementType.quality_hold': 'Zadrženo kvalitou',
    'productDetail.stockMovementType.quality_release': 'Uvolněno kvalitou',

    // Stock movement type codes for filtering
    'utils.stockMovementTypeCodes.stock_correction': 'Korekce zásob',
    'utils.stockMovementTypeCodes.completition': 'Kompletace',
    'utils.stockMovementTypeCodes.order': 'Objednávka',
    'utils.stockMovementTypeCodes.return': 'Vratka',
    'utils.stockMovementTypeCodes.receiving': 'Příjem',
    'utils.stockMovementTypeCodes.quality_hold': 'Zadrženo kvalitou',
    'utils.stockMovementTypeCodes.quality_release': 'Uvolněno kvalitou',

    // Client type codes
    'utils.clientTypeCodes.custom': 'Vlastní',
    'utils.clientTypeCodes.standard': 'Standardní',

    // Business field codes
    'utils.businessFieldCodes.electronics': 'Elektronika',
    'utils.businessFieldCodes.footwear': 'Obuv',
    'utils.businessFieldCodes.fashion': 'Móda',
    'utils.businessFieldCodes.cosmeticsAndPerfumes': 'Kosmetika a parfémy',
    'utils.businessFieldCodes.foodSupplements': 'Potravinové doplňky',
    'utils.businessFieldCodes.foodAndBeverages': 'Potraviny a nápoje',
    'utils.businessFieldCodes.healthcare': 'Zdravotnictví',
    'utils.businessFieldCodes.kids': 'Děti',
    'utils.businessFieldCodes.workEquipment': 'Pracovní vybavení',
    'utils.businessFieldCodes.drugstore': 'Drogerie',
    'utils.businessFieldCodes.merch': 'Merch',
    'utils.businessFieldCodes.packagingAndAccessories': 'Balení a příslušenství',

    // Contract term codes
    'utils.contractTermCodes.indefinite': 'Na dobu neurčitou',
    'utils.contractTermCodes.specificDate': 'Na dobu určitou',

    'productsImport.title': 'Import produktu',
    'productsImport.error': 'Chyba',
    'productsImport.excelFilePattern': 'Stáhnout šablonu pro import:',
    'productsImport.import': 'Importovat produkty',
    'productsImport.importConfirm': 'Opravdu chcete Importovat produkty?',
    'productsImport.columnsOptions': 'Možnosti sloupců',
    'productsImport.table.results': 'Výsledky',
    'productsImport.table.id': 'ID',
    'productsImport.table.sku': 'SKU',
    'productsImport.table.name': 'Název',
    'productsImport.table.productType': 'Typ produktu',
    'productsImport.table.ean': 'EAN',
    'productsImport.table.expeditionMethod': 'Expediční metoda',
    'productsImport.table.action': 'Akce',
    'productsImport.action.create': 'Upravit',
    'productsImport.action.update': 'Vytvořit',
    'productsImport.totalCountToImport': 'Počet produktů pro import - vytvořit: {{create}} upravit: {{update}}',
    'productsImport.totalCountImported': 'Počet importovaných produktů - vytvořeno: {{created}} upraveno: {{updated}}',
    'productsImport.tab.general': 'Všeobecné',
    'productsImport.tab.created': 'Vytvořeno',
    'productsImport.tab.updated': 'Upraveno',

    'productSets.table.setSku': 'SKU Sady',
    'productSets.table.setName': 'Název sady',
    'productSets.table.skuCount': 'Počet SKU',
    'productSets.table.productsCount': 'Počet kusů produktů',
    'productSets.title': 'Sady produktů',
    'productSets.action.productSetDetail': 'Detail sady produktů',
    'productSets.action.dowloadProductSetsTable': 'Export sad produktů',
    'productSets.action.exportFileName': 'Export sad produktů',
    'productSets.action.synchronizeTable': 'Synchronizovat tabulku',
    'productSets.action.createNew': 'Nová',

    'productSetDetail.title': 'Detail sady produktů {{setSKU}}',
    'productSetDetail.titleNew': 'Vytvořit novou sady produktů',
    'productSetDetail.action.create': 'Vytvořit',
    'productSetDetail.action.save': 'Uložit',
    'productSetDetail.action.delete': 'Smazat sadu produktů',
    'productSetDetail.action.detail': 'Detail',
    'productSetDetail.create': 'Vytvořit sadu produktů',
    'productSetDetail.createConfirm': 'Opravdu chcete vytvořit sadu produktů?',
    'productSetDetail.delete': 'Smazat sadu produktů',
    'productSetDetail.deleteConfirm': 'Opravdu chcete smazat tuto sadu produktů?',
    'productSetDetail.setSku': 'SKU sady produktů',
    'productSetDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem sady produktů',
    'productSetDetail.confirmGetNewDataStorageText': 'Máte uložený návrh sady produktů - chcete s ním pokračovat?',
    'productSetDetail.productsTable.productSku': 'Produkt SKU | název',
    'productSetDetail.productsTable.productCount': 'počet kusů produktů',
    'productSetDetail.action.removeProduct': 'Smazat produkt',
    'productSetDetail.action.addProduct': 'Přidat produkt',
    'productSetDetail.productsTable.action.add': 'Přidat',
    'productSetDetail.save': 'Uložit sadu produktů',
    'productSetDetail.saveConfirm': 'Opravdu chcete uložit tuto sadu produktů?',
    'productSets.message.productSetUpdate': 'Sada produktů byla uložena',
    'productSets.message.productSetCreated': 'Sada produktů byla vytvořena',
    'productSets.message.productSetDeleted': 'Sada produktů byla smazána',

    'productStockTransfersDetail.title': 'Převody skladových zásob #{{idProduct}}',
    'productStockTransfersDetail.productsTable.id': 'ID',
    'productStockTransfersDetail.productsTable.snapshotDate': 'Datum',
    'productStockTransfersDetail.productsTable.stockQuantity': 'Skladové množství',
    'productStockTransfersDetail.productsTable.description': 'Popis',

    'billsOfMaterial.title': 'Kusovníky',
    'billsOfMaterial.titlePrduct': 'Kusovníky produktu {{idProduct}}',
    'billsOfMaterial.action.billOfMaterialsDetail': 'Detail kusovníku',
    'billsOfMaterial.action.createNew': 'Nový',
    'billsOfMaterial.action.synchronizeTable': 'Synchronizovat tabulku',
    'billsOfMaterial.action.dowloadBillsOfMaterialsTable': 'Export kusovníků',
    'billsOfMaterial.action.exportFileName': 'Export kusovníků',
    'billsOfMaterial.table.id': 'ID',
    'billsOfMaterial.table.finalProductSku': 'Finální produkt SKU',
    'billsOfMaterial.table.name': 'Název',
    'billsOfMaterial.table.createdAt': 'Vytvořen',
    'billsOfMaterial.table.active': 'Aktivní',

    'billOfMaterialsDetail.title': 'Detail kusovníku {{idBillOfMaterials}}',
    'billOfMaterialsDetail.titleNew': 'Vytvořit nový kusovník',
    'billOfMaterialsDetail.create': 'Vytvořit kusovník',
    'billOfMaterialsDetail.createConfirm': 'Opravdu chcete vytvořit kusovník?',
    'billOfMaterialsDetail.save': 'Uložit kusovník',
    'billOfMaterialsDetail.saveConfirm': 'Opravdu chcete uložit tento kusovník?',
    'billOfMaterialsDetail.action.create': 'Vytvořit',
    'billOfMaterialsDetail.action.save': 'Uložit',
    'billOfMaterialsDetail.action.addBillOfMaterials': 'Přidat',
    'billOfMaterialsDetail.name': 'Název',
    'billOfMaterialsDetail.finalProduct': 'Finální produkt',
    'billOfMaterialsDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem kusovníku',
    'billOfMaterialsDetail.confirmGetNewDataStorageText': 'Máte uložený návrh kusovníku - chcete s ním pokračovat?',
    'billOfMaterialsDetail.productsTable.product': 'Produkt',
    'billOfMaterialsDetail.productsTable.count': 'Množství',
    'billOfMaterialsDetail.productsTable.action.add': 'Přidat',
    'billOfMaterialsDetail.productsTable.action.addProduct': 'Přidat produkt',
    'billOfMaterialsDetail.productsTable.action.removeProduct': 'Odebrat produkt',
    'billsOfMaterials.message.billOfMaterialsCreated': 'Kusovník byl vytvořen',
    'billsOfMaterials.message.billOfMaterialsUpdated': 'Kusovník byl uložen',

    'transports.title': 'Přeprava',
    'transports.allProviders': 'Všechny e-shopy',
    'transports.tab.transports': 'Přepravy',
    'transports.tab.packageTypes': 'Typy balení',
    'transports.tab.palletTypes': 'Typy palet',
    'transports.tab.geisPackingTypes': 'Geis typy balení',
    'transports.action.transportDetail': 'Detail přepravy',
    'transports.action.createNew': 'Nová',
    'transports.action.synchronizeTable': 'Synchronizovat tabulku',
    'transports.action.exportFileName': 'Export přepravy',
    'transports.action.exportFile': 'Export přepravy',
    'transports.table.id': 'ID',
    'transports.table.shipper': 'Dopravce',
    'transports.table.shipperService': 'Služba dopravce',
    'transports.table.status': 'Stav',
    'transports.table.type': 'Typ',
    'transports.table.item': 'ID položky',
    'transports.table.createdAt': 'Datum vytvoření',
    'transports.table.sender': 'Odesílatel',
    'transports.table.recipient': 'Příjemce',

    'transports.message.transportCreated': 'Přeprava byla vytvořena',
    'transports.message.transportUpdate': 'Přeprava byla uložena',
    'transports.message.orderShipmentSuccess': 'Doprava byla úspěšně objednána',

    'transportPackageTypes.title': 'Typy balení',
    'transportPackageTypes.action.createNew': 'Nový',
    'transportPackageTypes.action.detail': 'Detail typu balení',
    'transportPackageTypes.action.reload': 'Obnovit',
    'transportPackageTypes.action.sync': 'Synchronizovat typy z dopravce',
    'transportPackageTypes.action.syncCatalogue': 'Synchronizovat katalog',
    'transportPackageTypes.message.synced': 'Typy balení byly synchronizovány',
    'transportPackageTypes.message.syncedCatalogue': 'Katalog typů balení byl synchronizován',
    'transportPackageTypes.table.ssrcCode': 'Kód',
    'transportPackageTypes.table.name': 'Název',
    'transportPackageTypes.table.geisCode': 'Geis kód',
    'transportPackageTypes.table.type': 'Typ',
    'transportPackageTypes.table.billingGroup': 'Fakturační skupina',
    'transportPackageTypes.table.active': 'Aktivní',
    'transportPackageTypes.table.sortOrder': 'Pořadí',
    'transportPackageTypes.table.syncedAt': 'Synchronizováno',

    'transportPackageTypeDetail.title': 'Detail typu balení {{ssrcCode}}',
    'transportPackageTypeDetail.titleNew': 'Nový typ balení',
    'transportPackageTypeDetail.action.save': 'Uložit',
    'transportPackageTypeDetail.action.deactivate': 'Deaktivovat',
    'transportPackageTypeDetail.deactivateConfirm': 'Opravdu chcete tento typ balení deaktivovat?',
    'transportPackageTypeDetail.ssrcCode': 'Kód',
    'transportPackageTypeDetail.name': 'Název',
    'transportPackageTypeDetail.geisCode': 'Geis kód',
    'transportPackageTypeDetail.type': 'Typ',
    'transportPackageTypeDetail.sortOrder': 'Pořadí',
    'transportPackageTypeDetail.active': 'Aktivní',
    'transportPackageTypeDetail.nameCs': 'Název CS',
    'transportPackageTypeDetail.nameEn': 'Název EN',
    'transportPackageTypeDetail.billingGroup': 'Fakturační skupina',
    'transportPackageTypeDetail.typeCs': 'Typ CS',
    'transportPackageTypeDetail.unitCs': 'Jednotka CS',
    'transportPackageTypeDetail.message.created': 'Typ balení byl vytvořen',
    'transportPackageTypeDetail.message.updated': 'Typ balení byl uložen',
    'transportPackageTypeDetail.message.deactivated': 'Typ balení byl deaktivován',

    'palletTypes.title': 'Typy palet',
    'palletTypes.action.reload': 'Obnovit',
    'palletTypes.message.loadError': 'Typy palet se nepodařilo načíst',
    'palletTypes.message.saveError': 'Mapování typu palety se nepodařilo uložit',
    'palletTypes.table.name': 'Název',
    'palletTypes.table.packageType': 'Typ balení',

    'geisPackingTypes.title': 'Geis typy balení',
    'geisPackingTypes.action.reload': 'Obnovit',
    'geisPackingTypes.action.sync': 'Synchronizovat z Geis',
    'geisPackingTypes.action.detail': 'Detail Geis typu balení',
    'geisPackingTypes.message.loadError': 'Geis typy balení se nepodařilo načíst',
    'geisPackingTypes.message.emptyHint': 'Nejdřív synchronizujte Geis typy balení',
    'geisPackingTypes.message.mappingsSaved': 'Mapování typů balení bylo uloženo',
    'geisPackingTypes.message.mappingsError': 'Mapování typů balení se nepodařilo uložit',
    'geisPackingTypes.table.code': 'Kód',
    'geisPackingTypes.table.name': 'Název',
    'geisPackingTypes.table.packageTypes': 'Typy balení',
    'geisPackingTypes.table.returnable': 'Vratný',
    'geisPackingTypes.table.active': 'Aktivní',
    'geisPackingTypes.table.syncedAt': 'Synchronizováno',

    'geisPackingTypeDetail.title': 'Detail Geis typu balení {{code}}',
    'geisPackingTypeDetail.action.save': 'Uložit',
    'geisPackingTypeDetail.code': 'Kód',
    'geisPackingTypeDetail.name': 'Název',
    'geisPackingTypeDetail.returnable': 'Vratný',
    'geisPackingTypeDetail.active': 'Aktivní',
    'geisPackingTypeDetail.packageTypes': 'Typy balení',
    'geisPackingTypeDetail.packageTypesHint': 'Vyberte typy balení, které se mapují na tento Geis kód',
    'geisPackingTypeDetail.message.loadError': 'Geis typ balení se nepodařilo načíst',

    'transportDetail.title': 'Detail přepravy #{{idTransport}}',
    'transportDetail.titleNew': 'Vytvořit novou přepravu',
    'transportDetail.eshopTransportId': 'E-shop ID přepravy',
    'transportDetail.action.save': 'Uložit',
    'transportDetail.action.create': 'Vytvořit',
    'transportDetail.action.orderShipment': 'Objednat dopravu',
    'transportDetail.action.orderShipmentPending': 'Objednávání probíhá',
    'transportDetail.shipperFromOrderHint': 'Přebírá se z objednávky – upravte na detailu objednávky',
    'transportDetail.action.cloneTransport': 'Klonovat přepravu',
    'transportDetail.action.showLabel': 'Zobrazit štítek',
    'transportDetail.createTransport': 'Vytvořit přepravu',
    'transportDetail.paidTransport': 'Přeprava zaplacená',
    'transportDetail.paidTransportOptions': 'Možnosti zaplacení přepravy',
    'transportDetail.action.addPackage': 'Přidat balík',
    'transportDetail.action.removePackage': 'Odebrat balík',
    'transportDetail.action.nextStep': 'Další krok',
    'transportDetail.action.prevStep': 'Zpět',
    'transportDetail.tab.transport': 'Přeprava',
    'transportDetail.tab.history': 'Historie',
    'transportDetail.tab.transportHistory': 'Historie dopravy',
    'transportDetail.tab.packages': 'Balíky',
    'transportDetail.tab.address': 'Adresa',
    'transportDetail.tab.summary': 'Shrnutí',
    'transportDetail.tab.apiCalls': 'API volání',
    'transportDetail.tab.events': 'Události',
    'transportDetail.status.created': 'Vytvořeno',
    'transportDetail.status.shippingCreated': 'Doprava objednána',
    'transportDetail.status.onTheWay': 'Na cestě',
    'transportDetail.status.atPickupPoint': 'Na výdejním místě',
    'transportDetail.status.delivered': 'Doručeno',

    'transportDetail.linkedOrders.title': 'Propojené objednávky',
    'transportDetail.linkedOrders.id': 'ID',
    'transportDetail.linkedOrders.eshopOrderId': 'ID objednávky e-shop',
    'transportDetail.linkedOrders.role': 'Role',
    'transportDetail.linkedOrders.roleSystem': 'Systémová',
    'transportDetail.linkedOrders.roleManual': 'Manuální',
    'transportDetail.linkedOrders.orderDetail': 'Detail objednávky',
    'transportDetail.detail': 'Detail přepravy',
    'transportDetail.invoice': 'Fakturace',
    'transportDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem přepravy',
    'transportDetail.confirmGetNewDataStorageText': 'Máte uložený návrh přepravy - chcete s ním pokračovat?',

    'transportDetail.packagesCurrency': 'Měna balíků',
    'transportDetail.transport': 'Přeprava',
    'transportDetail.cashOnDelivery': 'Dobírka',
    'transportDetail.recipientInfo': 'Informace o příjemci',
    'transportDetail.senderInfo': 'Informace o odesílateli',
    'transportDetail.detailInfo': 'Detailní informace',
    'transportDetail.contact': 'Kontakt',
    'transportDetail.placeOfDelivery': 'Doručovací adresa',
    'transportDetail.senderAddress': 'Odesílací adresa',
    'transportDetail.recipientFullName': 'Jméno a příjmení příjemce',
    'transportDetail.senderFullName': 'Jméno a příjmení odesílatele',
    'transportDetail.recipientStreet': 'Doručovací adresa (ulice, číslo)',
    'transportDetail.senderStreet': 'Odesílací adresa (ulice, číslo)',
    'transportDetail.showContacts': 'Zobrazit kontakty',
    'transportDetail.selectProviderCompanyrecipient': 'Zvolte kontakt příjemce (Jméno a příjmení / Kontaktní osoba / Název firmy)',
    'transportDetail.selectProviderCompanysender': 'Zvolte kontakt odesílatele (Jméno a příjmení / Kontaktní osoba / Název firmy)',
    'transportDetail.summary': 'Přehled',
    'transportDetail.type': 'Typ',
    'transportDetail.transportStatus': 'Stav přepravy',
    'transportDetail.idItem': 'ID položky',
    'transportDetail.executeAt': 'Datum připomenutí',
    'transportDetail.pickupDate': 'Datum svozu',
    'transportDetail.pickUpAt': 'Datum vyzvednutí',
    'transportDetail.billedWeight': 'Účtovaná hmotnost/kg',
    'transportDetail.trackingNumber': 'Sledovací číslo',
    'transportDetail.shipperLabel': 'Zobrazit přepravní štítek',
    'transportDetail.shipperLabelDownload': 'Stáhnout soubor přepravního štítku',
    'transportDetail.agecheck': 'Kontrola věku (18+)',
    'transportDetail.incorrectMessage': 'Chybová hláška',
    'transportDetail.paymentMethod': 'Způsob platby',
    'transportDetail.paid': 'Zaplaceno',
    'transportDetail.created': 'Datum vytvoření',
    'transportDetail.shippingCreatedAt': 'Datum objednání dopravy',
    'transportDetail.losted': 'Datum ztráty',
    'transportDetail.delivered': 'Datum dodání',
    'transportDetail.incorrected': 'Datum chyby',
    'transportDetail.onTheWayAt': 'Datum na cestě',
    'transportDetail.returnedBackAt': 'Datum vrácení',
    'transportDetail.returningBackAt': 'Datum zahájení vratky',
    'transportDetail.invoiceNumber': 'Číslo faktury',
    'transportDetail.invoicePrice': 'Fakturovaná cena',
    'transportDetail.invoicePriceCurrency': 'Měna faktury',
    'transportDetail.invoiceDate': 'Datum fakturace',
    'transportDetail.shipper': 'Dopravce',
    'transportDetail.shipperService': 'Služba dopravce',
    'transportDetail.dispensingPoint': 'Výdejní místo',
    'transportDetail.shippingPrice': 'Cena přepravy',
    'transportDetail.shippingPriceCurrency': 'Měna přepravy',
    'transportDetail.currency': 'Měna',
    'transportDetail.transportPaidBySkladon': 'Přeprava placená Skladonem',
    'transportDetail.boxCount': 'Počet krabic',
    'transportDetail.shipmentPending': 'Objednává se doprava?',
    'transportDetail.cashOnDeliveryReferentionNumber': 'Variabilní symbol dobírky',
    'transportDetail.cashOnDeliveryPrice': 'Cena dobírky',
    'transportDetail.cashOnDeliveryCurrency': 'Měna dobírky',
    'transportDetail.cashOnDeliveryRefNumber': 'Variabilní symbol dobírky',
    'transportDetail.fullName': 'Celé jméno',
    'transportDetail.attentionName': 'Kontaktní osoba',
    'transportDetail.addressAdditionalInfo': 'Dodatečné informace o adrese',
    'transportDetail.addressAdditionalInfo2': 'Dodatečné informace o adrese 2',
    'transportDetail.address': 'Adresa',
    'transportDetail.additionalInformationForAddress2': 'Dodatečné informace o adrese',
    'transportDetail.city': 'Město',
    'transportDetail.country': 'Stát',
    'transportDetail.provinceCode': 'Provinční kód',
    'transportDetail.postCode': 'Směrovací číslo',
    'transportDetail.email': 'E-mail',
    'transportDetail.phone': 'Telefon',
    'transportDetail.companyName': 'Název firmy',
    'transportDetail.message': 'Zpráva',
    'transportDetail.filterTrackingNumber': 'Filtrovat sledovací číslo',
    'transportDetail.weight': 'Hmotnost/kg',
    'transportDetail.unit': 'Jednotka',
    'transportDetail.canceledAt': 'Zrušeno v',
    'transportDetail.updatedAt': 'Upraveno v',
    'transportDetail.lastStatusCheckAt': 'Poslední kontrola stavu',
    'transportDetail.companyId': 'ID společnosti',
    'transportDetail.taxId': 'DIČ',

    'transportDetail.addPackage': 'Přidat balík',
    'transportDetail.packageTable.action.add': 'Přidat',
    'transportDetail.packageTable.action.addPackage': 'Přidat balík',
    'transportDetail.packageTable.status': 'Stav',
    'transportDetail.packageTable.currency': 'Měna',
    'transportDetail.packageTable.trackingNumber': 'Sledovací číslo',
    'transportDetail.packageTable.warehouseTrackingNumber': 'Skladové číslo',
    'transportDetail.packageTable.openTracking': 'Otevřít sledování',
    'transportDetail.packageTable.packageType': 'Typ balení',
    'transportDetail.packageTable.weight': 'Hmotnost/kg',
    'transportDetail.packageTable.volume': 'Objem/m³',
    'transportDetail.packageTable.loadingMeters': 'Ložné metry',
    'transportDetail.packageTable.width': 'Šířka/m',
    'transportDetail.packageTable.height': 'Výška/m',
    'transportDetail.packageTable.length': 'Hloubka/m',
    'transportDetail.packageTable.price': 'Cena',
    'transportDetail.packageTable.boxNumber': 'Číslo expedičního boxu',
    'transportDetail.packageTable.actions': 'Akce',
    'transportDetail.packageTable.lineState': 'Stav',

    'transportDetail.apiCalls.empty': 'Žádná API volání',
    'transportDetail.apiCalls.table.calledAt': 'Čas',
    'transportDetail.apiCalls.table.shipper': 'Dopravce',
    'transportDetail.apiCalls.table.operation': 'Operace',
    'transportDetail.apiCalls.table.httpStatus': 'HTTP',
    'transportDetail.apiCalls.table.durationMs': 'ms',
    'transportDetail.apiCalls.table.errorMessage': 'Chyba',
    'transportDetail.apiCalls.action.showDetail': 'Detail',
    'transportDetail.apiCalls.detailTitle': 'API volání #{{id}} · {{operation}}',
    'transportDetail.apiCalls.detail.request': 'Request',
    'transportDetail.apiCalls.detail.response': 'Response',
    'transportDetail.apiCalls.detail.jsonHint': 'JSON je formátovaný a lze ho zkopírovat.',

    'transportDetail.events.empty': 'Žádné události',
    'transportDetail.events.table.occurredAt': 'Čas události',
    'transportDetail.events.table.status': 'Stav',
    'transportDetail.events.table.shipperStatusCode': 'Kód dopravce',
    'transportDetail.events.table.shipperStatusText': 'Text dopravce',
    'transportDetail.events.table.source': 'Zdroj',
    'transportDetail.events.table.location': 'Lokalita',
    'transportDetail.events.table.packageId': 'ID balíku',

    'transportDetail.history.PACKAGES.new': 'Nový balík',
    'transportDetail.history.PACKAGES.edit': 'Upraven balík',

    'transportDetail.confirmPaidAction': 'Změnit způsob platby',
    'transportDetail.confirmPaidActionText':
        'Změnou způsobu platby dojde k aktualizaci objednávky bez uložení ostatních zadaných změn.',
    'transportDetail.confirmPaidActionText2': 'Jste si jistí, že chcete nyní změnit způsob platby?',
    'transportDetail.confirmPaidActionTextCOD':
        'Jste si jisti, že chcete změnit doručení na dobírku? Prosím vyplňte informace níže:',
    'transportDetail.releaseFromSuspendedAt': 'Nastavte datum uvolnění',

    'transportDetail.history.createTransport': 'Přeprava vytvořena',
    'transportDetail.history.updateTransport': 'Přeprava upravena',
    'transportDetail.history.updateTransportToStatus': 'Upraven stav přepravy {{STATUS.old}} -> {{STATUS.new}}',
    'transportDetail.history.updateTransportStatusSucces':
        'Objednání dopravy bylo úspěšné: {{STATUS.old}} -> {{STATUS.new}}',
    'transportDetail.history.updateTransportStatusFailure':
        'Objednání dopravy bylo neúspěšné: {{STATUS.old}} -> {{STATUS.new}}',
    'transportDetail.history.errorWhileWrittingToDB': 'Chyba během zápisu dat do databáze: {{errorData}}',
    'transportDetail.history.recipient': 'Příjemce',
    'transportDetail.history.sender': 'Odesílatel',
    'transportDetail.history.newPackage': 'Nový balík',
    'transportDetail.history.editPackage': 'Upravený balík',

    'transportDetail.paidAction.transferPaymentPaid': 'Bankovním převodem - zaplaceno',
    'transportDetail.paidAction.transferPaymentNotPaid': 'Bankovním převodem - nezaplaceno',
    'transportDetail.paidAction.cashOnDelivery': 'Dobírka',
    'transportDetail.paidAction.onlinePaymentPaid': 'Kartou online - zaplaceno',
    'transportDetail.paidAction.onlinePaymentNotPaid': 'Kartou online - nezaplaceno',
    'transportDetail.paidAction.transferPaymentSend': 'Platba převodem je připravena k odeslání',
    'transportDetail.emptyData': 'Neobsahuje data',

    'users.title': 'Správa uživatelů',
    'users.action.createNew': 'Nový',
    'users.exportFileName': 'Export uživatelů',
    'users.action.synchronizeTable': 'Synchronizovat tabulku',
    'users.action.userDetail': 'Detail uživatele',
    'users.action.permissionsDetail': 'Detail oprávnění',
    'users.action.notificationsDetail': 'Detail notifikacií',
    'users.message.userCreated': 'Uživatel byl vytvořen',
    'users.message.userUpdate': 'Uživatel byl uložen',
    'users.message.userDeleted': 'Uživatel byl smazán',
    'users.messages.userActive': 'Uživatel aktivován',
    'users.messages.userDeactive': 'Uživatel deaktivován',
    'users.message.userNotificationsUpdate': 'Notifikace uživatele byly uloženy',
    'users.message.userPermissionsUpdate': 'Oprávnění uživatele byly uloženy',
    'users.table.id': 'ID',
    'users.table.name': 'Jméno',
    'users.table.surname': 'Příjmení',
    'users.table.emailAddress': 'E-mail',
    'users.table.role': 'Role',
    'users.table.dateCreated': 'Datum vytvoření',
    'users.table.status': 'Stav',
    'users.table.photo': ' ',
    'users.table.skladonUser': 'Skladon zaměstnanec',
    'users.table.eshops': 'E-shopy',
    'users.table.phone': 'Telefon',
    'users.table.lastLogin': 'Poslední přihlášení',
    'users.table.lastChangedPassword': 'Změna hesla',
    'users.table.creatorId': 'ID tvůrce',
    'users.table.lang': 'Jazyk notifikací',
    'users.table.actions': 'Akce',

    'userDetail.titleNew': 'Vytvořit nového uživatele',
    'userDetail.title': 'Detail uživatele #{{idUser}}',
    'userDetail.createUser': 'Vytvořit uživatele',
    'userDetail.save': 'Uložit uživatele',
    'userDetail.create': 'Vytvořit uživatele',
    'userDetail.createConfirm': 'Opravdu chcete vytvořit uživatele?',
    'userDetail.saveConfirm': 'Opravdu chcete uložit tento uživatele?',
    'userDetail.action.save': 'Uložit',
    'userDetail.action.create': 'Vytvořit',
    'userDetail.name': 'Jméno',
    'userDetail.surname': 'Příjmení',
    'userDetail.email': 'E-mail',
    'userDetail.roles': 'Role',
    'userDetail.active': 'Aktivní',
    'userDetail.street': 'Adresa (ulice, číslo)',
    'userDetail.city': 'Město',
    'userDetail.state': 'Stát',
    'userDetail.postCode': 'Směrovací číslo',
    'userDetail.phone': 'Telefonní číslo',
    'userDetail.companyId': 'ID firmy',
    'userDetail.taxId': 'DIČ',
    'userDetail.skladonUser': 'Skladon zaměstnanec',
    'userDetail.providers': 'E-shopy',
    'userDetail.allProviders': 'Všechny e-shopy',
    'userDetail.providersNotificate': 'Notifikované e-shopy',
    'userDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem uživatele',
    'userDetail.confirmGetNewDataStorageText': 'Máte uložený návrh uživatele - chcete s ním pokračovat?',

    'userNotificationsDetail.title': 'Upravit notifikace uživatele #{{idUser}} - {{email}}',
    'userNotificationsDetail.titleTree': 'Všechny notifikace',
    'userNotificationsDetail.save': 'Uložit',
    'userNotificationsDetail.saveConfirm': 'Opravdu chcete uložit notifikace pro tohoto uživatele?',

    'userNotificationsDetail.tree.email': 'E-mail',
    'userNotificationsDetail.tree.push': 'Push',
    'userNotificationsDetail.tree.CLAIM': 'Reklamace',
    'userNotificationsDetail.tree.CREATE': 'Vytvoření',
    'userNotificationsDetail.tree.REMINDER': 'Připomínka',
    'userNotificationsDetail.tree.UPDATE': 'Změna',
    'userNotificationsDetail.tree.UPDATE_STATUS': 'Změna stavu',
    'userNotificationsDetail.tree.JOB': 'Práce ',
    'userNotificationsDetail.tree.ORDER': 'Objednávky',
    'userNotificationsDetail.tree.SENT_TODAY_B2B': 'B2B - Odesláno dnes ',
    'userNotificationsDetail.tree.SENT_TODAY_B2C': 'B2C - Odesláno dnes',
    'userNotificationsDetail.tree.PALLETS': 'Palety',
    'userNotificationsDetail.tree.SHIPPING': 'Dopravci',
    'userNotificationsDetail.tree.ZASILKOVNA': 'Zásilkovna',
    'userNotificationsDetail.tree.INVALID_DISPESING_POINT': 'Chybné výdejní místo',
    'userNotificationsDetail.tree.PRODUCT': 'Produkty',
    'userNotificationsDetail.tree.TRASH_EVENT_RECORDED': 'Chyby produktů / EANů',
    'userNotificationsDetail.tree.ROP': 'Bod přeobjednání',
    'userNotificationsDetail.tree.EXPIRATION_DAYS': 'Upozornění na expiraci',
    'userNotificationsDetail.tree.RECEIVING': 'Příjmy zboží',
    'userNotificationsDetail.tree.UPDATE_PRODUCTS_INCOMPLETE': 'Neúplný příjem zboží',
    'userNotificationsDetail.tree.UPDATE_STATUS_CONFIRMED': 'Potvrzeno',
    'userNotificationsDetail.tree.RETURN': 'Vratky',
    'userNotificationsDetail.tree.STOCK_TAKING': 'Inventura ',
    'userNotificationsDetail.tree.TRANSPORT': 'Přeprava',
    'userNotificationsDetail.tree.CANCELED': 'Zrušena',
    'userNotificationsDetail.tree.CREATED': 'Vytvořena',
    'userNotificationsDetail.tree.DELIVERED': 'Doručena',
    'userNotificationsDetail.tree.INNCORRECT': 'Chyba',
    'userNotificationsDetail.tree.INCORRECT': 'Chyba',
    'userNotificationsDetail.tree.LOST': 'Ztracena',
    'userNotificationsDetail.tree.ONTHEWAY': 'Na cestě',
    'userNotificationsDetail.tree.ATPICKUPPOINT': 'Na výdejním místě',
    'userNotificationsDetail.tree.RETURNEDBACK': 'Vráceno zpět',
    'userNotificationsDetail.tree.RETURNINGBACK': 'Vrací se zpět',
    'userNotificationsDetail.tree.SHIPPINGCREATED': 'Doprava objednána',
    'userNotificationsDetail.tree.WAITINGFORPAYMENT': 'Čeká na platbu',
    'userNotificationsDetail.tree.SUSPENDED': 'Pozastavena',
    'userNotificationsDetail.tree.WAITINGFORSHIPMENT': 'Objednává se doprava',
    'userNotificationsDetail.tree.RECEIVED': 'Přijata',
    'userNotificationsDetail.tree.INPROCESS': 'Zpracovává se',
    'userNotificationsDetail.tree.PACKED': 'Zabalena',
    'userNotificationsDetail.tree.WAITINGFORCARRIER': 'Čeká na dopravce',
    'userNotificationsDetail.tree.PRERECEIVED': 'Čeká na zpracování',
    'userNotificationsDetail.tree.PREORDER': 'Předobjednávka',

    'userNotificationsDetail.tree.UNLOADED': 'Vyloženo',
    'userNotificationsDetail.tree.CONFIRMED': 'Potvrzeno',
    'userNotificationsDetail.tree.ACCEPTEDWAITINGFORCOMPENSATIONFROMSHIPPER': 'Akceptována - očekáváme kompenzaci',
    'userNotificationsDetail.tree.ACCEPTEDPENDINGCLIENTCOMPENSATION': 'Akceptována - čeká na kompenzaci klientovi',
    'userNotificationsDetail.tree.STORNO': 'Zrušena',
    'userNotificationsDetail.tree.PRODUCTSNOTAVAILABLE': 'Nedostupné produkty',
    'userNotificationsDetail.tree.ACCEPTED': 'Akceptována',
    'userNotificationsDetail.tree.MOREINFONEEDED': 'Nedostačující informace',
    'userNotificationsDetail.tree.REJECTED': 'Zamítnuta',

    'userPermissionsDetail.title': 'Upravit uživatelská oprávnění #{{idUser}}',
    'userPermissionsDetail.action.save': 'Uložit',
    'userPermissionsDetail.save': 'Uložit uživatelská oprávnění',
    'userPermissionsDetail.saveConfirm': 'Opravdu chcete uložit oprávnění pro tohto uživatele?',
    'userPermissionsDetail.titleTree': 'Oprávnění',
    'userPermissionsDetail.name': 'Jméno',
    'userPermissionsDetail.surname': 'Příjmení',
    'userPermissionsDetail.roles': 'Role',

    'admin.roles': 'Role',
    'admin.permissions': 'Oprávnění',
    'admin.providers': 'E-shopy',
    'admin.system': 'System',
    'admin.constants': 'Konstanty',
    'admin.applicationStatusMessages': 'Zprávy aplikace',
    'admin.emailTemplates': 'Šablony e-mailů',

    'roles.title': 'Role',
    'roles.action.synchronizeTable': 'Synchronizovat role',
    'roles.action.createNew': 'Nová',
    'roles.table.id': 'ID',
    'roles.table.name': 'Název',
    'roles.table.info': 'Info',
    'roles.table.countPermissions': 'Oprávnění',
    'roles.table.actions': 'Akce',
    'roles.action.roleDetail': 'Detail role',
    'roles.action.roleApprovedDetail': 'Povolené role',
    'roles.message.roleCreated': 'Role byla vytvořena',
    'roles.message.roleUpdate': 'Role byla uložena',

    'roleDetail.titleNew': 'Vytvořit novou roli',
    'roleDetail.title': 'Upravit roli #{{idRole}}',
    'roleDetail.create': 'Vytvořit roli',
    'roleDetail.save': 'Uložit',
    'roleDetail.createConfirm': 'Opravdu chcete vytvořit roli?',
    'roleDetail.saveConfirm': 'Opravdu chcete uložit tuto roli?',
    'roleDetail.name': 'Název',
    'roleDetail.info': 'Info',

    'permissions.title': 'Oprávnění',
    'permissions.permissionDetail': 'Detail oprávnění',
    'permissions.action.createNew': 'Nový',
    'permissions.action.synchronizeTable': 'Synchronizovat oprávnění',
    'permissions.message.permissionCreated': 'Oprávnění bylo vytvořeno',
    'permissions.message.permissionUpdate': 'Oprávnění bylo uloženo',
    'permissions.message.permissionDeleted': 'Oprávnění bylo smazáno',
    'permissions.PRODUCT.EXP_METHOD.EDIT': 'Editace expediční metody produktu',
    'permissions.ORDER.EXPORT.TABLE': 'Exportovat objednávky',
    'permissions.ORDER.EXPORT.PRODUCTS': 'Exportovat objednávky s produkty',
    'permissions.ORDER.EXPORT.PRODUCTS_SUMMARIZED': 'Exportovat objednávky s produkty sumarizované',
    'permissions.ORDER.EXPORT.EXPEDITION_PACKAGE': 'Export expedičních balíků',
    'permissions.ORDER.EXPORT.EXPEDITION_PACKAGE_PRODUCTS': 'Export expedičních balíků s produkty',
    'permissions.CLAIM.EXPORT.TABLE': 'Exportovat reklamace',
    'permissions.CLAIM.EXPORT.PRODUCTS': 'Exportovat reklamace s produkty',
    'permissions.CLAIM.CREATE_MULTIPLE': 'Vytvořit více reklamací k jedné objednávce',
    'permissions.RETURN.EXPORT.TABLE': 'Exportovat vratky',
    'permissions.RETURN.EXPORT.PRODUCTS': 'Exportovat vratky s produkty',
    'permissions.RECEIVING.EXPORT.TABLE': 'Exportovat příjmy',
    'permissions.RECEIVING.EXPORT.PRODUCTS': 'Exportovat příjmy s produkty',
    'permissions.PRODUCT.EXPORT': 'Exportovat produkty',
    'permissions.PROVIDER.EXPORT': 'Exportovat e-shopy',

    'permissionDetail.titleNew': 'Vytvořit nové oprávnění',
    'permissionDetail.title': 'Upravit oprávnění #{{idPermission}}',
    'permissionDetail.pid': 'Detail oprávnění',
    'permissionDetail.description': 'Popis',
    'permissionDetail.create': 'Vytvořit oprávnění',
    'permissionDetail.save': 'Uložit',
    'permissionDetail.createConfirm': 'Opravdu chcete vytvořit oprávnění?',
    'permissionDetail.saveConfirm': 'Opravdu chcete uložit toto oprávnění?',
    'permissionDetail.deletePermission': 'Smazat oprávnění',
    'permissionDetail.deletePermissionConfirm': 'Opravdu chcete smazat toto oprávnění?',

    'providers.title': 'E-shopy',
    'providers.providers': 'E-shopy',
    'providers.providersWaiting': 'Shoptet e-shopy čekající na registraci',
    'providers.action.providerDetail': 'Detail e-shopu',
    'providers.action.createNew': 'Nový',
    'providers.action.synchronizeTable': 'Synchronizovat tabulku',
    'providers.action.providerConfig': 'E-shop konfigurace',
    'providers.action.providerIntegrationConfig': 'Integrační konfigurace',
    'providers.action.exportFile': 'Export e-shopů',
    'providers.action.exportFileName': 'Export e-shopu',

    'providers.message.providerCreated': 'E-shop byl vytvořen',
    'providers.message.providerUpdate': 'E-shop byl uložen',

    'providers.table.id': 'ID',
    'providers.table.idDcix': 'DCIx ID',
    'providers.table.eshopName': 'Název e-shopu',
    'providers.table.businessName': 'Obchodní název společnosti',
    'providers.table.website': 'Internetové stránky',
    'providers.table.email': 'E-mail',
    'providers.table.system': 'Platforma',
    'providers.table.actions': 'Akce',
    'providers.table.active': 'Aktivní',
    'providers.table.enableReturnLabels': 'Povolit vratkové štítky',
    'providers.table.returnLabelsForAllOrders': 'Vratkové štítky pro všechny obj.',

    // Provider detail table translations
    'providers.table.providerDetail.clientType': 'Typ klienta',
    'providers.table.providerDetail.businessField': 'Obor podnikání',
    'providers.table.providerDetail.salesRepresentative': 'Obchodní zástupce',
    'providers.table.providerDetail.keyAccountManager': 'Key Account Manager',
    'providers.table.providerDetail.billingPostCode': 'Fakturační směrovací číslo',
    'providers.table.providerDetail.contactNumber': 'Kontaktní číslo',
    'providers.table.providerDetail.billingEmail': 'Fakturační e-mail',
    'providers.table.providerDetail.contractSigningDate': 'Datum podpisu smlouvy',
    'providers.table.providerDetail.contractTerm': 'Délka smlouvy',
    'providers.table.providerDetail.contractEndDate': 'Konec smlouvy',
    'providers.table.providerDetail.invoiceDueDays': 'Splatnost faktury (ve dnech)',
    'providers.table.providerDetail.noticePeriodMonths': 'Výpovědní lhůta (v měsících)',
    'providers.table.providerDetail.slaAlzaShipping': 'SLA Alza doprava',

    // Additional provider detail table translations
    'providers.table.providerDetail.virtualEshopParent': 'Nadřazený e-shop providera',
    'providers.table.providerDetail.eshopKey': 'E-shop key',
    'providers.table.providerDetail.shoptetStockRatio': 'Quantity stock ratio',
    'providers.table.providerDetail.allowedOrderProductsEdit': 'Editace produktů v objednávkách',
    'providers.table.providerDetail.enableReturnLabels': 'Povolit vratkové štítky',
    'providers.table.providerDetail.printReturnLabel': 'Vratkové štítky pro všechny obj.',
    'providers.table.providerDetail.underSanctionEnabled': 'Objednávka pod sankcí',
    'providers.table.providerDetail.allowDisableShippingReorder': 'Externí TN (Marketplace) - neobjednávat dopravu',
    'providers.table.providerDetail.customsWarehouseEnabled': 'Celní sklad',
    'providers.table.providerDetail.dcixExportPersonalData': 'Export osobních dat do DCIx u objednávky',
    'providers.table.providerDetail.orderProductDetail': 'Detail produktu objednávky (přizpůsobení)',
    'providers.table.providerDetail.printFiles': 'Tisk souborů',
    'providers.table.providerDetail.updateAllStock': 'Update all stock',
    'providers.table.providerDetail.receivingPostponeHours': 'Receiving SLA',
    'providers.table.providerDetail.b2cSla': 'B2C SLA',
    'providers.table.providerDetail.b2bSla': 'B2B SLA',
    'providers.table.providerDetail.b2bD0': 'B2B D0',
    'providers.table.providerDetail.b2bD1': 'B2B D1',
    'providers.table.providerDetail.b2bD2': 'B2B D2',
    'providers.table.providerDetail.b2bD3': 'B2B D3',
    'providers.table.providerDetail.contactPerson': 'Kontaktní osoba',
    'providers.table.providerDetail.phone': 'Kontaktní číslo',
    'providers.table.providerDetail.street': 'Adres (ulice číslo)',
    'providers.table.providerDetail.city': 'Město',
    'providers.table.providerDetail.postCode': 'Směrovací číslo',
    'providers.table.providerDetail.state': 'Stát',
    'providers.table.providerDetail.billingStreet': 'Fakturační adresa (ulice, číslo)',
    'providers.table.providerDetail.billingCity': 'Fakturační město',
    'providers.table.providerDetail.billingState': 'Fakturační stát',
    'providers.table.providerDetail.companyId': 'IČ',
    'providers.table.providerDetail.taxId': 'DIČ/VAT',
    'providers.table.providerDetail.eori': 'EORI',
    'providers.table.providerDetail.GLN': 'GLN',
    'providers.table.providerDetail.status': 'Stav',
    'providers.table.providerDetail.plannedLaunch': 'Plánované spuštění',
    'providers.table.providerDetail.actualLaunch': 'Reálné spuštění',
    'providers.table.providerDetail.plannedOffboarding': 'Plánovaný OFFboarding',
    'providers.table.providerDetail.actualOffboarding': 'Reálný OFFboarding',
    'providers.table.providerDetail.shownInMys': 'Zobrazeno v MyS',

    'providerDetail.title': 'Upravit e-shop #{{idProvider}} - {{eshopName}}',
    'providerDetail.titleNew': 'Vytvořit nový e-shop',
    'providerDetail.action.save': 'Uložit',
    'providerDetail.action.create': 'Vytvořit',
    'providerDetail.createProvider': 'Vytvořit e-shop',
    'providerDetail.editProvider': 'Uložit e-shop',
    'providerDetail.provider': 'Dodavatel',
    'providerDetail.shoptetOrderStatus': 'Shoptet stav objednávky',
    'providerDetail.shoptetPaymentMethods': 'Shoptet platební metody',
    'providerDetail.shoptetStock': 'Shoptet sklad',
    'providerDetail.shoptetShippingMethods': 'Shoptet způsoby přepravy',
    'providerDetail.updateDataFromShoptet': 'Upravit data ze Shoptetu',
    'providerDetail.businessName': 'Obchodní název společnosti',
    'providerDetail.eshopName': 'Název e-shopu',
    'providerDetail.email': 'E-mail',
    'providerDetail.providerWebsite': 'Internetové stránky',
    'providerDetail.street': 'Adresa (ulice, číslo)',
    'providerDetail.city': 'Město',
    'providerDetail.state': 'Stát',
    'providerDetail.postCode': 'Směrovací číslo',
    'providerDetail.printFiles': 'Tisk souborů',
    'providerDetail.orderProductDetail': 'Detail produktu objednávky (přizpůsobení)',
    'providerDetail.orderProductFiles': 'Detail produktu objednávky',
    'providerDetail.enableReturnLabels': 'Povolit vratkové štítky',
    'providerDetail.printReturnLabel': 'Vratkové štítky pro všechny obj.',
    'providerDetail.underSanctionEnabled': 'Objednávky pod sankcí',
    'providerDetail.branchIdEnabled': 'ID pobočky (B2Bc)',
    'providerDetail.GLN': 'GLN',
    'providerDetail.EORI': 'EORI',
    'providerDetail.contactPerson': 'Kontaktní osoba',
    'providerDetail.allowExpedition': 'Povolit expedici',
    'providerDetail.allowedOrderProductsEdit': 'Editace produktů v objednávkách',
    'providerDetail.sendRecipientEmailB2BSend': 'Poslat příjemci e-mail o odeslání objednávky B2B',
    'providerDetail.sendRecipientEmailB2CSend': 'Poslat příjemci e-mail o odeslání objednávky B2C',
    'providerDetail.serviceCodes': 'Služby dopravců',
    'providerDetail.serviceCodesOther': 'Ostatní',
    'providerDetail.companyId': 'IČO',
    'providerDetail.taxId': 'DIČ',
    'providerDetail.billingStreet': 'Fakturační adresa (ulice, číslo)',
    'providerDetail.billingCity': 'Fakturační město',
    'providerDetail.billingState': 'Fakturační stát',
    'providerDetail.phone': 'Telefon',
    'providerDetail.system': 'Systém',
    'providerDetail.stockId': 'ID skladu',
    'providerDetail.users': 'Uživatelé',
    'providerDetail.usersNotificate': 'Notifikováni',
    'providerDetail.detail': 'Detail',
    'providerDetail.contract': 'Smluvní ujednání',
    'providerDetail.sla': 'SLA',
    'providerDetail.it': 'IT',
    'providerDetail.transport': 'Přeprava',
    'providerDetail.history': 'Historie',
    'providerDetail.emails': 'E-maily',
    'providerDetail.stockName': 'Název skladu',
    'providerDetail.serviceCode': 'Kód služby',
    'providerDetail.shippingMethod': 'Způsob dopravy',
    'providerDetail.active': 'Aktivní',
    'providerDetail.demoProvider': 'Demo e-shop',
    'providerDetail.userName': 'Uživatelské jméno',
    'providerDetail.userSurname': 'Uživatelské příjmení',
    'providerDetail.virtualEshopParent': 'Nadřazený e-shop providera',
    'providerDetail.shoptetStockRatio': 'Quantity stock ratio',
    'providerDetail.dcixProviderId': 'DCIx provider ID',
    'providerDetail.allowDisableShippingReorder': 'Externí TN (Marketplace) - neobjednávat dopravu',
    'providerDetail.customsWarehouseEnabled': 'Celní sklad',
    'providerDetail.dcixExportPersonalData': 'Export osobních dat do DCIx u objednávky',
    'providerDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem e-shopu',

    // New fields
    'providerDetail.clientType': 'Typ klienta',
    'providerDetail.businessField': 'Obor podnikání',
    'providerDetail.salesRepresentative': 'Obchodní zástupce',
    'providerDetail.keyAccountManager': 'Key Account Manager',
    'providerDetail.billingPostCode': 'Fakturační směrovací číslo',
    'providerDetail.contactNumber': 'Kontaktní číslo',
    'providerDetail.billingEmail': 'Fakturační e-mail',
    'providerDetail.contractSigningDate': 'Datum podpisu smlouvy',
    'providerDetail.contractTerm': 'Délka smlouvy',
    'providerDetail.contractEndDate': 'Konec smlouvy',
    'providerDetail.invoiceDueDays': 'Splatnost faktury (ve dnech)',
    'providerDetail.noticePeriodMonths': 'Výpovědní lhůta (v měsících)',
    'providerDetail.contractWithClient': 'Smlouva s klientem',
    'providerDetail.qualityLevelAndCompensation': 'Úroveň kvality a kompenzace',
    'providerDetail.documents': 'Dokumenty',
    'providerDetail.receiptProductsDiscount': 'Příjem produktů do skladu',
    'providerDetail.returnReceiptDiscount': 'Příjem vrácených zásilek do skladu',
    'providerDetail.b2cDispatchDiscount': 'Expedice B2C objednávek',
    'providerDetail.b2bDispatchDiscount': 'Expedice B2B objednávek',
    'providerDetail.hours12to24': '12-24 hod',
    'providerDetail.hours24to48': '24-48 hod',
    'providerDetail.hours48to72': '48-72 hod',
    'providerDetail.hours72Plus': '72+ hod',
    'providerDetail.percent9795': '97,99-95 %',
    'providerDetail.percent9490': '94,99-90 %',
    'providerDetail.percent89Less': '89,99 % a méně',
    'providerDetail.products0100': '0-100 ks produktů (D+1)',
    'providerDetail.products101999': '101-999 ks produktů (D+2)',
    'providerDetail.products10004000': '1000-4000 ks produktů (D+3)',
    'providerDetail.products4001Plus': '4001 ks produktů (D+X)',
    'providerDetail.lossAndErrorRate': 'Ztráta a chybovost',
    'providerDetail.acceptableLossPercent': 'Akceptovatelná ztráta v %',
    'providerDetail.errorRatePercent': 'Přirozená chybovost v %',
    'providerDetail.slaAlzaShipping': 'SLA Alza doprava',
    'providerDetail.confirmGetNewDataStorageText': 'Máte uložený návrh e-shopu - chcete s ním pokračovat?',

    // Additional missing fields for history
    'providerDetail.publicId': 'Veřejné ID',
    'providerDetail.eshopKey': 'Klíč e-shopu',
    'providerDetail.logo': 'Logo',
    'providerDetail.bankAccountNo': 'Číslo bankovního účtu',
    'providerDetail.eori': 'EORI',

    'providerDetail.externalDcixImport': 'Externí DCIx import',
    'providerDetail.updateAllStock': 'Aktualizovat všechny zásoby',
    'providerDetail.importFromStatus': 'Import ze stavu',
    'providerDetail.secondary': 'Sekundární',
    'providerDetail.defaultAllowExpedition': 'Výchozí povolení expedice',
    'providerDetail.sendRecipientEmailB2bOnTheWay': 'Poslat příjemci e-mail o odeslání B2B',
    'providerDetail.sendRecipientEmailB2cOnTheWay': 'Poslat příjemci e-mail o odeslání B2C',
    'providerDetail.receivingPostponeHours': 'Odložení příjmu (hodiny)',
    'providerDetail.b2cSla': 'B2C SLA',
    'providerDetail.b2bSla': 'B2B SLA',
    'providerDetail.b2bD0': 'B2B D0',
    'providerDetail.b2bD1': 'B2B D1',
    'providerDetail.b2bD2': 'B2B D2',
    'providerDetail.b2bD3': 'B2B D3',

    // Specific discount field translations
    'providerDetail.receiptDiscount12to24': 'Příjem produktů 12-24h (sleva %)',
    'providerDetail.receiptDiscount24to48': 'Příjem produktů 24-48h (sleva %)',
    'providerDetail.receiptDiscount48to72': 'Příjem produktů 48-72h (sleva %)',
    'providerDetail.receiptDiscount72Plus': 'Příjem produktů 72h+ (sleva %)',
    'providerDetail.returnReceiptDiscount12to24': 'Příjem vrácených 12-24h (sleva %)',
    'providerDetail.returnReceiptDiscount24to48': 'Příjem vrácených 24-48h (sleva %)',
    'providerDetail.returnReceiptDiscount48to72': 'Příjem vrácených 48-72h (sleva %)',
    'providerDetail.returnReceiptDiscount72Plus': 'Příjem vrácených 72h+ (sleva %)',
    'providerDetail.b2cDispatchDiscount9795': 'B2C expedice 97-95% (sleva %)',
    'providerDetail.b2cDispatchDiscount9490': 'B2C expedice 94-90% (sleva %)',
    'providerDetail.b2cDispatchDiscount89Less': 'B2C expedice 89% a méně (sleva %)',
    'providerDetail.b2bDispatchDiscount0100': 'B2B expedice 0-100 ks (sleva %)',
    'providerDetail.b2bDispatchDiscount101999': 'B2B expedice 101-999 ks (sleva %)',
    'providerDetail.b2bDispatchDiscount10004000': 'B2B expedice 1000-4000 ks (sleva %)',
    'providerDetail.b2bDispatchDiscount4001Plus': 'B2B expedice 4001+ ks (sleva %)',

    // Tooltip translations
    'providerDetail.receiptProductsDiscount.tooltip': 'Sleva v % se vztahuje na opožděné zalistování produktů do skladu oproti dohodnutým SLA.',
    'providerDetail.returnReceiptDiscount.tooltip': 'Sleva v % se vztahuje na opožděné zalistování vrácených produktů do skladu oproti dohodnutým SLA.',
    'providerDetail.b2cDispatchDiscount.tooltip': 'Sleva v % se vztahuje na zásilky, které nebyly expedovány v souladu s dohodnutým SLA.',
    'providerDetail.b2bDispatchDiscount.tooltip': 'Sleva v % se vztahuje na zásilky, které nebyly expedovány v souladu s dohodnutým SLA.',

    'providerDetail.emailTemplates': 'E-mailové šablony',
    'providerDetail.emailtemplates.type': 'Typ',
    'providerDetail.emailtemplates.language': 'Jazyk',
    'providerDetail.emailtemplates.templateId': 'ID šablony',
    'providerDetail.emailtemplates.actions': 'Akce',
    'providerDetail.emailtemplates.addTemplate': 'Přidat šablonu',
    'providerDetail.emailtemplates.removeTemplate': 'Odebrat šablonu',
    'providerDetail.action.nextStep': 'Další krok',
    'providerDetail.action.prevStep': 'Zpět',

    // Status and lifecycle fields
    'providerDetail.statusSection': 'Stav',
    'providerDetail.status': 'Stav',
    'providerDetail.plannedLaunch': 'Plánované spuštění',
    'providerDetail.actualLaunch': 'Reálné spuštění',
    'providerDetail.plannedOffboarding': 'Plánovaný OFFboarding',
    'providerDetail.actualOffboarding': 'Reálný OFFboarding',
    'providerDetail.shownInMys': 'Zobrazeno v MyS',
    'providerDetail.pipesInTest': 'Odesílání dat (MyS → platforma)',
    'providerDetail.pipesActive': 'Stahování dat (platforma → MyS)',
    'providerDetail.pipesUpload.yes': 'Ano',
    'providerDetail.pipesUpload.no': 'Ne',
    'providerDetail.pipesDownload.yes': 'Ano',
    'providerDetail.pipesDownload.no': 'Ne',

    // Provider status codes
    'utils.providerStatusCodes.created': 'Vytvořeno',
    'utils.providerStatusCodes.onboarding': 'Probíhá ONboarding',
    'utils.providerStatusCodes.active': 'Aktivní',
    'utils.providerStatusCodes.scheduledOffboarding': 'Naplánovaný OFFboarding',
    'utils.providerStatusCodes.inactiveDataExport': 'Neaktivní - pouze export dat',
    'utils.providerStatusCodes.inactiveNoTransfers': 'Neaktivní - žádné přenosy dat',
    'utils.providerStatusCodes.storedGoodsOnly': 'Uskladněné zboží - bez objednávek',

    'providerDetail.history.Provider created': 'Vytvořen e-shop',
    'providerDetail.history.Provider updated': 'Upraven e-shop',

    'providerConfigDetail.title': 'E-shop konfigurace #{{idProvider}} - {{eshopName}}',
    'providerConfigDetail.action.save': 'Uložit e-shop konfiguraci',
    'providerConfigDetail.action.newStructureItem': 'Nová struktura konfigurace',
    'providerConfigDetail.message.update': 'Konfigurace byla uložena',
    'providerConfigDetail.message.missingSystem': 'E-shop nemá nastavený integrační systém (SYSTEM). Konfiguraci nelze načíst ani uložit.',
    'providerConfigDetail.confirm.deleteKeysTitle': 'Smazat konfigurační klíče?',
    'providerConfigDetail.confirm.deleteKeysText': 'Uložením se smažou následující klíče, které nejsou ve formuláři vyplněné:\n{{keys}}',
    'providerConfig.mappedShippingMethodsOnly': 'Pouze namapované dopravy',
    'providerConfig.allowOrdersWithoutPaymentMethod': 'Povolit objednávky bez platební metody',

    'system.title': 'System',
    'system.config': 'Kongifurace',

    'systemConfigDetail.titleTree': 'Struktura konfigurace',
    'systemConfigDetail.editStructureItem': 'Upravit položku struktury konfigurace',
    'systemConfigDetail.newStructureItem': 'Nová struktura konfigurace',
    'systemConfigDetail.title': 'Systemová konfigurace',
    'systemConfigDetail.save': 'Uložit',
    'systemConfigDetail.enabledShippers.none': 'Žádný dopravce',
    'systemConfigDetail.enabledShippers.title': 'Dopravci objednávaní přes transport-ms',
    'systemConfigDetail.message.update': 'Konfigurace byla uložena',
    'systemConfigDetail.message.applicationInstalled': 'E-shop nainstalován do Pipes',
    'systemConfigDetail.message.applicationActivated': 'E-shop aktivován v Pipes',
    'systemConfigDetail.message.applicationDeactivated': 'E-shop deaktivován v Pipes',
    'systemConfigDetail.action.installApplication': 'Instalovat do Pipes',
    'systemConfigDetail.action.activateApplication': 'Aktivace e-shopu v Pipes',
    'systemConfigDetail.action.deactivateApplication': 'Deaktivace e-shopu v Pipes',
    'systemConfigDetail.action.activateApplicationConfirm': 'Opravdu chcete AKTIVOVAT tento e-shop v Pipes?\n\nAktuální hodnoty:\nActive: {{active}}\nInTest: {{inTest}}\n\nStahování / odesílání dat platforma <-> MyS se aktivuje.',
    'systemConfigDetail.action.deactivateApplicationConfirm': 'Opravdu chcete změnit nastavení tohoto e-shopu v Pipes?\n\nAktuální hodnoty:\nActive: {{active}}\nInTest: {{inTest}}\n\nStahování / odesílání dat platforma <-> MyS bude deaktivováno.',
    'systemConfigDetail.action.activateApplicationLabel': 'Nastavte hodnoty pro Pipes:',
    'systemConfigDetail.action.activeLabel': 'Active',
    'systemConfigDetail.action.inTestLabel': 'InTest',
    'systemConfigDetail.action.downloadLabel': 'Stahování (platforma → MyS)',
    'systemConfigDetail.action.uploadLabel': 'Odesílání (MyS → platforma)',
    'systemConfigDetail.action.statusActive': 'AKTIVNÍ',
    'systemConfigDetail.action.statusInactive': 'NEAKTIVNÍ',
    'systemConfig.newStructureItem': 'Nová položka struktury konfigurace',
    'systemConfig.action.saveStuctureItem': 'Uložit položku struktury konfigurace',
    'systemConfig.editStructureItem': 'Upravit položku struktury konfigurace',
    'systemConfig.action.addStuctureItem': 'Přidat položku struktury konfigurace',
    'systemConfig.structure.key': 'Klíč',
    'systemConfig.structure.type': 'Typ',
    'systemConfig.structure.description': 'Popis',
    'systemConfig.messages.keyAlreadyUsed': 'Klíč již byl použit v jiné položce',

    'constants.title': 'Konstanty',
    'constants.action.constantDetail': 'Detail konstanty',
    'constants.table.name': 'Název',
    'constants.table.count': 'Info',
    'constants.message.constantUpdate': 'Konstanta byla uložena',

    'constantDetail.title': 'Upravit konstantu: {{constantKey}}',
    'constantDetail.action.save': 'Uložit',
    'constantDetail.table.label': 'Štítek',
    'constantDetail.table.value': 'Hodnota',
    'constantDetail.table.shipperCode': 'Kód dopravce',
    'constantDetail.table.color': 'Barva',
    'constantDetail.table.editOrder': 'Upravit objednávku',
    'constantDetail.table.ORDER_INT': 'Pořadí',
    'constantDetail.table.awaiting': 'Očekáváno',
    'constantDetail.table.shipper': 'Dopravce',
    'constantDetail.table.lang': 'Jazyk',
    'constantDetail.table.countryCodesSelect': 'Stát',
    'constantDetail.table.isReturn': 'Vrácení',
    'constantDetail.table.isExpedition': 'Expedice',
    'constantDetail.action.addItem': 'Přidat položku',
    'constantDetail.action.removeItem': 'Odebrat položku',
    'constantDetail.addItem': 'Přidat položku',
    'constantDetail.removeItem': 'Odebrat položku',
    'constantDetail.itemsTable.action.add': 'Přidat',
    'constantDetail.save': 'Uložit konstantu',
    'constantDetail.saveConfirm': 'Opravdu chcete uložit tuto konstantu?',

    'error.enableEditOrderInStatus': 'Tuto objednávku nelze upravit',
    'error.empty': 'Tato hodnota nesmí být prázdná',
    'error.wrongValue': 'Chybná hodnota',
    'error.notNumber': 'Není číslo',
    'error.isNegative': 'Tato hodnota nesmí být záporná',
    'error.wrongRequiredNumberValue': 'Tato hodnota nesmí být 0 nebo desetinné číslo',
    'error.exceededMaxLength': 'Překročena maximální délka {{length}} znaků',

    'profil.title': 'Profil uživatele #{{userId}} - {{email}}',
    'profil.changePassword': 'Změnit heslo',
    'profil.save': 'Uložit',
    'profil.basicDataTitle': 'Základní údaje',
    'profil.profilePictureTitle': 'Profilový obrázek',
    'profil.notificationsTitle': 'Notifikace',
    'profil.addressTitle': 'Adresa (nepovinné)',
    'profil.languageTitle': 'Jazyk notifikací',
    'profil.name': 'Jméno',
    'profil.surname': 'Příjmení',
    'profil.phone': 'Tel. číslo',
    'profil.userEmail': 'E-mail',
    'profil.role': 'Role',
    'profil.street': 'Adresa (ulice, číslo)',
    'profil.city': 'Město',
    'profil.state': 'Stát',
    'profil.postCode': 'PSČ',
    'profil.language': 'Vyberte jazyk notifikací',

    'changePassword.title': 'Změna hesla',
    'changePassword.oldPassword': 'Staré heslo',
    'changePassword.newPassword': 'Nové heslo',
    'changePassword.comparePassword': 'Potvrďte nové heslo',
    'changePassword.sumbit': 'Uložit heslo',
    'changePassword.logout': 'Odhlášení',
    'changePassword.incorretPasswordText':
        'Nové heslo musí mít více než 7 znaků a musí obsahovat malé a velké písmena a číslo',
    'changePassword.incorretPasswordMatchText': 'Hesla se neshodují',

    'tasks.title': 'Seznam úkolů',
    'tasks.action.synchronizeTable': 'Synchronizovat tabulku',
    'tasks.action.confirm': 'Potvrdit úkol',
    'tasks.action.orderDetail': 'Detail objednávky',
    'tasks.action.receivingDetail': 'Detail příjmu zboží',
    'tasks.action.claimDetail': 'Detail reklamace',
    'tasks.action.productsList': 'Seznam produktů',
    'tasks.table.check': ' ',
    'tasks.table.id': 'ID',
    'tasks.table.section': 'Oblast',
    'tasks.table.text': 'Text úkolu',
    'tasks.table.createdAt': 'Datum vytvoření',
    'tasks.table.waitingDays': 'Čeká dní',
    'tasks.table.status': 'Stav',
    'tasks.table.state': 'Status',
    'tasks.sections.ORDER': 'Objednávka',
    'tasks.sections.RECEIVING': 'Příjem zboží',
    'tasks.sections.CLAIM': 'Reklamace',
    'tasks.sections.PRODUCT': 'Produkt',
    'tasks.text.PRODUCT.ROP': 'Počet kusů zboží skladem poklesl pod nastavenou hranici bodu přeobjednání',
    'tasks.text.CLAIM.UPDATE_STATUS.ACCEPTED': 'Reklamace {{ID}} akceptována',
    'tasks.text.CLAIM.UPDATE_STATUS.INPROCESS': 'Probíhá zpracování reklamace {{ID}}',
    'tasks.text.CLAIM.UPDATE_STATUS.REJECTED': 'Reklamace {{ID}} zamítnuta',
    'tasks.text.CLAIM.UPDATE_STATUS.MOREINFONEEDED': 'Nedostačující informace k reklamaci {{ID}}',
    'tasks.text.ORDER.UPDATE_STATUS.INCORRECT': 'Chybná data v objednávce {{ID}}',
    'tasks.text.ORDER.UPDATE_STATUS.PRODUCTSNOTAVAILABLE': 'Nedostupné produkty v objednávce {{ID}}',
    'tasks.text.CLAIM.UPDATE_STATUS.ACCEPTEDWAITINGFORCOMPENSATIONFROMSHIPPER': 'Reklamace {{ID}} akceptována - očekáváme kompenzaci',
    'tasks.text.CLAIM.UPDATE_STATUS.ACCEPTEDPENDINGCLIENTCOMPENSATION': 'Reklamace {{ID}} akceptována - čeká na kompenzaci klientovi',
    'tasks.text.CLAIM.UPDATE_STATUS.STORNO': 'Reklamace {{ID}} zrušena',
    'tasks.text.ORDER.UPDATE_STATUS.WAITINGFORPAYMENT': 'Objednávka {{ID}} čeká na platbu',
    'tasks.text.ORDER.UPDATE_STATUS.CANCELED': 'Objednávka {{ID}} zrušena',
    'tasks.text.ORDER.UPDATE_STATUS.SUSPENDED': 'Objednávka {{ID}} pozastavena',
    'tasks.text.ORDER.UPDATE_STATUS.WAITINGFORSHIPMENT': 'Objednává se doprava pro objednávku {{ID}}',
    'tasks.text.ORDER.UPDATE_STATUS.RECEIVED': 'Objednávka {{ID}} přijata',
    'tasks.text.ORDER.UPDATE_STATUS.INPROCESS': 'Probíhá zpracování objednávky {{ID}}',
    'tasks.text.ORDER.UPDATE_STATUS.PACKED': 'Objednávka {{ID}} zabalena',
    'tasks.text.ORDER.UPDATE_STATUS.WAITINGFORCARRIER': 'Objednávka {{ID}} čeká na dopravce',
    'tasks.text.ORDER.UPDATE_STATUS.ONTHEWAY': 'Objednávka {{ID}} je na cestě',
    'tasks.text.ORDER.UPDATE_STATUS.ATPICKUPPOINT': 'Objednávka {{ID}} je na výdejním místě',
    'tasks.text.ORDER.UPDATE_STATUS.LOST': 'Objednávka {{ID}} ztracena',
    'tasks.text.ORDER.UPDATE_STATUS.RETURNINGBACK': 'Objednávka {{ID}} se vrací',
    'tasks.text.ORDER.UPDATE_STATUS.RETURNEDBACK': 'Objednávka {{ID}} vrácena',
    'tasks.text.ORDER.UPDATE_STATUS.PREORDER': 'Objednávka {{ID}} v předobjednávce',

    'tasks.text.ORDER.UPDATE_STATUS.DELIVERED': 'Objednávka {{ID}} doručena',
    'tasks.text.ORDER.UPDATE_STATUS.PRERECEIVED': 'Objednávka {{ID}} čeká na zpracování',
    'tasks.text.RECEIVING.UPDATE_STATUS.UNLOADED': 'Příjem zboží {{ID}} vyložen',
    'tasks.text.RECEIVING.UPDATE_STATUS.RECEIVED': 'Probíhá zpracování příjmu zboží {{ID}}',
    'tasks.text.RECEIVING.UPDATE_STATUS.CONFIRMED': 'Příjem zboží {{ID}} potvrzen',
    'tasks.text.RECEIVING.UPDATE_STATUS.CANCELED': 'Příjem zboží {{ID}} zrušen',
    'tasks.text.RETURN.UPDATE_STATUS.RECEIVED': 'Probíhá zpracování vratky {{ID}}',
    'tasks.text.RETURN.UPDATE_STATUS.CONFIRMED': 'Vratka {{ID}} potvrzena',
    'tasks.text.RETURN.UPDATE_STATUS.CANCELED': 'Vratka {{ID}} zrušena',
    'tasks.text.RECEIVING.NOTDELIVEREDATTIME': 'Příjem zboží {{ID}} nedorazil v předpokládaném čase doručení',
    'tasks.text.RECEIVING.DIFFERENCE_PRODUCTS': 'Příjem zboží {{ID}} obsahuje rozdílné množství produktů',
    'tasks.text.PRODUCT.EXPIRATION_DAYS': 'Produkty s blížícím se datem expirace',
    'documents.title': 'Dokumenty',
    'documents.dowload': 'Stáhnout',
    'documents.show': 'Zobrazit',
    'documents.instruction.title': 'MySkladon manuál',
    'documents.instruction.text': 'Uživatelský manuál k aplikaci MySkladon',
    'documents.instruction.file': 'user_manual_CZ.pdf',
    'documents.customerCareComunication.title': 'Freshdesk manuál',
    'documents.customerCareComunication.text': 'Zákaznický servis - Help Desk',
    'documents.customerCareComunication.file': 'customer_care_CZ.pdf',
    'documents.customerCareClaims.title': 'Reklamační řád',
    'documents.customerCareClaims.text': 'Seznámení s Reklamačním oddělením a postupy pro řešení reklamací',
    'documents.customerCareClaims.file': 'claims_manual_CZ.pdf',
    'documents.feedback.title': 'Zpětná vazba / Report problému',
    'documents.feedback.text': 'Formulář pro zaslání zpětné vazby / report problému',
    'documents.feedback.file': 'zpetna_vazba.pdf',
    'documents.incorrectOrders.title': 'Jak na objednávky s chybou',
    'documents.incorrectOrders.text': 'Nejčastější chybové hlášky objednávek a jejich řešení',
    'documents.incorrectOrders.file': 'incorrect_orders_CZ.pdf',
    'documents.downloading': 'Exportuji data...',

    'commands.productCompletionSheets': 'Kompletační listy produktů',

    'productCompletionSheets.title': 'Kompletační listy produktů',
    'productCompletionSheets.action.createNew': 'Nový',
    'productCompletionSheets.action.productCompletionSheetDetail': 'Detail kompletačního listu produktů',
    'productCompletionSheets.action.synchronizeTable': 'Synchronizovat tabulku',
    'productCompletionSheets.table.id': 'ID',
    'productCompletionSheets.table.status': 'Stav',
    'productCompletionSheets.table.createdAt': 'Vytvořeno',
    'productCompletionSheets.table.completedUntil': 'Kompletovano do',

    'productCompletionSheetDetail.title': 'Upravit kompletační list produktů #{{idProductCompletionSheet}}',
    'productCompletionSheetDetail.titleNew': 'Vytvořit nový kompletační list produktů',
    'productCompletionSheetDetail.create': 'Vytvořit kompletační list produktů',
    'productCompletionSheetDetail.save': 'Uložit kompletační list produktů',
    'productCompletionSheetDetail.createConfirm': 'Opravdu chcete vytvořit kompletační list produktů?',
    'productCompletionSheetDetail.saveConfirm': 'Opravdu chcete uložit tento kompletační list produktů?',
    'productCompletionSheetDetail.status': 'Stav',
    'productCompletionSheetDetail.completedUntil': 'Kompletováno do',
    'productCompletionSheetDetail.confirmGetNewDataStorage': 'Pokračovat s návrhem kompletačního listu produktů',
    'productCompletionSheetDetail.confirmGetNewDataStorageText':
        'Máte uložený návrh kompletačního listu produktů - chcete s ním pokračovat?',
    'productCompletionSheetDetail.action.create': 'Vytvořit',
    'productCompletionSheetDetail.action.save': 'Uložit',

    'productCompletionSheetDetail.finalProductsTable.finalProduct': 'Konečný produkt',
    'productCompletionSheetDetail.finalProductsTable.billOfMaterials': 'Kusovník',
    'productCompletionSheetDetail.finalProductsTable.count': 'Množství',
    'productCompletionSheetDetail.finalProductsTable.lot': 'Lot',
    'productCompletionSheetDetail.finalProductsTable.status': 'Stav',
    'productCompletionSheetDetail.finalProductsTable.completedAt': 'Kompletováno',
    'productCompletionSheetDetail.finalProductsTable.action.removeProduct': 'Odebrat produkt',
    'productCompletionSheetDetail.finalProductsTable.action.addProduct': 'Přidat produkt',
    'productCompletionSheetDetail.action.addBillOfMaterials': 'Přidat konečný produkt',
    'productCompletionSheetDetail.finalProductsTable.action.add': 'Přidat',
    'productCompletionSheets.message.productCompletionSheetCreated': 'Kompletační list byl vytvořen',
    'productCompletionSheets.message.productCompletionSheetUpdate': 'Kompletační list byl uložen',

    'settings.skladonMapping': 'Mapování ',
    'settings.widgets': 'Widgety',
    'settings.providerCompanies': 'Kontakty',
    'settings.providerTransferCompanies': 'Partneři pro přesun zboží',
    'settings.webhooks': 'Webhooky',
    'settings.webhookRecords': 'Záznamy',
    'settings.webhookHistory': 'Historie',

    'webhooks.title': 'Webhooky',
    'webhooks.action.createNew': 'Nový',
    'webhooks.action.synchronizeTable': 'Synchronizovat tabulku',
    'webhooks.action.webhookDetail': 'Upravit webhook',
    'webhooks.message.webhookActivated': 'Webhook byl aktivován',
    'webhooks.message.webhookDeactivated': 'Webhook byl deaktivován',
    'webhooks.table.id': 'ID',
    'webhooks.table.webhookType': 'Typ webhooku',
    'webhooks.table.method': 'Metoda',
    'webhooks.table.payloadVersion': 'Verze payloadu',
    'webhooks.payloadVersion.v2': 'v2',
    'webhooks.payloadVersion.v21': 'v21',
    'webhooks.table.registeredAt': 'Registrováno',
    'webhooks.table.active': 'Aktivní',
    'webhooks.table.url': 'URL',
    'webhooks.table.unregisteredAt': 'Odregistrován v',
    'webhooks.table.deactivationEmailSentAt': 'Deaktivační e-mail odeslán v',
    'webhooks.webhookType.CREATE_ORDER': 'Vytvoření objednávky',
    'webhooks.webhookType.UPDATE_ORDER': 'Aktualizace objednávky',
    'webhooks.webhookType.UPDATE_ORDER_STATUS': 'Změna stavu objednávky',
    'webhooks.webhookType.CREATE_PRODUCT': 'Vytvoření produktu',
    'webhooks.webhookType.UPDATE_PRODUCT': 'Aktualizace produktu',
    'webhooks.webhookType.CREATE_RECEIVING': 'Vytvoření příjmu',
    'webhooks.webhookType.UPDATE_RECEIVING': 'Aktualizace příjmu',
    'webhooks.webhookType.UPDATE_RECEIVING_STATUS': 'Změna stavu příjmu',
    'webhooks.webhookType.CREATE_RETURN': 'Vytvoření vratky',
    'webhooks.webhookType.UPDATE_RETURN': 'Aktualizace vratky',
    'webhooks.webhookType.UPDATE_RETURN_STATUS': 'Změna stavu vratky',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_STOCK_CORRECTION': 'Skladová korekce',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_ORDER': 'Pohyb skladu – objednávka',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_RETURN': 'Pohyb skladu – vratka',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_RECEIVING': 'Pohyb skladu – příjem',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_COMPLETITION': 'Pohyb skladu – kompletace',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_QUALITY_HOLD': 'Pohyb skladu – kvalita',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_QUALITY_RELEASE': 'Pohyb skladu – uvolnění z kvality',

    'webhookDetail.titleNew': 'Vytvořit nový webhook',
    'webhookDetail.title': 'Upravit webhook #{{idWebhook}}',
    'webhookDetail.detail': 'Detail',
    'webhookDetail.history': 'Historie',
    'webhookDetail.history.Webhook created': 'Webhook vytvořen',
    'webhookDetail.history.Webhook updated': 'Webhook upraven',
    'webhookDetail.history.Webhook activated': 'Webhook aktivován',
    'webhookDetail.history.Webhook deactivated': 'Webhook deaktivován',
    'webhookDetail.history.Webhook secret regenerated': 'Secret webhooku regenerován',
    'webhookDetail.history.Webhook deleted': 'Webhook smazán',
    'webhookDetail.create': 'Vytvořit',
    'webhookDetail.save': 'Uložit',
    'webhookDetail.createConfirm': 'Opravdu chcete vytvořit nový webhook?',
    'webhookDetail.saveConfirm': 'Opravdu chcete uložit změny webhooku?',
    'webhookDetail.deleteWebhook': 'Smazat webhook',
    'webhookDetail.deleteWebhookConfirm': 'Opravdu chcete smazat tento webhook?',
    'webhookDetail.webhookType': 'Typ webhooku',
    'webhookDetail.method': 'Metoda',
    'webhookDetail.payloadVersion': 'Verze payloadu',
    'webhookDetail.active': 'Aktivní',
    'webhookDetail.url': 'URL',
    'webhookDetail.parameters': 'Parametry',
    'webhookDetail.withPackingLists': 'Odesílat balící listy',
    'webhookDetail.registeredAt': 'Registrováno',
    'webhookDetail.unregisteredAt': 'Odregistrován v',
    'webhookDetail.deactivationEmailSentAt': 'Deaktivační e-mail odeslán v',
    'webhookDetail.secretRegenerated': 'Secret regenerován',
    'webhookDetail.message.webhookCreated': 'Webhook byl vytvořen',
    'webhookDetail.message.webhookUpdate': 'Webhook byl uložen',
    'webhookDetail.message.webhookDeleted': 'Webhook byl smazán',

    'webhookRecords.title': 'Záznamy webhooků',
    'webhookRecords.mode.grouped': 'Podle události',
    'webhookRecords.mode.attempts': 'Jednotlivé pokusy',
    'webhookRecords.action.synchronizeTable': 'Synchronizovat tabulku',
    'webhookRecords.action.recordDetail': 'Detail záznamu',
    'webhookRecords.action.retry': 'Poslat znovu',
    'webhookRecords.action.retryConfirm':
        'Opravdu chcete znovu odeslat tento webhook? Použije se původní payload, ale aktuální URL a nastavení webhooku.',
    'webhookRecords.action.toggleAttempts': 'Rozbalit pokusy',
    'webhookRecords.action.copyOnDoubleClick': 'Dvojklikem zkopírovat',
    'webhookRecords.message.retryQueued': 'Opakované odeslání bylo zařazeno',
    'webhookRecords.nextRetryAt': 'Další pokus: {{time}}',
    'webhookRecords.table.sendingTime': 'Čas zaslání',
    'webhookRecords.table.eventId': 'ID události',
    'webhookRecords.table.eventIdTooltip': 'Hodnota hlavičky X-Skladon-Webhook-Id pro idempotenci',
    'webhookRecords.table.webhookType': 'Typ webhooku',
    'webhookRecords.table.method': 'Metoda',
    'webhookRecords.table.url': 'URL',
    'webhookRecords.table.attemptCount': 'Počet pokusů',
    'webhookRecords.table.attempt': 'Pokus',
    'webhookRecords.table.statusCode': 'Kód',
    'webhookRecords.table.retryRelation': 'Manuální retry',
    'webhookRecords.table.retryOf': 'Retry of',
    'webhookRecords.table.retryCreated': 'Retry',
    'webhookRecords.table.retryRequested': 'Retry vyžádán',
    'webhookRecords.table.responseMessage': 'Response',
    'webhookRecords.table.payload': 'Payload',
    'webhookRecords.table.webhookId': 'ID webhooku',
    'webhookRecords.retryBlocked.success': 'Úspěšné doručení nelze znovu odeslat',
    'webhookRecords.retryBlocked.manualRetryRequested': 'Manuální retry už byl pro tuto událost vyžádán',
    'webhookRecords.retryBlocked.autoRetryInProgress': 'Automatický retry ještě běží',

    'webhookRecordDetail.title': 'Záznam doručení {{eventId}}',
    'webhookRecordDetail.attempts': 'Průběh pokusů',
    'webhookRecordDetail.attemptsHint': 'Kliknutím na řádek zobrazíte kompletní response daného pokusu.',
    'webhookRecordDetail.attemptResponse': 'Response pokusu č. {{attempt}}',
    'webhookRecordDetail.payloadHint': 'Stejný payload se odesílá při každém pokusu.',
    'webhookRecordDetail.payload.show': 'Zobrazit payload',
    'webhookRecordDetail.payload.hide': 'Skrýt payload',
    'webhookRecordDetail.payload.format': 'Formátovat JSON',
    'webhookRecordDetail.payload.showRaw': 'Zobrazit původní',
    'webhookRecordDetail.payload.formattedHint': 'JSON je automaticky formátován a barevně zvýrazněn.',
    'webhookRecordDetail.payload.notJson': 'Payload není platný JSON, zobrazuje se jako text.',
    'webhookRecordDetail.lastAttemptAt': 'Poslední pokus',
    'webhookRecordDetail.nextRetryAt': 'Další plánovaný pokus',
    'webhookRecordDetail.retryOfEventId': 'Retry původní události',
    'webhookRecordDetail.manualRetryEventId': 'Vytvořený manuální retry',
    'webhookRecordDetail.retryUnavailable': 'Manuální retry není dostupný',
    'webhookRecordDetail.action.reload': 'Obnovit detail',
    'webhookRecordDetail.action.copy': 'Kopírovat do schránky',

    'webhookHistory.title': 'Historie webhooků',
    'webhookHistory.action.synchronize': 'Synchronizovat historii',
    'webhookHistory.webhookId': 'ID webhooku',
    'webhookHistory.webhookDetailLink': 'Detail webhooku #{{id}}',

    'messages.copiedToClipboard': 'Zkopírováno do schránky',
    'messages.copyFailed': 'Kopírování se nezdařilo',

    'skladonMapping.title': 'Skladon mapování',
    'skladonMapping.action.synchronizeTable': 'Synchronizovat tabulku',
    'skladonMapping.action.createNew': 'Nové',
    'skladonMapping.action.exportFile': 'Export Skladon mapování',
    'skladonMapping.action.exportFileName': 'Export Skladon mapování',
    'skladonMapping.action.skladonMappingDetail': 'Detail Skladon mapování',

    'skladonMapping.message.skladonMappingCreated': 'Skladon mapování bylo vytvořeno',
    'skladonMapping.message.skladonMappingUpdate': 'Skladon mapování bylo upraveno',
    'skladonMapping.message.skladonMappingDeleted': 'Skladon mapování bylo smazáno',

    'skladonMapping.table.id': 'ID',
    'skladonMapping.table.system': 'Systém',
    'skladonMapping.table.key': 'Klíč',
    'skladonMapping.table.value': 'Hodnota',
    'skladonMapping.table.name': 'Název',
    'skladonMapping.table.uid': 'UID',

    'skladonMappingDetail.titleNew': 'Vytvořit nové Skladon mapování',
    'skladonMappingDetail.title': 'Upravit Skladon mapování #{{idSkladonMapping}}',
    'skladonMappingDetail.create': 'Vytvořit nové Skladon mapování',
    'skladonMappingDetail.save': 'Uložit Skladon mapování',
    'skladonMappingDetail.createConfirm': 'Opravdu chcete vytvořit nové Skladon mapování?',
    'skladonMappingDetail.saveConfirm': 'Opravdu chcete uložit Skladon mapování?',
    'skladonMappingDetail.key': 'Klíč',
    'skladonMappingDetail.sys': 'Systém',
    'skladonMappingDetail.value': 'Hodnota',
    'skladonMappingDetail.uid': 'UID',
    'skladonMappingDetail.name': 'Název',
    'skladonMappingDetail.deleteSkladonMapping': 'Vymazat Skladon mapování ',
    'skladonMappingDetail.deleteSkladonMappingConfirm': 'Opravdu chcete vymazat toto Skladon mapování?',

    'providerCompanies.action.providerCompanyDetail': 'Detail kontaktu',
    'providerCompanies.action.synchronizeTable': 'Synchronizovat tabulku',
    'providerCompanies.action.createNew': 'Nový',
    'providerCompanies.action.exportFile': 'Export kontaktů',
    'providerCompanies.action.exportFileName': 'Kontakty',
    'providerCompanies.title': 'Kontakty',
    'providerCompanies.table.id': 'ID',
    'providerCompanies.table.recipientName': 'Jméno a příjmení',
    'providerCompanies.table.contactPerson': 'Kontaktní osoba',
    'providerCompanies.table.companyName': 'Název firmy',
    'providerCompanies.table.GLN': 'GLN',
    'providerCompanies.table.email': 'E-mail',
    'providerCompanies.table.phone': 'Telefon',
    'providerCompanies.table.companyId': 'ID společnosti',
    'providerCompanies.table.street': 'Adresa (ulice, číslo)',
    'providerCompanies.table.city': 'Město',
    'providerCompanies.table.zipCode': 'Směrovací číslo',
    'providerCompanies.table.state': 'Země',
    'providerCompanies.table.addressAdditionalInfo': 'Dodatečné informace o adrese',
    'providerCompanies.table.provinceCode': 'Provinční kód',
    'providerCompanies.table.actions': 'Akce',

    'providerTransferCompanies.action.createNew': 'Nový',
    'providerTransferCompanies.action.providerTransferCompanyDetail': 'Detail partnera pro přesun zboží',
    'providerTransferCompanies.title': 'Partneři pro přesun zboží',
    'providerTransferCompanies.table.id': 'ID partnera',
    'providerTransferCompanies.table.providerName': 'Název partnera',
    'providerTransferCompanies.action.exportFile': 'Export partnerů pro přesun zboží',
    'providerTransferCompanies.action.exportFileName': 'Partneři pro přesun zboží',
    'providerTransferCompanies.action.synchronizeTable': 'Synchronizovat tabulku',

    'providerTransferCompanyDetail.titleNew': 'Vytvořit nového partnera pro přesun zboží',
    'providerTransferCompanyDetail.title': 'Upravit partnera pro přesun zboží #{{idProviderTransferCompany}}',
    'providerTransferCompanyDetail.create': 'Vytvořit',
    'providerTransferCompanyDetail.save': 'Uložit',
    'providerTransferCompanyDetail.createConfirm': 'Opravdu chcete vytvořit nového partnera pro přesun zboží?',
    'providerTransferCompanyDetail.saveConfirm': 'Opravdu chcete uložit partnera pro přesun zboží?',
    'providerTransferCompanyDetail.deleteProviderTransferCompany': 'Vymazat partnera pro přesun zboží',
    'providerTransferCompanyDetail.deleteProviderTransferCompanyConfirm': 'Opravdu chcete vymazat tohoto partnera pro přesun zboží?',
    'providerTransferCompanyDetail.targetProviderEshopKey': 'Partner pro přesun zboží',
    'providerTransferCompanyDetail.message.providerTransferCompanyCreated': 'Partner pro přesun zboží byl vytvořen',
    'providerTransferCompanyDetail.message.providerTransferCompanyUpdate': 'Partner pro přesun zboží byl upraven',
    'providerTransferCompanyDetail.message.providerTransferCompanyDeleted': 'Partner pro přesun zboží byl vymazán',

    'providerCompanyDetail.deleteProviderCompany': 'Smazat kontakt',
    'providerCompanyDetail.deleteProviderCompanyConfirm': 'Opravdu chcete smazat tento kontakt?',
    'providerCompanyDetail.contact': 'Kontakt',
    'providerCompanyDetail.address': 'Adresa',
    'providerCompanyDetail.recipientName': 'Jméno a příjmení',
    'providerCompanyDetail.contactPerson': 'Kontaktní osoba',
    'providerCompanyDetail.companyName': 'Název firmy',
    'providerCompanyDetail.GLN': 'GLN',
    'providerCompanyDetail.email': 'E-mail',
    'providerCompanyDetail.phone': 'Telefon',
    'providerCompanyDetail.companyId': 'ID společnosti',
    'providerCompanyDetail.street': 'Adresa (ulice, číslo)',
    'providerCompanyDetail.city': 'Město',
    'providerCompanyDetail.zipCode': 'Směrovací číslo',
    'providerCompanyDetail.state': 'Země',
    'providerCompanyDetail.addressAdditionalInfo': 'Dodatečné informace o adrese',
    'providerCompanyDetail.provinceCode': 'Provinční kód',
    'providerCompanyDetail.VAT': 'DIČ',
    'providerCompanyDetail.idNumber': 'IČO',
    'providerCompanyDetail.create': 'Vytvořit',
    'providerCompanyDetail.createConfirm': 'Opravdu chcete vytvořit nový kontakt?',
    'providerCompanyDetail.save': 'Uložit',
    'providerCompanyDetail.saveConfirm': 'Opravdu chcete uložit kontakt?',
    'providerCompanyDetail.title': 'Upravit kontakt #{{idProviderCompany}}',
    'providerCompanyDetail.titleNew': 'Vytvořit nový kontakt',
    'providerCompanyDetail.message.providerCompanyCreated': 'Kontakt byl vytvořen',
    'providerCompanyDetail.message.providerCompanyUpdate': 'Kontakt byl upraven',
    'providerCompanyDetail.message.providerCompanyDeleted': 'Kontakt byl smazán',

    'reminders.title': 'Připomínky',
    'reminders.create': 'Vytvořit',
    'reminders.message.reminderCreated': 'Připomínka byla vytvořena',
    'reminders.message.reminderUpdate': 'Připomínka byla upravena',
    'reminders.message.reminderCanceled': 'Připomínka byla zrušena',
    'reminders.message.removedFromReminderAttendees': 'Byli jste odebráni z účastníků připomenutí',

    'reminderDetail.title.order': 'Připomínka na objednávku #{{idItem}}',
    'reminderDetail.title.return': 'Připomínka na vratku #{{idItem}}',
    'reminderDetail.title.claim': 'Připomínka na reklamaci #{{idItem}}',
    'reminderDetail.title.receiving': 'Připomínka na příjem zboží #{{idItem}}',
    'reminderDetail.action.create': 'Vytvořit',
    'reminderDetail.action.save': 'Uložit',
    'reminderDetail.action.cancel': 'Smazat',
    'reminderDetail.action.removeFromReminderAttendees': 'Odebrat z účastníků',
    'reminderDetail.action.close': 'Zavřít',
    'reminderDetail.title': 'Nadpis',
    'reminderDetail.text': 'Text připomínky',
    'reminderDetail.executionAt': 'Datum připomenutí',
    'reminderDetail.pushNotification': 'Push notifikace',
    'reminderDetail.emailNotification': 'E-mail notifikace',
    'reminderDetail.attendeesUsers': 'Uživatelé',

    'widget.title': 'Widgety',
    'widget.action.widgetDetail': 'Detail widgetu',
    'widget.returnWidget': 'Return widget',
    'widget.table.id': 'ID',
    'widget.table.name': 'Název',

    'returnWidgetDetail.title': 'Return widget',
    'returnWidgetDetail.textScript': 'Přidat skript na Vaši stránku:',
    'returnWidgetDetail.textElement':
        'Přidat element s parametremy id="skladon-returns-widget" a veřejné ID obsahující Vaši veřejnou ID:',
    'returnWidgetDetail.text': 'Umístěte prvek tam, kde chcete, aby se formulář zobrazil.',

    'applicationStatusMessages.title': 'Zprávy aplikace',
    'applicationStatusMessages.action.createNew': 'Nová',
    'applicationStatusMessages.action.synchronizeTable': 'Synchronizovat tabulku',
    'applicationStatusMessages.action.exportFile': 'Export zpráv aplikace',
    'applicationStatusMessages.action.exportFileName': 'Zprávy aplikace',
    'applicationStatusMessages.action.applicationStatusMessageDetail': 'Detail zprávy aplikace',
    'applicationStatusMessages.action.activate': 'Aktivovat',
    'applicationStatusMessages.action.deactivate': 'Deaktivovat',
    'applicationStatusMessages.table.id': 'ID',
    'applicationStatusMessages.table.title': 'Název',
    'applicationStatusMessages.table.createdAt': 'Datum vytvoření',
    'applicationStatusMessages.table.type': 'Typ informace',
    'applicationStatusMessages.table.notificationType': 'Typ oznámení',
    'applicationStatusMessages.table.active': 'Aktivní',
    'applicationStatusMessages.table.lang': 'Jazyk',
    'applicationStatusMessages.message.applicationStatusMessageCreated': 'Zpráva aplikace byla vytvořena',
    'applicationStatusMessages.message.applicationStatusMessageUpdate': 'Zpráva aplikace byla upravena',

    'applicationStatusMessageDetail.title': 'Upravit zprávu aplikace: {{idApplicationStatusMessage}}',
    'applicationStatusMessageDetail.titleNew': 'Vytvořit novou zprávu aplikace',
    'applicationStatusMessageDetail.create': 'Vytvořit zprávu aplikace',
    'applicationStatusMessageDetail.createConfirm': 'Opravdu chcete vytvořit zprávu aplikace?',
    'applicationStatusMessageDetail.save': 'Uložit',
    'applicationStatusMessageDetail.saveConfirm': 'Opravdu chcete uložit zprávu aplikace?',
    'applicationStatusMessageDetail.activate': 'Aktivovat zprávu aplikace',
    'applicationStatusMessageDetail.activateConfirm': 'Opravdu chcete aktivovat tuto zprávu aplikace?',
    'applicationStatusMessageDetail.deactivate': 'Deaktivovat zprávu aplikace',
    'applicationStatusMessageDetail.deactivateConfirm': 'Opravdu chcete deaktivovat tuto zprávu aplikace?',
    'applicationStatusMessageDetail.titleEdit': 'Název',
    'applicationStatusMessageDetail.text': 'Text',
    'applicationStatusMessageDetail.type': 'Typ informace',
    'applicationStatusMessageDetail.lang': 'Jazyk',
    'applicationStatusMessageDetail.notificationType': 'Typ oznámení',

    'appbar.search': 'Hledat',
    'appBar.notifications': 'Notifikace',
    'appBar.allNotifications': 'Všechny notifikace',
    'appBar.deleteAllNotifications': 'Smazat všechny',
    'appBar.deleteAllNotificationsTitle': 'Smazat všechny notifikace',
    'appBar.deleteAllNotificationsText': 'Opravdu chcete smazat všechny notifikace?',
    'appBar.deleteNotification': 'Smazat notifikaci',
    'appBar.notificationsDays': 'Před {{days}} dny',
    'appBar.notificationsHours': 'Před {{hours}} hodiny',
    'appBar.userSettings': 'Profil uživatele',
    'appBar.currentAccount': 'Aktuální e-shop',
    'appBar.switchToAccount': 'Přepnout na e-shop',
    'appBar.logout': 'Odhlášení',
    'appBar.language': 'Jazyk',
    'appBar.infoMessages': 'Zpráva aplikace: Informace',
    'appBar.warningMessages': 'Zpráva aplikace: Varování',
    'appBar.errorMessages': 'Zpráva aplikace: Chyba',
    'topBlock.actionItems': 'Více akcí',

    'table.rowsPerPage': 'Řádků na stránce',
    'table.downloadFormat': 'Vybrat formát',
    'table.showColumns': 'Zobrazit sloupce',
    'table.defaultShowColumns': 'Obnovit výchozí',
    'table.editOrderColumns': 'Upravit pořadí sloupců',
    'table.clearFilters': 'Smazat filtry',
    'table.noResults': 'Žádné výsledky nenalezeny',
    'table.total': 'Celkem',

    'paymentEdit.paymentMethod': 'Způsob platby',
    'paymentEdit.paidOrderOptions': 'Možnosti zaplacení',
    'paymentEdit.paidAction.transferPaymentPaid': 'Bankovním převodem - zaplaceno',
    'paymentEdit.paidAction.transferPaymentNotPaid': 'Bankovním převodem - nezaplaceno',
    'paymentEdit.paidAction.cashOnDelivery': 'Dobírka',
    'paymentEdit.paidAction.cashOnDeliveryPaid': 'Dobírka - zaplaceno (reklamace/výměna)',
    'paymentEdit.paidAction.cashOnDeliveryNotPaid': 'Dobírka - nezaplaceno',
    'paymentEdit.paidAction.onlinePaymentPaid': 'Kartou online - zaplaceno',
    'paymentEdit.paidAction.onlinePaymentNotPaid': 'Kartou online - nezaplaceno',
    'paymentEdit.paidAction.transferPaymentSend': 'Platba převodem je připravena k odeslání',
    'paymentEdit.paidAction.noPaymentPaid': 'Zaplaceno - bez platební metody',
    'paymentEdit.paidAction.noPaymentNotPaid': 'Nezaplaceno - bez platební metody',

    'utils.ordersType.B2COrders': 'B2C objednávky',
    'utils.ordersType.B2BOrders': 'B2B objednávky',

    'utils.orderStatusCodes.received': 'Přijata',
    'utils.orderStatusCodes.onTheWay': 'Na cestě',
    'utils.orderStatusCodes.atPickupPoint': 'Na výdejním místě',
    'utils.orderStatusCodes.inProcess': 'Zpracovává se',
    'utils.orderStatusCodes.delivered': 'Doručena',
    'utils.orderStatusCodes.canceled': 'Zrušena',
    'utils.orderStatusCodes.refunded': 'Peníze vráceny',
    'utils.orderStatusCodes.lost': 'Ztracena',
    'utils.orderStatusCodes.returningBack': 'Vrací se',
    'utils.orderStatusCodes.receivedBack': 'Přijato zpět',
    'utils.orderStatusCodes.returnedBack': 'Vrácena',
    'utils.orderStatusCodes.suspended': 'Pozastavena',
    'utils.orderStatusCodes.incorrect': 'Chyba',
    'utils.orderStatusCodes.processing': 'Čeká na zpracování',
    'utils.orderStatusCodes.processed': 'Zpracována',
    'utils.orderStatusCodes.onResend': 'Znovu odeslat',
    'utils.orderStatusCodes.refundInProcess': 'Probíhá vrácení peněz',
    'utils.orderStatusCodes.partlyReceivedBack': 'Částečně přijato zpět',
    'utils.orderStatusCodes.preReceived': 'Obdržena',
    'utils.orderStatusCodes.waitingForPayment': 'Čeká na platbu',
    'utils.orderStatusCodes.productsNotAvailable': 'Nedostupné produkty',
    'utils.orderStatusCodes.packed': 'Zabalena',
    'utils.orderStatusCodes.waitingForCarrier': 'Čeká na dopravce',
    'utils.orderStatusCodes.shoptetImport': 'Importováno Shoptetem',
    'utils.orderStatusCodes.forShipment': 'K odeslání',
    'utils.orderStatusCodes.waitingForShipment': 'Objednává se doprava',
    'utils.orderMarketplacesCodes.alza': 'Alza',
    'utils.orderMarketplacesCodes.mall': 'Mall',
    'utils.orderStatusCodes.preOrder': 'Předobjednávka',

    'utils.orderMarketplacesCodes.allegro': 'Allegro',
    'utils.orderMarketplacesCodes.kaufland': 'Kaufland',
    'utils.orderMarketplacesCodes.other': 'Ostatní',
    'utils.paymentCodes.cashOnDelivery': 'Dobírka',
    'utils.paymentCodes.visaMasterCard': 'Kartou online',
    'utils.paymentCodes.paymentOnABill': 'Bankovním převodem',

    'utils.returnStatusCodes.awaiting': 'Očekává se',
    'utils.returnStatusCodes.received': 'Zpracovává se',
    'utils.returnStatusCodes.confirmed': 'Potvrzena',
    'utils.returnStatusCodes.canceled': 'Zrušena',

    'utils.returnResolutionCodes.returnToInventory': 'Vráceno na sklad',
    'utils.returnResolutionCodes.receiveAsDamaged': 'Zadrženo kvalitou - přijata jako poškozená',
    'utils.returnResolutionCodes.onResend': 'Znovu odeslat',
    'utils.returnResolutionCodes.unknown': 'Neznámý',
    'utils.returnResolutionCodes.scrap': 'Zlikvidováno',
    'utils.returnResolutionCodes.cleanedReturnedToInventory': 'Obnoveno do původního stavu',
    'utils.returnResolutionCodes.cleanedHoldOnQuality': 'Neúspěšné obnovení do původního stavu',
    'utils.returnResolutionCodes.restoredToOriginal': '(legacy) Obnoveno do původního stavu → použijte Vráceno na sklad',
    'utils.returnResolutionCodes.failedRestoredToOriginal': '(legacy) Neúspěšné obnovení → použijte Známky používání',
    'utils.returnResolutionCodes.differentLook': 'Zadrženo kvalitou - vypadá odlišně / velikost nesedí',
    'utils.returnResolutionCodes.disposal': 'Zadrženo kvalitou - likvidace',
    'utils.returnResolutionCodes.dryCleaning': 'Zadrženo kvalitou - čistírna',
    'utils.returnResolutionCodes.signsOfUse': 'Zadrženo kvalitou - známky používání',

    'utils.claimsResolverCodes.skladon': 'Skladon logistika',
    'utils.claimsResolverCodes.skladonIT': 'Skladon IT',
    'utils.claimsResolverCodes.carrier': 'Dopravce',

    'utils.receivingDeliveryTypeCodes.courier': 'Kurýrní přeprava',
    'utils.receivingDeliveryTypeCodes.transportCompany': 'Volně ložené kartony',
    'utils.receivingDeliveryTypeCodes.truckingCompany': 'Paletizované kartony',
    'utils.receivingDeliveryTypeCodes.container': 'Kontejnerová přeprava',

    'utils.receivingUrgentCodes.OK': 'OK',
    'utils.receivingUrgentCodes.ok': 'OK',
    'utils.receivingUrgentCodes.Po Urgenci': 'Po urgenci',
    'utils.receivingUrgentCodes.Vytvořeno Skladonem': 'Vytvořeno Skladonem',
    'utils.receivingUrgentCodes.Nefakturovat': 'Nefakturováno',
    'utils.receivingUrgentCodes.afterUrgent': 'Po urgenci',
    'utils.receivingUrgentCodes.createdBySkladon': 'Vytvořeno Skladonem',
    'utils.receivingUrgentCodes.notInvoiced': 'Nefakturováno',
    'utils.receivingUrgentCodes.recievedWithoutAsn': 'Přijato bez ASN',

    'utils.receivingTypeCodes.piece_mix': 'Kusový (mix SKU) - přepočet zboží po kusech',
    'utils.receivingTypeCodes.carton_single': 'Kartonový (single SKU) - příjem zboží po celých kartonech',
    'utils.receivingTypeCodes.carton_mix': 'Kartonový (mix SKU) - příjem zboží po celých kartonech',
    'utils.receivingTypeCodes.pallet_single': 'Paletový (single SKU) - příjem zboží po celých paletách',
    'utils.receivingTypeCodes.pallet_mix': 'Paletový (mix SKU) - příjem zboží po celých paletách',

    'utils.receivingPackingTypeCodes.non_returnable_pallet': 'Nevratná paleta',
    'utils.receivingPackingTypeCodes.returnable_pallet_wood': 'Vratná paleta – dřevo',
    'utils.receivingPackingTypeCodes.returnable_pallet_not_wood': 'Vratná paleta - jiný materiál',

    'utils.receivingPalletCodes.pallet_100x120_ippc': 'Paleta 100x120 - IPPC',
    'utils.receivingPalletCodes.pallet_100x120_standard': 'Paleta 100x120 - standard',
    'utils.receivingPalletCodes.pallet_80x120_eur_a': 'Paleta 80x120 - EUR - třída A, - IPPC',
    'utils.receivingPalletCodes.pallet_80x120_eur_b': 'Paleta 80x120 - EUR - třída B',
    'utils.receivingPalletCodes.pallet_80x120_standard': 'Paleta 80x120  - standard',
    'utils.receivingPalletCodes.pallet_60x80_ippc': 'Paleta 60x80 - IPPC',
    'utils.receivingPalletCodes.pallet_60x80_standard': 'Paletea 60x80 standard',
    'utils.receivingPalletCodes.unspecified': 'Nespecifikováno',

    'utils.receivingStatusCode.awaiting': 'Očekává se',
    'utils.receivingStatusCode.unloaded': 'Vyloženo',
    'utils.receivingStatusCode.received': 'Zpracovává se',
    'utils.receivingStatusCode.confirmed': 'Potvrzen',
    'utils.receivingStatusCode.canceled': 'Zrušen',

    'utils.claimStatusCodes.received': 'Vytvořena',
    'utils.claimStatusCodes.informationAdded': 'Informace doplněny',
    'utils.claimStatusCodes.inProcess': 'Zpracovává se',
    'utils.claimStatusCodes.inProcessAt': 'Zpracovává se v',
    'utils.claimStatusCodes.rejected': 'Zamítnuta',
    'utils.claimStatusCodes.rejectedAt': 'Datum zamítnutí',
    'utils.claimStatusCodes.storno': 'Zrušena',
    'utils.claimStatusCodes.stornoAt': 'Datum zrušení',
    'utils.claimStatusCodes.notFound': 'Nenalezena',
    'utils.claimStatusCodes.accepted': 'Akceptována - uzavřena',
    'utils.claimStatusCodes.partiallyAccepted': 'Částečně akceptována',
    'utils.claimStatusCodes.acceptedWaitingForCompensationFromShipper': 'Akceptována - očekáváme kompenzaci',
    'utils.claimStatusCodes.acceptedWaitingForCompensationFromShipperAt': 'Akceptována - očekáváme kompenzaci v',
    'utils.claimStatusCodes.moreInfoNeeded': 'Nedostačující informace',
    'utils.claimStatusCodes.moreInfoNeededAt': 'Nedostačující informace v',
    'utils.claimStatusCodes.acceptedPendingClientCompensation': 'Akceptována - čeká na kompenzaci klientovi',
    'utils.claimStatusCodes.acceptedPendingClientCompensationAt': 'Akceptována - čeká na kompenzaci klientovi v',

    'utils.claimReasonCodes.lost': 'Ztracena',
    'utils.claimReasonCodes.damaged': 'Poškozena',
    'utils.claimReasonCodes.deliveryTimeExceeded': 'Zásilka bez pohybu',
    'utils.claimReasonCodes.trackingLabelsSwapped': 'Záměna trasovacího štítku',
    'utils.claimReasonCodes.duplicatedLabels': 'Duplicitní objednávky',
    'utils.claimReasonCodes.missingItems': 'Chybějící položky',
    'utils.claimReasonCodes.exceedingItems': 'Nadbývající položky',
    'utils.claimReasonCodes.swappedItems': 'Zaměněné položky',
    'utils.claimReasonCodes.others': 'Ostatní',

    'utils.retunReasonCodes.exchange': 'Výměna zboží',
    'utils.retunReasonCodes.changemind': 'Změnil jsem názor',
    'utils.retunReasonCodes.undeliverable': 'Nedoručitelná zásilka',
    'utils.retunReasonCodes.damaged': 'Poškozeno při přepravě',
    'utils.retunReasonCodes.unknown': 'Neznámý',
    'utils.retunReasonCodes.nofit': 'Vypadá odlišně/Velikost nesedí',
    'utils.retunReasonCodes.nolike': 'Není podle mých představ',
    'utils.retunReasonCodes.late': 'Pozdní doručení',

    'utils.productTypeCodes.semiProduct': 'Polotovar',
    'utils.productTypeCodes.finalProduct': 'Finální produkt',
    'utils.productTypeCodes.packagingMaterial': 'Obalový materiál',
    'utils.productTypeCodes.promoMaterial': 'Promo materiál',
    'utils.productTypeCodes.pallet': 'Paleta',
    'utils.productTypeCodes.pack': 'Sada produktů',
    'utils.productTypeCodes.virtual': 'Virtuální produkt',
    'utils.productTypeCodes.serviceProduct': 'Služba',

    'utils.productCompletionSheetStatusCodes.created': 'Vytvořeno',
    'utils.productCompletionSheetStatusCodes.inProcess': 'Zpracovává se',
    'utils.productCompletionSheetStatusCodes.completed': 'Dokončeno',
    'utils.productCompletionSheetStatusCodes.canceled': 'Zrušeno',

    'utils.stockTakingStatusCodes.created': 'Vytvořeno',
    'utils.stockTakingStatusCodes.inProcess': 'Zpracovává se',
    'utils.stockTakingStatusCodes.completed': 'Dokončeno',
    'utils.stockTakingStatusCodes.canceled': 'Zrušeno',

    'utils.stockTakingTypeCodes.complete': 'Kompletní',
    'utils.stockTakingTypeCodes.byProducts': 'Vybrané produkty',

    'utils.boolCodes.yes': 'Ano',
    'utils.boolCodes.no': 'Ne',

    'utils.scanImeiSnCodes.no': 'Ne',
    'utils.scanImeiSnCodes.snExpedition': 'SN – pouze při expedici',
    'utils.scanImeiSnCodes.imeiExpedition': 'IMEI – pouze při expedici',
    'utils.scanImeiSnCodes.snInbound': 'SN – pouze při naskladnění',
    'utils.scanImeiSnCodes.imeiInbound': 'IMEI – pouze při naskladnění',
    'utils.scanImeiSnCodes.snBoth': 'SN – při expedici i naskladnění',
    'utils.scanImeiSnCodes.imeiBoth': 'IMEI – při expedici i naskladnění',

    'utils.paidMappingCodes.noMapping': 'Nemapovat',
    'utils.paidMappingCodes.yes': 'Ano',
    'utils.paidMappingCodes.no': 'Ne',

    'utils.activeNumberCodes.yes': 'Ano',
    'utils.activeNumberCodes.no': 'Ne',
    'utils.configItemTypeCodes.string': 'Text',
    'utils.configItemTypeCodes.number': 'Číslo',
    'utils.configItemTypeCodes.boolean': 'Ano / Ne',
    'utils.configItemTypeCodes.multiline': 'Víceřádkový text',
    'utils.activeNumberCodes.deleted': 'Smazán',

    'utils.documentTypesCodes.invoice': 'Faktura (A4 tisk)',
    'utils.documentTypesCodes.deliveryNote': 'Dodací list (netiskne se)',
    'utils.documentTypesCodes.certificate': 'Certifikát (netiskne se)',
    'utils.documentTypesCodes.other': 'Ostatní (netiskne se)',
    'utils.documentTypesCodes.customDeclaration': 'Celní prohlášení (netiskne se)',
    'utils.documentTypesCodes.shippingAddonLabel': 'Přepravní štítek (A6 - Zebra tiskárna)',

    'utils.activeCodes.nonActive': 'Neaktivní',
    'utils.activeCodes.active': 'Aktivní',

    'utils.expeditionMethodCodes.FIFO': 'FIFO',
    'utils.expeditionMethodCodes.FEFO': 'FEFO',

    'utils.handlingUnitsCodes.box_loose': 'Volné krabice',
    'utils.handlingUnitsCodes.box_on_pallete': 'Krabice na paletě',
    'utils.handlingUnitsCodes.product_loose': 'Volně ložený produkt',
    'utils.handlingUnitsCodes.container': 'Kontejner',

    'utils.driverCompanyCodes.PPL': 'PPL',
    'utils.driverCompanyCodes.DPD': 'DPD',
    'utils.driverCompanyCodes.GLS': 'GLS',
    'utils.driverCompanyCodes.zasilkovna': 'Zásilkovna',
    'utils.driverCompanyCodes.CP': 'ČP',
    'utils.driverCompanyCodes.UPS': 'UPS',
    'utils.driverCompanyCodes.TNT': 'TNT',
    'utils.driverCompanyCodes.DHL': 'DHL',
    'utils.driverCompanyCodes.ALZA': 'ALZA',
    'utils.driverCompanyCodes.WEDO': 'WEDO',
    'utils.driverCompanyCodes.other': 'Ostatní - není v seznamu',

    'utils.receivingPriorityCodes.0': 'Normální',
    'utils.receivingPriorityCodes.1': 'Vysoká',
    'utils.receivingPriorityCodes.2': 'Urgentní',

    'utils.lineState.e': 'Povoleno',
    'utils.lineState.d': 'Zakázáno',

    'utils.applicationMessageCodes.info': 'Informace',
    'utils.applicationMessageCodes.warning': 'Varování',
    'utils.applicationMessageCodes.error': 'Chyba',

    'utils.applicationMessageNotificationTypesCodes.banner': 'Banner',
    'utils.applicationMessageNotificationTypesCodes.popup': 'Pop up',
    'utils.applicationMessageNotificationTypesCodes.both': 'Banner i pop up',

    'utils.orderClaimReturnType.claim': 'Reklamace',
    'utils.orderClaimReturnType.return': 'Vratka',

    'utils.orderProductFileType.other': 'Ostatní',
    'utils.orderProductFileType.engravingTemplate': 'Rytina Šablona',

    'utils.orderProductCustomizationType.stamping': 'Lisování',
    'utils.orderProductCustomizationType.engraving': 'Gravírování',
    'utils.orderProductCustomizationType.grinding': 'Mletí',

    'utils.productInsetTypeCodes.everyOrder': 'Každá objednávka',
    'utils.productInsetTypeCodes.specificProduct': 'Specifické produkty',

    'utils.insertByOrderTypeCodes.all': 'B2B i B2C objednávky',
    'utils.insertByOrderTypeCodes.b2c': 'Pouze B2C objednávky',
    'utils.insertByOrderTypeCodes.b2b': 'Pouze B2B objednávky',
    'utils.orderPriorityCodes.normal': 'Normální',
    'utils.orderPriorityCodes.high': 'Vysoká',
    'utils.orderPriorityCodes.urgent': 'Naléhavé',

    'utils.transportStatusCodes.created': 'Vytvořeno',
    'utils.transportStatusCodes.shippingCreated': 'Doprava objednána',
    'utils.transportStatusCodes.onTheWay': 'Na cestě',
    'utils.transportStatusCodes.atPickupPoint': 'Na výdejním místě',
    'utils.transportStatusCodes.delivered': 'Doručeno',
    'utils.transportStatusCodes.returningBack': 'Vrací se',
    'utils.transportStatusCodes.returnedBack': 'Vráceno',
    'utils.transportStatusCodes.canceled': 'Zrušeno',
    'utils.transportStatusCodes.incorrect': 'Chyba',
    'utils.transportStatusCodes.lost': 'Ztraceno',

    'utils.transportTypeCodes.expedition': 'Expedice',
    'utils.transportTypeCodes.return': 'Vratka',
    'utils.transportTypeCodes.order': 'Objednávka',

    'utils.productRelationCodes.insertToOrder': 'Vložit 1 ks do objednávky',
    'utils.productRelationCodes.insertToOrderMultiple': 'Vložit kusy dle počtu kusů produktu',

    'utils.orderProductCustomsTypeCodes.gift': 'Dárek',
    'utils.orderProductCustomsTypeCodes.documents': 'Dokumenty',
    'utils.orderProductCustomsTypeCodes.saleOfGoods': 'Prodej zboží',
    'utils.orderProductCustomsTypeCodes.commercialSample': 'Komerční vzorek',
    'utils.orderProductCustomsTypeCodes.returnedGoods': 'Vrácené zboží',
    'utils.orderProductCustomsTypeCodes.productSet': 'Sada produktů',

    'utils.sourceSysCodes.myskladon': 'MySkladon',
    'utils.sourceSysCodes.wmsSkladon': 'WMS Skladon',
    'utils.sourceSysCodes.retino': 'Retino',

    'utils.transportPaidByCodes.skladon': 'Skladon',
    'utils.transportPaidByCodes.provider': 'E-shop',
    'utils.transportPaidByCodes.customer': 'Zákazník',

    'utils.orderCancelReasonCodes.skladon': 'Důvod na straně Skladonu (zrušení nefakturujeme)',
    'utils.orderCancelReasonCodes.provider': 'Důvod na straně klienta (zrušení fakturujeme)',

    'utils.incotermsCodes.FOB': 'FOB - Vyplaceně na palubu',
    'utils.incotermsCodes.CPT': 'CPT - Přeprava placena do',
    'utils.incotermsCodes.CIP': 'CIP - Přeprava a pojištění placeny do',
    'utils.incotermsCodes.DPU': 'DPU - Dodáno a vyloženo v místě',
    'utils.incotermsCodes.DAP': 'DAP - Dodáno v místě',
    'utils.incotermsCodes.DDP': 'DDP - Dodáno, clo uhrazeno',

    'file.close': 'Zavřít',
    'file.download': 'Stáhnout',
    'file.display': 'Zobrazit',
    'file.delete': 'Odstranit',
    'file.description': 'Popis',
    'file.colFile': 'Soubor',
    'file.colDescription': 'Popis',
    'file.colType': 'Typ souboru',
    'file.colActions': 'Akce',
    'file.uploadedAt': 'Nahráno dne',
    'file.creatorRole.skladon_employee': 'Skladon',
    'file.creatorRole.client': 'Klient',
    'file.filterBy.creatorRole': 'Nahrál',
    'file.filterBy.creatorRoleAll': 'Kdokoliv',
    'file.type.instruction': 'Instrukce',
    'file.type.label': 'Štítek',
    'file.type.other': 'Ostatní',
    'productDetail.attachmentsTitle': 'Přílohy produktu (instrukce / štítek / ostatní)',
    'textField.error': 'Chybná hodnota',
    'textField.requiredError': 'Požadovaná hodnota',
    'fileUpload.downloadFiles': 'Nahrát soubory',
    'fileUpload.dowloadImage': 'Nahrát fotku',

    // Provider files
    'providerFiles.title': 'Soubory providera',
    'providerFiles.upload': 'Nahrát soubor',
    'providerFiles.type': 'Typ souboru',
    'providerFiles.fileName': 'Název souboru',
    'providerFiles.uploadedAt': 'Nahráno',
    'providerFiles.actions': 'Akce',
    'providerFiles.download': 'Stáhnout',
    'providerFiles.delete': 'Odstranit',
    'providerFiles.confirmDelete': 'Opravdu chcete odstranit tento soubor?',
    'providerFiles.uploadSuccess': 'Soubor byl úspěšně nahrán',
    'providerFiles.deleteSuccess': 'Soubor byl úspěšně odstraněn',
    'providerFiles.uploadError': 'Chyba při nahrávání souboru',
    'providerFiles.deleteError': 'Chyba při odstraňování souboru',

    // Provider file types
    'utils.providerFileTypeCodes.providerContract': 'Smlouva providera',
    'utils.providerFileTypeCodes.other': 'Ostatní',

    // Provider history - file operations
    'providerDetail.history.FILES_ADDED': 'Přidány soubory',
    'providerDetail.history.FILES_DELETED': 'Odstraněny soubory',
    'providerDetail.history.FILES_UPDATED': 'Upraveny soubory',
    'providerDetail.history.FILES.new': 'Přidán soubor',
    'providerDetail.history.FILES.edit': 'Upraven soubor',
    'providerDetail.history.FILES.delete': 'Odstraněn soubor',
    'providerDetail.history.SERVICE_CODES.new': 'Přidána služba dopravce',
    'providerDetail.history.SERVICE_CODES.edit': 'Upravena služba dopravce',
    'providerDetail.history.SERVICE_CODES.delete': 'Odebrána služba dopravce',
    'providerDetail.serviceCodeLabel': 'Název služby',
    'providerDetail.files': 'Soubory',
    'providerDetail.fileName': 'Název souboru',
    'providerDetail.fileType': 'Typ souboru',
    'providerDetail.fileExtension': 'Přípona',

    'confirmProviderChange.title': 'Pozor, hrozí ztráta dat',
    'confirmProviderChange.text1':
        'Pracujete na více e-shopech současně v jednom prohlížeči.',
    'confirmProviderChange.text2':
        'Na kterém e-shopu chcete pokračovat?',

    'dialog.close': 'Zavřít',
    'dialog.locationBack': 'Zpět',
    'dialog.reminders': 'Připomínky',
    'dialog.addReminder': 'Přidat připomínku',

    'actionItem.moreActions': 'Více možností',

    'confirmDialog.ok': 'Ok',
    'confirmDialog.cancel': 'Zrušit',

    'messages.uploaded': 'Uloženo',
    'messages.passwordBeenChanged': 'Heslo bylo změněno',
    'messages.BillOfMaterialsActive': 'Kusovník aktivován',
    'messages.BillOfMaterialsDeactive': 'Kusovník deaktivován',
    'messages.branchUnavailable': 'Výdejní místo nepříjmá zásilky',
    'messages.formWarningTitle': 'Chybný, nebo nekompletní formulář',
    'messages.billOfMaterialsActive': 'Kusovník byl aktivován',
    'messages.billOfMaterialsDeactive': 'Kusovník byl deaktivován',
    'messages.formWarningText': 'Formulář má chybné nebo nekompletní hodnoty',
    'messages.formErrorTitle': 'Chyba ve formuláři',

    'emailTemplates.title': 'Šablony e-mailů',
    'emailTemplates.emailTemplateDetail': 'Podrobnosti šablony e-mailu',
    'emailTemplates.createNewEmailTemplate': 'Vytvořit novou šablonu e-mailu',
    'emailTemplates.synchronizeTable': 'Synchronizovat tabulku',
    'emailTemplates.table.id': 'ID',
    'emailTemplates.table.name': 'Název',
    'emailTemplates.table.type': 'Typ',
    'emailTemplates.table.lang': 'Jazyk',
    'emailTemplates.table.actions': 'Akce',

    'emailTemplateDetail.title': 'Detail šablony #{{idEmailTemplate}}',
    'emailTemplateDetail.titleNew': 'Vytvořit novou šablonu',
    'emailTemplateDetail.sendTestEmail': 'Odeslat zkušební e-mail',
    'emailTemplateDetail.email': 'E-mail',
    'emailTemplateDetail.template': 'Template',
    'emailTemplateDetail.version': 'Verze',
    'emailTemplateDetail.templateEditor': 'Template ediotr',
    'emailTemplateDetail.selectedVersion': 'Vybrana verze',
    'emailTemplateDetail.name': 'Název',
    'emailTemplateDetail.lang': 'Jazyk',
    'emailTemplateDetail.type': 'Typ',
    'emailTemplateDetail.testExample': 'Struktura testovacího příkladu',
    'emailTemplateDetail.subject': 'Předmět',
    'emailTemplateDetail.test_data': 'Testovací data',
    'emailTemplateDetail.deleteEmailTemplate': 'Odstranit šablonu',
    'emailTemplateDetail.duplicateEmailTemplate': 'Duplikovat šablonu',
    'emailTemplateDetail.testEmailTemplateVersion': 'Otestovat verzi',
    'emailTemplateDetail.createEmailTemplateVersion': 'Vytvořit verzi',
    'emailTemplateDetail.saveEmailTemplateVersion': 'Uložit verzi',
    'emailTemplateDetail.activateEmailTemplateVersion': 'Aktivovat verzi',
    'emailTemplateDetail.deleteEmailTemplateVersion': 'Smazat verzi',
    'emailTemplateDetail.createEmailTemplate': 'Vytvořit šablonu',
    'emailTemplateDetail.editEmailTemplate': 'Uložit šablonu',
    'emailTemplateDetail.confirmSaveVersionTitle': 'Neuložené změny šablony budou ztraceny',
    'emailTemplateDetail.confirmSaveVersionContent': 'Chcete pokračovat ?',
    'emailTemplateDetail.confirmSaveTemplateTitle': 'Neuložené změny verze budou ztraceny',
    'emailTemplateDetail.confirmSaveTemplateContent': 'Chcete pokračovat ?',
    'emailTemplateDetail.message.emailTemplateCreated': 'Šablona vytvořena',
    'emailTemplateDetail.message.emailTemplateUpdate': 'Šablona aktualizována',
    'emailTemplateDetail.message.emailTemplateDeleted': 'Šablona odstraněna',
    'emailTemplateDetail.message.emailTemplateVersionCreated': 'Verze šablony vytvořena',
    'emailTemplateDetail.message.emailTemplateVersionUpdate': 'Verze šablony aktualizována',
    'emailTemplateDetail.message.emailTemplateVersionDeleted': 'Verze šablony smazána',
    'emailTemplateDetail.message.emailTemplateVersionActivated': 'Verze šablony aktivována',
    'emailTemplateDetail.message.emailTemplateSendTestEmail': 'Odeslání zkušebního e-mailu',

    'massEditProductDialog.ok': 'Uložit',

    'utils.batteryTypeCodes.no': 'Ne',
    'utils.batteryTypeCodes.device': 'Ano, v zařízení (PI967)',
    'utils.batteryTypeCodes.device_lr41': 'Ano, 1.5V LR41 Knoflíková baterie v zařízení',
    'utils.batteryTypeCodes.package': 'Ano, součást balení (PI966)',

    issueReport: 'Report problému',
    'admin.carriers': 'Dopravci',
    'carriers.title': 'Dopravci',
    'carriers.table.id': 'ID',
    'carriers.table.shipper': 'Dopravce',
    'carriers.table.cot': 'Cut-off time (COT)',
    'carriers.table.createdAt': 'Vytvořeno',
    'carriers.table.updatedAt': 'Upraveno',

    'carriers.action.createNew': 'Vytvořit dopravce',
    'carriers.action.exportFile': 'Exportovat soubor',
    'carriers.action.exportFileName': 'carriers',
    'carriers.action.synchronizeTable': 'Obnovit tabulku',
    'carriers.action.carrierDetail': 'Detail dopravce',

    'carrierDetail.title': 'Dopravce #{{idCarrier}}',
    'carrierDetail.titleNew': 'Nový dopravce',
    'carrierDetail.shipper': 'Dopravce',
    'carrierDetail.cot': 'Cut-off čas',
    'carrierDetail.create': 'Vytvořit',
    'carrierDetail.save': 'Uložit',
    'carrierDetail.delete': 'Smazat',
    'carrierDetail.deleteConfirm': 'Opravdu chcete smazat tohoto dopravce?',
    'carrierDetail.message.carrierCreated': 'Dopravce byl vytvořen',
    'carrierDetail.message.carrierUpdated': 'Dopravce byl upraven',
    'carrierDetail.message.carrierDeleted': 'Dopravce byl smazán',

    'countries.at': 'Rakousko',
    'countries.be': 'Belgie',
    'countries.bg': 'Bulharsko',
    'countries.cz': 'Česká republika',
    'countries.de': 'Německo',
    'countries.dk': 'Dánsko',
    'countries.es': 'Španělsko',
    'countries.fi': 'Finsko',
    'countries.fr': 'Francie',
    'countries.gr': 'Řecko',
    'countries.hr': 'Chorvatsko',
    'countries.hu': 'Maďarsko',
    'countries.it': 'Itálie',
    'countries.lu': 'Lucembursko',
    'countries.nl': 'Nizozemí',
    'countries.pl': 'Polsko',
    'countries.pt': 'Portugalsko',
    'countries.ro': 'Rumunsko',
    'countries.si': 'Slovinsko',
    'countries.sk': 'Slovensko',

    'admin.egonRoutes': 'EGON služby',
    'egonRoutes.title': 'EGON služby',
    'egonRoutes.table.id': 'ID',
    'egonRoutes.table.shipper': 'Dopravce',
    'egonRoutes.table.service': 'Služba',
    'egonRoutes.table.country': 'Země',
    'egonRoutes.table.egonDelivery': 'EGON doprava',
    'egonRoutes.table.transferType': 'Typ přepravy',
    'egonRoutes.table.enabled': 'Aktivní',
    'egonRoutes.table.note': 'Poznámka',
    'egonRoutes.table.updatedAt': 'Upraveno',
    'egonRoutes.table.updatedBy': 'Upravil',
    'egonRoutes.action.createNew': 'Vytvořit EGON službu',
    'egonRoutes.action.exportFile': 'Exportovat soubor',
    'egonRoutes.action.exportFileName': 'egon-routes',
    'egonRoutes.action.synchronizeTable': 'Obnovit tabulku',
    'egonRoutes.action.detail': 'Detail EGON služby',
    'egonRouteDetail.title': 'EGON služba #{{idEgonRoute}}',
    'egonRouteDetail.titleNew': 'Nová EGON služba',
    'egonRouteDetail.shipper': 'Dopravce',
    'egonRouteDetail.service': 'Služba dopravce',
    'egonRouteDetail.countries': 'Země',
    'egonRouteDetail.country': 'Země',
    'egonRouteDetail.delivery': 'EGON doprava',
    'egonRouteDetail.deliveryId': 'ID EGON dopravy',
    'egonRouteDetail.deliveriesFailed': 'Seznam EGON dopravců se nepodařilo načíst. Zadejte ID EGON dopravy ručně.',
    'egonRouteDetail.transferType': 'Typ přepravy',
    'egonRouteDetail.enabled': 'Aktivní',
    'egonRouteDetail.note': 'Poznámka',
    'egonRouteDetail.create': 'Vytvořit',
    'egonRouteDetail.save': 'Uložit',
    'egonRouteDetail.delete': 'Smazat',
    'egonRouteDetail.deleteConfirm': 'Opravdu chcete smazat tuto EGON službu?',
    'egonRouteDetail.message.created': 'EGON služby byly vytvořeny',
    'egonRouteDetail.message.updated': 'EGON služba byla upravena',
    'egonRouteDetail.message.deleted': 'EGON služba byla smazána',
    'egonRouteDetail.message.conflictTitle': 'EGON služba již existuje',
    'egonRouteDetail.message.conflict': 'Pro zadanou službu a zemi již EGON služba existuje.',
    'egonRouteDetail.message.conflictCountries': 'Pro zadanou službu již EGON služba existuje pro země: {{countries}}',
    'orders.table.shippingBackend': 'Doprava přes',
    'orders.shippingBackend.egon': 'EGON',
    'orders.shippingBackend.skladon': 'Skladon',
    'orderDetail.egonBadge': 'Přes EGON',
    'orderDetail.egonBadgeOrderId': 'EGON objednávka: {{id}}',
    'orderDetail.egonBadgeStatus': 'Stav: {{status}}',
    'orderDetail.egonBadgeStatusAt': 'Čas stavu: {{date}}',
};

export default langObj;